import React from 'react';
import { IMapLessonItemStates } from 'types';
import Checkmarks from 'components/common/maps/checkmarks';

const MultiPurpose: React.FC<IMapLessonItemStates> = ({
  active,
  visited,
  process,
}: IMapLessonItemStates) => {
  return (
    <g
      className={
        active
          ? 'prefix__component-item animationComponent'
          : 'prefix__component-item'
      }
    >
      {active && (
        <g
          className={
            active
              ? 'prefix__active-process animation'
              : 'prefix__active-process'
          }
        >
          <image
            width={256}
            height={259}
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEDCAYAAADa5trIAAAACXBIWXMAAAsSAAALEgHS3X78AAAgAElEQVR4Xuy9y5IcRdY1utZ294jIS1WJVkObZAw4ZozEkBfQS+h5QM+jV2CgF9BQGmF2sHNkyPhANIK6ZEa47/UP3COrSkh09/dLQrRimaVFZmRWVWZW7OXL95WSsGDBgg8T9q9esGDBgv9eLASwYMEHjIUAFiz4gLEQwIIFHzAWAliw4APGQgALFnzAWAhgwYIPGAsBLFjwAWMhgAULPmAsBLBgwQeMhQAWLPiAsRDAggUfMBYCWLDgA8ZCAAsWfMBYCGDBgg8YCwEsWPABYyGABQs+YCwEsGDBB4yFABYs+IAR/9UL/iogyZfPaWl4uGDBH4J/XRv5vcH/K5ALKSxYcBV/MQJ42ejre79///5ryeCrr75qH/Dll/ylPviCBW8FfxECuG749+9/za++uv6KBw8e/44E7t374hUf7itdJYNFFSz4kPF+EwBJXHt7X18x8kuDf/jwi8P9u3fnc/PjOwIeAAAePHiZFL4+3F+IYMGHiPeYAK6u+tXwHzx4zHv3qsHfvQs8evQ9vwSAL7/EkyfPfqcA7ty5JeARHj0CvvzydvugMyE0IrgP4Kuvr3wJ7+0XsmDBG8d7SgCz8QvAvL9/zNnwge/55Mltdt1zAkCMN1/rA/jss+f69lvg889v6skT4M6d7wXc1sOHwN27j3Uggmtbg/fyS1mw4I3jPSSA68ZfV/17AJ7wquHHeJMxvmAIJwQAs9NXkoD7VgBQygvlfKLP8nNhvCk0IrimCBY1sOADw3tGAL83/o8//oJHR99ztbo0/M/iC/7wczC7tSV5TvvlgvjbTZAX10hAWgk/A37jXNJa7qf6xz9uO777VcjP9WS8qYuL71W3B1fVwEICCz4MvIeZgK82/jt3nnMYon3Ww37sT0Ja70OMF+H83OL5EOPFxT7FaHG3y2m3yylGq+cGxHRuMZ39ElPaBvz4a/hhdRowRFuvYScnvQHfE/iCl47Fq87G/zzfYMGCvwreIwKYDe33xr9ew4BoKQX7KZ2HGC9C+HgTYrTYdYxdt0pdl9N+zy6lPqXUp/2eXdf1adeNadfnFPobMUbEXxJiStvwY38SPuthwxAN3/b25MljqyRwhzWk+DXnPIOFBBb8t+I9IoAa3weAe/dqOG82/r6H/fjjSUhpG2Jch3huMQTGutL3KcYuxWxdnNjl7H3O3seJXYzoYmQXY5/2aUy73Zh2u32KETGd/RJ/Sufh0xSsqoEvDE9gjx59Yx9/PKuB+5zfUyWBhQgW/HfhPfEBzIb1dTO8L1hleW9AtB9/PAkhwELYBTsfgoUx0LqwsynYmMI45UDCyEIwXBqpitTJJXjXheLncC9T8T6WVdkXn1Ip26GUAs8Zvt/DP/sMDswOwtdFCea3DeD9+AIXLPhf4f0hgPtfE18BDx/C7h59z29PehuGaJ+mYD+nbQhhFy4uGI9CH/YjooVdpMUwZUSzEkgaJhgZiASM0wgoKCW4RyudSnEPRZ6Ld579t1iGXtlzX8rmovzP/8iPj9fl1i04cJUEXsobALCQwYL/FrwHBPCK1f8JDGvYD6vT8I9g9uLc4kXHGPeMlhhDYJxySRYQaYxkCMweSFguMEQAGVCAS/AYrUilKConR3ZX9qJcsvLQrfOLvC/TdFG22678/e/rAsDx7ctRgkoEL2cT3r8PfHU1dLgQwYK/EP5UAiDJ+ue/Pjj+7t6t0v/Zs5vhVoT9coZ40f8WYzyKYZpSjiVZjikET7l46i1FGmIuOZKwDBqLMwRThikEFslLDMiSsjuyF5tSzJPnMJWCXDrlUvZltTrKN/J5QXHHVPy7fKKcn2scb+rOIW8AeB0ZXAsfLkSw4C+AP5UAXr33hwEw/HAa/nkW4nlvMSXGOOUUYpemgi4EdsWnziwkmiV3JToi6QGAFYpBFGCSeRGsyJGDlcndphA0egmTlzyVHKYUx6l0ykPeZJ925WQ7FBT4D89ONf2t+CGB6KVswvreX0UGSx7Bgr8G/sQowKXxP3jwmHj4BYFbBP7GZ89gPwUzi7STANtaFyxYnHJJIXgyR2cKvYuDslYmX5lpJXEtcG3iWsBGwFpFGwnrEHzlCKsQMLhzCLH0IbILCV0u1oWpS/s0ptAx/hoRfzlDTOtt6PuTsFqdhmebm+Hp0xehhiR7A2BPnsCAbwz4gpeRg/qZrkUPXtGsZMGC9wF/kgKoBnFZ1nuHjx59YyfN8df3JyHGi7Db5XQcj+KYL7oQ2eWS+qDSWwj93stgst4MnQsdWVVAoQJhBACDvAguIZv55MRo5N4doxn3XjCGotGDxpjD5DFOfUI+9bGsSldU4J7hfgx3v8wmdN/qdanFv68xWNTAgvcXfwIBvFzoU6X/kyew9Rq2Wp3WeP85oiXEMZ93IVmXS+xD9N6dg4mDC4NQBpr1knqybQWkYEY6AAO8CG7GyeSTiJHkXs690/fmjQQ627vnKYZ+9ILsHbL7WNzh7vJS4NutXP/cyY9vXCODf0zFkU+EmQguvhdem1r8zr/sBQv+EO+YAF5t/HPM/9mzmyH9eh7iP9Zht9unOJUUk9XV31mluzA4tDLjIGjlwmCy3s07OhOp4PPWximZSiSnIp9I7isB+J4MOxXfF3Jv5vtQNEZL486VPSJ3nbJ7Ku7nLslXLpdv/Vffa7uV//OfOx0f3/C/FfgPjQi+yyf67LV5BAsJLHj/8A4J4PXG/+23Tfr/ug/x1lGI5xZ3U06h61Lx0oeYetc0hJAGg1ZTLmsLtpIaEQiDpB5iCoEhF4S6CYADxUlORZxI7eXck9oR2Dm1M4adWdm7Ywwljh7KJFdOEXnOG5Dkcrk7XIPcXe6+9c2VLcKcTHTrFvzbb5/r88/3vpDAgvcd74gAXjL+B4/58OMvePfoe+LL2wRgP/xQpf/5+YuYUogx9ilmdtlLH5yDRw4mrQRUR59ppcK1oBUNg2S95B2JCMCqCJAIFghZ1EhwL2nvwI7UTl6PTu6NtjfX6OZTDJzckeWlSFZSDGW3g3fpChn0sfhv8NXQlRcFvtlclFLkpbhPU/FPd9nxOxJoCURLiHDBe4K33xb80NarGv/VQh98eZv4DobPYCGYnZ7uQtcN4SgwjCPi5CWFGJMRCe6dw3uBPYBe4CDDQNggYSWop7GjEB0KLbwhh1xAJpAARBqCESanWZC508zMzN0UEOQhupfoQo6xy1IpxVliyqWI7iWWrsvFJhbvUtmn0ZJ1JZ4buemL/fKcOOrxFMCn3wL4/HsHvgDwGLX9EITF9Be8J3gHCoB8lfF/+eVtfvcd7LMercJvHS4uEI8jooUpnZ6XPkT1IYbeR608hlVQXf0FbQxYF2hDYQVwRfggogMYIQS0dRaAQ8gkRjUFQGoH48WsANq2YG/kXuIk88kdOUh5kpVgyJIVeSlRoXhQlpeSUp/Py1S6Dnkoyl664tOulPGsTEd9mabiu132zz/f+8OHt/Xjj49VcwWWrcCC9wNvWQFclvgCwL179/Do0TcH4+972E+/nofYjyHcDCHuc7R+E8dckgVPFmIqhZ0ZOnPvHewFHwzsBQ0EBgArASvQehCdhEQo1L/tIFkAZAFRUKQhEDS5DEAAECwwkApyRQGTiqZATgrMIbMEIE/IJSRkd+QQmOUx55JDLMw5w/YpsSfaWwLw2xlw1OPTT08EgEdH3+Pu3XsCnqDy0pIasODPx1smgKux/scEwNXq0vhjhIVPaOF8FS4uGGNiHKecLMRk8FQKO8F7SL3A3gJ6FusFDSAGkr2AnkBPaRDQUUyCItpmm2BxqBgxNmVgqg6CICFADKBHB5MJo6jRgk0SMgoyoCwoBzBLyELOrvq8y6aYylSKWeaOyIF9SgAGvACwDi48g77bA6vVba9tza5sBVov4td8dQsWvHW8xS3Aa0p8v+0NQ7QfW7JPCKtghrjfTymEkkJml0vsXdPg4hCglSysDFjLtQGwEbgxq1sBAGsJKwIDmwIAEEAYHADhJDLASdIkas8rkQCRewl7gnsRo6TJjJNUaweMdrgvlRyMk5tN8jKZxTEYxv2uTCFojEFjyWEqKU05/5ZX+5KnzY388f5FQXMKPnx4W3fvwi/7D761f8CCBf8Sb5cAWokvcId49I29XOIbz1/EixTiUdjGX/OuW4eYintvHnoPGDxrpaCVAWuIa7k2ZlgL2ADaELYWtAa4Enwg2IFIkqI1AnJIAAuBScBEYA9hBLEjsBdVcwOE0ahR4lSEbJxJoGYRSsjmzT/AMJpjlM2ZhdNoZnsvGkvQGOMw5jxO06S83nv+aFMy/rGtVYaAX0YFFl/Agj8Xb2kL0Fb/K9L/yeo21xH8NIA/hXM7bx7/OJY4ximFElMGuyB0Rd4HsYd5L3EQMBgwwDDv+wcHBkADgIFUD7Enmg+AFiQYCFAQyEIhgApwBJqCQHMhEozuSCRGd0wSJiMnuTJQiQCODHJS0CjZhKIkMpo8eDGzFOilwIJBFjRNWTFS0ijbRsdk9uwZdOvW3+qO5SHw4MfHuHfva1xPFV6w4N3iLREA0Dz/AO4Bj75hd9Lzsxj5YzyxGGgffUSzXQ77rgvMjIElmasrqnt9lw+SNeOvWX8ChgKsaBjoHGjs3b0HmvGTHaQkVzSSclGE4HJQ2R2RZIBoAgKBCEckkeDoREw0TJCyBU5oCkDAZMAkcDRgVGCke8iFgZS5CAsBliFoErIpuPkqdV7OO/9lD8UN9PTp/6tPPz3Ro6Pvce/u1WDg4gtY8OfgjVcDXo7prgk/wBM+Wd1mjDf5w8/BwgvY2dkYeN4Hsy6EiTGXksxiKoGdBXQu62nWM2BgS/mlVY9/Ow409nIfWCMCvYQeQgeiM0MS1IHoCHQkOpA9620AsAK0BrCmYQ1wA8MG4BbAFsTWXUdyHQHYmnErcCvHFuBG0AaBawtaSVopa+UTB5f3xdlZ8DSVknYjo4Ux2N8qP6QU7LvvYKvVbeLhF7UK8lA1uGDBu8cbVwDX1rF79XDnDvD06QvarRPa2S92Em6YhTHsR0aLiDbFVDh1JnaO0JuplzCorfxmGORYkRjgWglcgT6A7KuRWyeoI5UgJRcDAKMBcoCEQygEglyBRCAtUAoCIqBMcAKQa9YgsgFZVIaUHZpIjQBGAQlQVEEQaBacBEW4O4NbLm6woqASjGU3wiff+zD0brb1GF+w6zIfHe25qIAFfzbeuAKomK/je8Cj74lvnzOEE5Ln5EcDabDdPgeGEswQ2SPSQ3Jj51I/AYPEQdLKhEHCCsQgaSVyaCt5j7rq95B3RiYISWIilSoZIJFImFUA0IHoAQyaiQS1h4BLzbGojUEbybcAtzRsCG5w5UaEtYC1GVeStffIweS9BXRF7KzENE6IFnIIIYezs32YVUCMN/nll5dDTe8vKmDBn4S3EAUg59j/w4ewTz65LPPtzkKMvUXr+hQiujHnvjgHl68CfCVwLXEtNmO0sAa0kWNjxFpCDftBK4orUAPQiIDoQEQCUU0BQGL9dBJrVlAhUFwoJDLILFchkQUVwuqRyHAUEJls4cNWTERwJ/pOzgtA5zSeueMcwBnhZww8Y9Z5IS8IuyhT3gcL+z76mId+mibk/f5F+fTTkxYVuIwIVA3wxv8hCxa8Fm98CwBU53+d6fcF8AR4Gl/Q7IQ08Czs7Ziw/ZiDxRg4lciIWBBSEBKoulK79So+GGwANKgl/sC9b/v5TmBHqhOQBCQKUWKEwSCZWNPtCJNqYZAJHkgWAQGuSKIAKBSLoIL6OFeyUJYrg5jMMEoIggwOowl0yF1O0GnKBZY5eUZgJpXL5HlYxVzyFC52Hvrcl7CDfbo5ceA5gT2BOTtw2QAsePd4s1uA2QH4VR3uAQDfds/5KQD+fE7ajlv23BkMhE1TCaQHK4gkolPJhY5iR6ILZCeqp6mXc5D7oJb9J6gn1Kk6/pIBEWAUFSFFANGAQCGiZgZGQAlgApgIdUZ0AlpxkQYSQ/UzYA1o5dCaxIrECq0SEcCatJXElcAVyQHytgVQT0NnQmduqQ+ItW15CpvtxhhgFn+xH+P/GHCTwG0CT65MIlqw4N3izSqAl1awR4++58lJj2fhhOnmObgbSI7kvhhjspxLUAohiIHuEUUJRBLYCejM0FHVyUeiI9iJ6OjoSCZQSY5EIElIIILhMt1XmhVAq8AjnIB7rRVwEIWqyTkkXYBTKKKcYCEtQ62GAKjDR+rnFAEX4QAyjRnSBMNIsgNspDzlrGSJ0zgpljLlHBXGSB+45bNnsLOz53rxYs979xZn4II/B2+WAF7Cl+34DIDZmr9xzxvsSUwcJxhZb4UeghQUGbwgWt3LJwldDe2po9QJ7FDDe0lAByEZq4GCDG2lNxAGwWpLANAhkBQqMXhNDoLLEWZSAOEHMgC9+grUJgwgCDCKFAUSIugGFXdkmk0uTZBGASNUOiKM1jEyI1oowaiwNbMXwSwEWimnHuNNrlbgw4e3efcuhMZSCxa8K7xVAphxC8DPAI4BXHBkpJMghUjWbYgVZwj0ULP4qmQnEEFEiYnGCCgSFuVKYN02yBFFxir1EWTN+AHioAA4m5ZQCUIgnZIwk0Fb1VFXdZfDSRWBgYKRpCDABQFSDTAWQhnCSGIErQO8Ay1RnopbojEa6/CSnY3BjOW332ir1ZYxvuCdOye4cwdoswgBQCS5OAMXvAu8EwIAgL8B+O3waACQWWf5kcg0shgQLVAmVlKAGByIhILE6uFvTT0kBAkRtQuwgbLm7QusyygB8LANqBygAxFIhstz1fgBUXCRDspBGiUTalZh/UUmQoVgJjAB7GoiEkcD9gA7FzoLlhIQ99mTCxOJGEvKFpPduAHmDPs0vMoZ2NyVCwkseAd4ZwQAADgG1ntgHABcACkBPjmBABQjgujuJtBAmDU5L1cgEGQMkgKqkQcBBppBCrPsJ0ChHQW23oBwgNBhKyDpkhSuKoOqCVSLdgSrv4IQhcNzViMFLmUIEw0jgY7wzsUumBIdyaFEMnZdCCXnMJrClsl+Pd+HYXfhP25G+xif1JrFa6XC0kICC94F3mwU4A/wMwD8CpwDwK6dnOoGGwAQAHcnDCBFVmcYAdFAVvN0o2CAak0/a7iPVe6bIBMuHxtBtdcSMiPZSKL+bHUUBuD6jWRAJceI2kgkWVUekUSSo4OjI5gCmSB2EjonO5JJzm4SukJLZoy5IJIxcIxhN07BjHYaaWzOwKoCvuchdRL3m0jBldTqBQvePN4sAbx0qT5qx2ft+CsAnAGVAYomABGmUn9YMJOBqvk7Dp9/kQFVyhtogHRJDrwi9+uaznqOItjOtecOpFG9+ddubUsRAITm/AtgVRokg4gIKQGIZohgjVgU1YiEUUlC5/LOrWYjmivRPRkreVgowSwF2+cQmjPw1q1TPn0abQ4JAnfat3hJAvUzkFjIYMEbxhslgFddnd/Od35+jiP10noSFCQFxQif5AoBbga3IC91Sy6BQt2oy32W645LPUwAVjf0s6kDcxCNJBtpqN0uiUKSkTgQgggjdSADzDdVEoArQogAA4koIQEWKSYSSfJOqqs/aUnyjrJEUyIRiyvt9p7MGKe8ixZSCKEPZ2djwE9mn4YTfvfd/HcbCTx4zEoC85ixFiSYyeDabcGC/x3eKAEc9qv3ATwA6lht4FZ5Ib+xko52kpJUM281jkVRcM2NMlRvZiwmlsO5+XmayyHWwT/VEa/27OV74CUJtJP1zhUSIK89lqydq1sIXZKAhIAaUAwCYotQ1FJithssikyUqvGzKgB3JjdL5p46QwsJMpqVYPscTsKJ/RLX4adfz0Pfww4k8Ogbw70v+PAhDHjMO3cuyeAaIRzocCGFBf87vBUn4H0Ad1B3tJ+PN/V0eIFea0mQdCr1W9f5zoVm/BM8s3gIsUheABUBBWIRVUjVVN2qBRySaHDJvInk5qEjSEpNjDRPGqBLccLZdK6cwywfmmeQBOSweg5AIwNWyRHUMgslJKvVgbUQCVcTlNjRlIqrg9lIlCQoGS2bKQbRd/HMh7Mo9Gvg13PcOl7j6dMX/PSkdwC6e/d7PXr0Ee/du62HD8E6cxAtbHi/vfev6+E+gK++0uHzvEQClRQXh+KC63grxUDVau5zLga6s4b9sDoNXRfifm9dytaVrvS+0yqmuAJ9ExA2oo4AHQE4gnAM8RjAEagjgVsDNiLXkNYgBqiVA6vmBUiKEgMBo81Sn1eMXe0428ZsLzXEP5+s2w0Jos/xftQCocOAEQA7gucAziWdAToF+RvIXwH9RulXiL8h4DcKp4WtSAjlwhh3MeR9mXzsU5x8Ui5TX/L2vPy9uD87DB/9p3I+0udXxpI/etSU1UPgIYCZFPAAwGE8+VV8pcvPe4mFEBYAb5kAqkPrG6vjtG+Gn39GTBf7tO/Z5ex9EgdXXMWItUrZAtyKOgJxZOCRS8cGHgE4cumIxg0cG7K2AuehJoA1FdgQIAQBgTjI+rocsimCVxhDha4SQdPXkoSa8MPaKwDESGAvYQ/DBcBzQGdynJnxN8h/c/A3o3518DcWnRbhNAY7LcA5c7mwjhfRbO8FY8njVDrlIW+yr3elDiOVX04i/lWlbPRpPtF3+A45HwkAxvGmgMe4c+ejS1IAcDmdGHjwALj3O1L4PSEsZPDh4o36AAC0a2u+wB7g0SPg228B4Fju53qhndzhktxjKNFL0eRFjly78XKSc4I0ETa6NAmaSBshTCInofbr88M2AYVEgZrhCoI4r+Rgje+/5r1eedD8B+0ByZqrTIo4OAdpAoNahAC1AjFZixJI7Ch08nlqMbuY0LnUz/0C3L2/2Hk/FXQ5WRemLoU0prAb0m6XU7ebUkqI3VmIt9KNMJyl+OP5/8TV6u9hs7kZPh+iHR+/COv1F/bdd2M4Oent22+fhydPYJ988tiAj+zRo4/s3sGPcIfA42uOxUtfAq5FGpaw44eFN08AV0ztQXMEfv75TT19+v9DWmu7PXF3edfF0imXvZfihhyMk+STEaOZRrF26SUxShxZR3uPkCaQE6QMKIPIAIoDTqAAcBKumQiuiBySlzRAoPkG5hsANpVQJYMOzzclUd0DJijU7MRWKEREsdYuqDUfIdFR7GnsVTCYqXdTX6sGQx+i11uJffHSj9n7MaFLOXShW6W426fdKqdfu3VKK4tp3cXuLMS+R/xpSLHvT8LmNaQA9HZy0htQt2DAN/bo0UeGe18QVwihOhdfTwZY8F+PN08AB3yle/e+0MOHAPC9cj5pkha+KXCdylVCiTFlufIoZDebJJ/oGCWNEkaQe0L7+tgrEdTzI1Fbd2Nu6nElYsCa0y+w7ekPKqBxwO8VwYEEqiSuKkAUGykQkKEmGhnEOU+g1i207kOsswn6WsaMXvKBtF5FKxMHDxwscHDVceeuPISY+uyxDzn38ci6sZR+LKVPKXRhj25frIvDKsVVTulin7rdOl1c7NKrSGG1Og0//NDHzeZmwNMX4fj4Rfjuu9thJoQnVwjh3u8iDdfJ4EAEiyr4r8VbiQJUEMDXuHv3sR49+ognJ8/1jyn6T+HcvJgPQ1/GhJJyzi5kV5mCcxLDKPhIci+ok7MzsnOoMzB5bfEVq/RWJNlGfdFAZVyu6HSAdKg2BhHaYi5ciwD87k2r+QqaN6AlFs0/rFrBKIMRCI5DglBCbTs2EejcMZDIAjKgQgtOyCFhKs7AYIZiBSG6PEiq38OFF3koKYUSCnzyyeMJfbzI8j44QOn0TH9bbRyqrcdxsZe01i++k3vWiffSjef6yVfqtVZKp3K/KTx9oTt3TgT0Ojmpn+6TTx7j0aOPdDXSUKMMX7ev5Cu1NIr2nS2+gv8mvAUn4AwS97/mgzuPee/eF3zypEYDsDoN/+xC3O1yOkl9GrP3Ica+yFc+cR0i17k5BA3cgjqScASzLVxHoLYCN0BtD8baL7An0bvUA0zzqozWG4A4jAObV3LikgNeJgNdOxJetQML0LoHtSEjgEaAOxA7SBcCLww4E3gG6IzAmYNnhJ8BOCfs3OEX5th51M4do7nGkMI4TshDb9M4lhJDKVIos5+kE7yqmyw5HApywaFJ3sOBKJ1OWq02ftrEknun7VYuDZIuJK3kP55LfzvVxx9/4s+eATXScKKcn+vzz28KuBJlwB3V0EJzIt5Hm2RUUVXSW7t4FrwjvF0CuBoNePSN4aS3Z5ubIaXzkJLF/d66mNkVL32UDZ5qX8BQG3VWEiC2pbbnPjJiK2ALaAtwQ3Dt8DXBQcJgRG0YIqSauosoKYA08kpUQNdI4FVqQE0xqHkGHYK75CQzcDlqjMRewN6AC5EXcF3QcCbgHK1XoIBzUucALwRd0LVjtJ0co7z6PCZH7symSaWEgCy3EqOVUXBpdAmeVJ2nUudd+hekcBa1WsFPNWrtW4fv5Y0Qbjj8Jz/XZaRhDjs2MhhvCne+F3Bbc1ThekTh5UjCW7uIFrxlvDUCYMvIwdXZgE9guAMDTsM//xnibrdKKY0pZ++jxz5GDj7ltWKd+xdgG4FbuI4sYOuOIwJbkFt339K4ptBGg2kloEf1vNeOwNZKhi/Teq0ZPqvYP1zFr1ABMwHUyAIBPzgar4cER3eMJHaAdgQvJF3AeE7gXI4LAOeiLghcELwg0UaSc58Pjk9OWchmyJi8mCEjsEwZHoIXCQ7JY7QiwcexSIKn+HtS2O+yuq6d7+WDr/0co9zha5drA9eLXr6FSxfS83OVk5s+hx1v3brtwHMBNf/g4uJ7vUoV3L8PfLWogr803poPoF4IZL1Ivmj7y++Fb3s929xUSue+Xu9K2A02FuScctjtkFcpjqPnGMDoYAQ9gUxyRAhJhtoYhBYp1X4BbFV8koE0tCpAOIkaESBr5x8IrI5PXfELXLlzicPDGhA4OAJJzKnCYhAVm8MxQXRRtb2Y4AJFa6kFYgshIgCKCkgudcE4Sj6VghNKxnsAACAASURBVAma5xIwZ/cSguWA7IAVZLhCKOMkj8FKTKp/Q3KBLmQvsgLBY0cvgivRVeSn2rk7vJd8dLn/Atdw5r5XJYThpluC6+egcnzDgVPi2U09LS+0Xp+o63rhCYQ73wj44rW+Ai2+gr8c3poCAP5ABcy+gNYmfJ/ZxY5ddu+DOHjSSpnrELAWwgYs25YJuHV/aSsgbkStCa4ArKQ6JRg1DJdARdVwXbDazWPuFdAiIK/dClxRARJAYa5boArJWQVMECbhMkGIxh2lnYAdhB2AnWaFQNvJ20BSqk4jpo2U6igyUx1HJlYVYCzKxWFWDCwQXOYFgGuCh2BlkjwGLwJcIzwGKxPkcniModQthBU5PKVQILh3sUjn7mdwFflqiEUbuLtc/9zJj294KfB5i3DrFq6ogse4uPhIX/52W7i7qIK/Mt4qAVRczgl4pS/g3GLoGPfZupjYZccQxMFj9QdA2hhsA3o1etcRwO3LWwEIawIrQSuCvaQeZPXOXzoEA1/jELwM/R1wIADOjUKqN9BZU4ML2uwAVc//iJqnUImA3EvaE9hRbQoxbCdWLx3BvVCTnQCf2KYRo00mAryQIQNezFgkK6UUN2NNflIlBRV4MC8yFuRKCFIpk+r9KCsKXqZJPjsXPVrpVMpuJ+9SLO5TkcuHPpZTryRQCrwU+dFRzUz8e3GHb/X0ZV/BxffCq5yGABZfwfuPt04A11TAg8dEiwjMw0JS2oYYEcNuTPvMLqbSF7ehOAcB6wCuAW0saCPn1qEjss3wcxyB3AjasrXsRpsiBKgHraOUWpJOxEEFyNhCen/gC1B9/4f8gaoCWgETqy+gkoBxgrw5BtGSlzDSsIdjBLCvzkLV8GYdTz5KmNgSmw4EAGVJjVhYjMiGWhRVCtzAAvNSFcJVUvBiZgViySgusQRZCYaswCJ5vXkliOpkRHa3olRK8lDkuVxI3pVYhj6VUz91d/l6ncrvVcGvurW/7cjPhRZBAGqNAu4+1tXahEUVvL946wRQcT0i8OjRN3Zy0tswROv7k5DOEEOPGNKYxux99ti7OET4yoJWojaCbVB8i1BXfxeODNhqHugJbAisHVgb6wBRCb2Ajq9TAcS/iggcVABa+7CaKsjqECQLoAKhCMgk6ihxwwhhAjHKVbcHxEhxVHMcApwI1XCikBkuk5pEZEi1LTmqscNUTCwCC6hiYClyl1gMXmCsr5OKxCJTMbMMqQhezEOuJIE8iSUE5OjIo0qJIWWpFHflGnbMRSUU76cy+KUqWK/74g7Xzxcqx1UVzIVLn376/zjwcy1aWlTBXwbvhACuqoAHDx7z3sdfEHdvEdjbs2c/H8KCYTekMZ93IVlXR4ZxCEErgWuDNqXUKb1GbAFuAR2R2MpxRGpT8wO0JrmSMAAaQHQQO7SwIBoBgDAd+gD80TbgqgqoJEDAXVIlADhqbkB2oHYJBicBGdK8sk9kNXpAE+qWYXIpk3UMOYnsXn0LZE0ekmaCqQYNsdS/+TIpqICNHKQieTELWc3gS67+BBmyCRmmbEKWIysoS/FABiEg73elZWjmkiKyd6HoHO59Ku6nvl6n4q7qL3i+UjmpquAfU/HvXsorWFTB+413QgAVs3f4ax4cgnOBzQ81OSie17mBY0YX4stzA1FVwCtyAxw4ArBlUwGq24GVgIFSL7JjHRxSW4dLgXPnYZAvGf4rVMDV4+VW4HCrhUgOoACs8wWrgzADmFBbIDeDryu+gEwhA20aMZXlc9VhXeXVjB9AUVv1xWrkcPhMCvU5NMWgUqRirHMOq8EjS8pW06XbTdnMJki5FmLZJCnLkN2RoysrIrvn4qXL6nLpSijuU5l9BavSNcch/IbDf/rxXOWGuy+q4C+Dt1gLcB2z+dc+Fpc1AsBzVRkp9yJX2RcvU5Eju+9z8DK52WQWRiNGmsbsmsh5r93uQxOJuvK2AiEC5bBKE3PPf4EUwXp8XaXgjMN1eVkkRALzAXOOQeshCNUGoiAShA6oWYoSBgKr5qxcE1iD2pDcYN7KEFu0/gcgjwAeiTgGdQzyGOCx5CcQTkAcAzg24tho7TmcuOPEyGMIJwCOQRwLqM87j+E8Bu0ItCNARyo4ErkVsRXKVtAGxTeeuHZxLcRVhK+ic8jiEFLXj9n7mNmFhG6/Rxd3+/TbxT6llcWuC7E/Q+z7k/DDD/9fxNMXYb2GfdtqEWp5+FyU9PgVrc/qt1yJ+XDVLHhLeIcKAHilCmhhwR+uTQ/OaczW5Zj62FSAwDXgGwM2s6HIeQTiCNCRoV7EcG1hWEtcA1oZ2QvqX94G4JAYBNbbv8oMnA/VH1BFA+ocgfqEA3RATqAIsyJAAZqUhwrAfDhffQeFVH2NWEgV1yHUWNzhRhSCxeXN78ACuIu1dZqolqJcFYGj+Q+koqYAAjFJyK6qRihNRcgmTjKfzOtRbpNZve+OHMRJjhx6m+S49BWUULqE7F0sOj9372Px3+CrYVEFfyW8MwUAXJr//asq4M73wmfPazrqsdy38lOXy+WdcpFykUoJavtWWTvWC7t6yWuTQajuhZscd4IuSXJKqGeFZsZzleC/h3llqp9BoNoyhUN7cQVBAa13IGrBUiKYVMeZdRJ7gNVBCaxErEiuANYIBrzVOGhDcAPHdnZ0OvyIxu1MeABb0xQ/xtw9yXlQCoDqeeKYjmN3nIA8rurAj106oXCMoCODNSINh+5LAreBtlHQJkSuNfnGgXVQWIUYVzFxKCqrWDDk1PUxex/7f18V3FnD8L9QBVhUwRvFO1YAAK5FBB7z0aOP7Msvb/Pp0xehRgR+iaG/EffpvIvZuiIOIXLwiWtFroO0EbFFmVuFWZXMwBFUcwQEbYg5RRgr1JyAa34AVslumseI/bECmFG/LKKm981KoK5V7oBIOGq9obdXHRqbinPk4PJcXf1bgtH1cubD63TV36D6OxxwoCkCr34IttCkVBUFiexgYR1gUn0N0KSrTsrAkdIkcTJiLOJUt1ZVFVjEqKYSNFVfwdT8BzFUR+J+X0qMV1SBxyL/Y1Xw9xtXW5/9Pq/g36lBYP3y3/UF/F+FP50ArtYI/PBD7RsYo8X9zy07UNPg4hBjXAVwPRVsQd+GwK1auzAUr70DDVuCWxe2lwTgK4I9UAd5CEpAaxs2DxH99wkAaCQw+w7qUcCcMShK0GXn4utEUI9s2wXCJYk6+Cdm43eXBHHua3B4nq8hBbA1TSULZwIwXoYViUw05cSafyC2zkviJGoSOaLM/hUbIU2MNko+yStJXG4XbHJXDqFuDUIjAykXL332lEvnubiHMnSpnAm+KvuiAvci96OXIgj/KI7vTjTnFRyyDf+NysT2b3nXF/J/Bd5aLcB/gicA1t8BqxWAfwLogdW605QnoAtKdYwnMoAQmhe+AKCjOfJrnF51CTVAjrpQk6wn/5VZ//sg6qpPQDiUCACYPYOo74b12Xamhh4rAQAi5JUuqmrwykCX/gRBJJ2QC5ehR1UFcJ0UasmyC6xZioaqCqAsa8lKtS9BBpAJTk5mChPEyYmJ5FiJABOoEfSxgBPdR6uDTyfApwCOTUFMkZoMmiYgS5wcqCHFVPJ+76VEZneWqeQcu1jGsTRVQF/tuqJP4ObwG771n346t7+vTv2Z31R5+kLr9RfquuevrEF4cAe412oQLsOJdWuwqIL/DH8JBRBjP5h8NaEmBAX4triOLIQtXMegjlCzAo+A2i/gLSqAGbo8tOYhjYQOj2dFQNWoQ33x4daM/XLboMvHuva8HKi1CKikUkmhvs7lEnBQCwWqWwjNiUotPwBzhETIgjLBCVcTklhTkyVdzWicrEVcrm4PJE6JGGWX24M/VAWxz+6vUQWtBuHlvIL/pDKxYlEF/yneCwWAO8DTpy/Y9yfki1+I/gaxOee+uEVPnPJkIQZjhoHFABoJo7u5WI2YsLolZ7sdjJqqCzHRegMBl97P/4srpK3sbeHhrAo4a4TLRYkUm3G7miqpb64SgSuQFFjVjRpxsP4SsUodVVKoDk1SrkYKbMqCTRVo9inULEWH1KINdUsAIqNGIyZA2dm2AcDc42AEaiYjoQm00aUR8gmwMbCSRHGfzGxEwYQ/UgUx5uivVwXDPpYLp69Wl6pACirlNZWJgIDrqqAmGX0N4PeqYCGC1+NPVgCvLg7a9TmlbF129THFPiiuHHmdoTY/oIYBjdi66xjkEYGthCMSG4AbQWsCK0CD5vkBdbx4AhDskA34v1YAFbNDEEDlA155PJ+8cp5V9lcrboqhth2uZFB/pCqGln4sAWykgJkUWk6D46qKkABrvgE56vahbguuhB7RMg3RHIOs2YgTycnds1nd/6sVOTkulQFbc1Zv9+s5+1+pgtRUgV5SBVezDecahB9/PNeNa+HE7P+xKuD8bS6Y8ecogPv3a6uwj8Enn9zmOoIrO6XZlqdhb53RaLSh66w4Q4aHgBAiPIiIBCNcdWpvYIAzuBABDxADDdYq8Y0gQdWgn+HQF7iu1v+hsb8KlxmEqjyCZssAquwnwFkuNNuu78LYNgyzkR8ci2yGL9Q3315XnRpCs2xCMsxj0qo6wEwEzdHIK5EFobVPb7kJqv6A1uEIWdBEMEs6FClVQ6/dmC1wVNHk0AhxAjQaaz+DWRWIqurhX6iCGGMuXrLkxVVVwanvarZhbyXsWS6c7sPKy8XeVyvzrqM/f/5cJyc3q1fn6R+rghpB+Lr9L74Sqr9mUQVX8I4VwPzlf82r6cCXIUDE3bBPMfYpneU+Yxw82RBiWCFrI6qmAoPbQh1BOLJDr0BuBW0BbACuCa0ADAR6B3qihQCFKF3WAwAHIpgN+f+WFF76Qqvkv/o1z4Z+eGlTBwcCmK/Odu7qtkGopPDy/cNNUKU3OgSJbWswTzhC8xOwqYHW4YhibWBKZEKTvEULWtgQ7Tj7BUiMOPgENJEa/drj/0wVjHMo0UNJEVldLBcXF951sehUXoauuP/mm+Lu2xN3h/vvkoz+tSpYahCu409QAEKN49wD8A2BniHcJHnO0zhZZyuzcQpjKCGmGCCP7p5kSAGWACaX6gw+4TCME1Ai2Gb2KYLV0Ye5J2BdiavTnQBQB38Ab3wtuEogbZ2ez81/6DrXzOpAs3q43C4AhAgeSIE1rvAaUlBTCI0UqvPRCXjzHcxRg5YspSKwUKh1B5iJgJdE0HwFJCe5MmCjUa3ASVUZ0MYiTJAmgP+eKoiaTFUVTFl5SGFSQC77Ump35Fw2MWWVXNSFMpbJuy6U/d58tWvhxJV56Oh6/lzl31QFr+1iROBD3B78CQqgVQTee6k7UOsUnFKfYva+tL75Ig89AURsQ1v9rVUDQq0QyLSRuAG5hmstYCDRg+rg7DBP853LgQlDqwasq8AbUwCvw0tf9OXDlxVCPXf1cryuIl5WCkTbEsw/05yJvKIE2h9sauAyj0Cak5FqVSHnVOXZP3CIFrQ0YmASNXFWBeJEYBRnVTCv/n+sCiqJcJJxMvcpmE3y2hpdrXip+gtK8ZiylEvntXmJN1UwDF2Rw1XgvsW/pwrmLkYPHry2MvGNLwnvMd4hAbxa/uPpi/DTWYppdcX5l7orNQBYx9YP4CD950pAq30BIGzJ65WArAU4tR/AlQxA/EFXILw947+G68Z9FVdO/t6Z+FpSuLqlmLcEMyG0X6r2ZN0WQKJ4iBhURTBvEdTqDlDIuUwZBVTmnEOARgTARNaVX+REXZKAak5BIwQeCreMVnskGCejRskm0ScTp0nIwXzyCTl0tQbBHTlG1WzDkCoheCg10SgU76ai09bS7EqS0fPn5zo5Kf5x/sT/7S5G9/FSgtE7M44/De94CyC8LP8RbtI+Bk8v9tbZ1vY2hTSVkOExxhgFpQJLwb3LUG8IHcgOUCdHT6Cj1fi+wEQouiOijvCuHYBmg5fMWLcBl6rvD9/wW8EVtXEJojmp5he9vG2oL7r2A8KV8OOBEEg2d1cz/AMZ1IiHMDsLCW/6IIBsZc10gYU1zTjr4DhkhlAcyJUMWjpxa2gCaII46YoqADDR2ByG9bHgI1gdiMVZJ0FRowxTUPUzhMhJGVnmE6jssmkVY1b0vN97iSnmFGPeKZeudMX7qeyTFe3lw9CX891v/skQ3c+C/3wM78uJp3Qqf7oXbsLxOqfhlQSjGj2oi1ZViH/GlfL28Y4JoOHhEz755DbvrEGsTkkGHh+vuN/D1kbLCKFPzbMvRBYld3QkO0E9gN6szuED0EnqAHUAkmZnHzgX5gS0RqCom362NZM6yP93svD/Mf4NUrgkjleRwu8JQbNz0XAtDwGkJBlrOrLQsgnlCI0YCkB3KbKpAs3qgMwkszu6mQjA5kAEqqPQmj/gEF5sUQNhgnF0sJ5DzSOQMLn7RP4f9t5lSY4i6xpda3tcslS6QKvpNmEcO9gxRuLMeAENzivwPELPo1fogV5AQ2nyy+xngMGh+UQjVVVewt33+gfbIzOrVILu75OqBOTCoiIiM0VlRYRvX3vti6cJ7hlEBj0DllOyrILi9Kys0sGKkMt6QumSSnEUuVVfsg53UF4vsw811U01r4uu1tXGj4/Hqp+T6v/9kaOecs42/Oyz0QHob39DrI70yacCnuF89OCbNvTnZ+WPZQiu2AX4ZtsXEHvq/2q17sdx0fc9hrpcL7reFq5YJUg1uv/IdQtQLBnOVgMA3BSjEQiAGxSPRC0IjAJG7Cv/cz9AyJr6xzZQ2AbRB2AFfhu/7T5w++6+a7B7fZeVqMYQEPRhGz6UQ9ylGldtcwlUyShhhrRlBWqswGb3gMhwFRHntQI7H0HQNpcgsg3VXAkzTJrZgTErEo5ykYq55WR16x4oqXSu4mkofaeyVqnuXR2aVuDeuhiVvl6sQfik4Jx7ME13dS56sKcT7Bci/ZEMwdUYADZvtPn/T59+bHfujHbckn+G9Y1+UzB0dzB0FYvq9ciBGwk6FnATVbdE3HLhtgG3YLwlaTYCu8Qfzb4/R1GDgZ2ITq6O/I+XCPtd4HKDoPlN7Q7jmT2vGwhoxUvxWYnktvYAhMODIYDNELDVGVDbFmSMZKLQCqBiFm3O3tQKouiIilbqTJwkRUHSnkDIfTGRTTRsxkHybGSWLBs9uhjN/Qp0XivoexW1LkbnKhMr3Avcb2PX5PS719rc/dR/Uyf4gxmCqzEAcamwzf7DPwwYDbibfv4ZXb/a9GnkMJVhrCpHHfzIO95Q4c0UawDccvltM95yRT275qXCyGMIxyCP5DoicT7vn635h5BooLZ9AOOLXdj/7vGmQZhPdswgXAvtDAQlascK1FgBL2EFjQHsZRiqEqgSKvgbrEDbZKMWDlTm3FJ9PmeUHwMe0YWtQWh5BN6YhDObKUMq7p6TMU+OksxyJxVPKPK9vIL9bMPTMz9adPVVRXMPVqpZPkcP7m0Q3Y4vWSLtj2YIrskA/Mu+/faHdHTUin/WR/1U89gNdazeH6XOj1TsWKg3QUTNvzwaXQi3YbgFtfTfSP4J5R9YCBzR9AC0TsDa9gBkm/l3s3/cvD+OATiHEP72cFk48e2sgLYLIeo/ZgU8F0EwnmcFbGnHZLgCYPQjgLA9n43BnG/AvbyCi6xAZDZZ9sYKkll2R+mS5Y1q7VzFa6lDPxb/FfdgXgPhhwuLocwNTt80BN/sXeErGUzvFFduAJ48gf3tb7FS8E/H6PozdN1i00+1jlW26KAj7+0GkI4TcFPULfg8+HkbxG2XbgNR+UfwGBH+OzI231+I9l+4mPUnYivm/PFm/9+A3jy8hBXsaQUA54GvRhkuNjxpZcu/xgpaKbJQL80r4NuMQQiHRMsilLJRU63ttTmkaNGrgGaT3LPMtu3NkjOnZMEMHEUJpXeV9UX3oHR1sRjqiZ94re7Hx0P9uMp/0qlK+Zvv5xNsOx3jvh4/fhzNSh7hdxs+vPIowIO2/657xRF3QFsTXDCqUkkMTmaZelitSolKgkXDTWPy6p0ZE6QkMAFKaPs4h+1tcxIdQx4P6v8nHPzA7m/V3p/NPVawx4jmcAJowSJEMCIIwaIEwQRESTJh2AqHin6IF7INsU0yYo2B39qf79yCAiCbWXb3ohZSTMYJ7tlokzuirTptir1PgE2gYql2Wk7AJNaMalnmORdlmWV1NfuEUhfMyVlqh+KFte+HMqVSpx6lP0uexrF268Fe11d+Vga/XeD1zh3/4Qfw3j04XozCBD1d/UPRqegZduHD2S34/UQMrswAPHr0iPfvP+PXX38ZL3wHkEueWObHNJKVi4VxvYn1+7o2iN0tgR5dd4VEMEkx6NUGP4XEWBTUKJii9UbcCYHtCWfcnHPU/8+IfaMngM0gxsVoqbHxWrgEnFkBQ8rlzAqaqbAY+FtWYJFogSpi16SEqCQ6tW7NaNWIZEs9ttatCMrNOGTIsmLAZ5cyhGzGSXP4sCoDPhlskkf5MogJStk6RSSBzAk+CSmnzrNnRS3ChqXrmKujHHddWS/XXd9b8cK6qcvq41G9m4aqDv767Bf//OZQAecPx3d1r4PfGUY9fw6tVh/rkxY+BB4Bj74BHn6jZivfGrP5UHBlBuAiPvsM+K//Am7jDpY8Y4+Bm4kEyZ5O1UbbtTejUwmxyu7WGJAwRyj80La8t+1lJDhb5fjNsdtjAX9mvJUVNIHwnbICSVsXQWBzE7QrRgrtICP6FRZEzUFhzPAZ1qoTxQz6JDATnEBN8EgukmMSNWnOK4BnOCYZJrXogeC5C3EyC7lUWe56K9VV+r6WVRpqX1Q2A6qnqd5NH9Xv1q/s+F9D7ful/2jORe6866D79z914HsAXwJ4Bjz8UhHt+qbpLx/2VHNlBuDh3vGLFy95fHyX4xl4crThuOy5Hit7kD1ID8pOIRGpMowADa6o4QdiYJOUxyCPaYoEYwoL1WGe9A+z/2+AALCbr+aL925YgRyJgCMSj+qWFSB6GAqqaqnHkoYY9ChwzLpAAZgJZImFhgmwTOxKlWEKt0A2QZqMNglRhCTaBNdUpWzkhMqc3bMlTgnMLmYJJSnluplKl1Cqs3gtpa8sm7qsw3hU1+uN3bjR19ev6bdu3awpwQHgxYtR0/RM9+9/6cB9hDbwDfZdgg/1iXvvBoAkJWwtwNOn3/POnfGNzy2wQEVhRmGHRIF0rwbSjAgjYKTUOv+IBrjRSPfGFqh45OJyB/3HbAWAw+z/67hwXd4ZK0AYiTmCkLiXbQgEKyBRBfUAC4m5lVlR62PYtkyoSGz9CpS31F/IRk4Ob2FDmzD3KzBNKIpeh8BkHSZ3ZlRMhcwGTQmWhZK963JKzGYoa1fp+prdbhQvudowlvV6snHsa38G8uay/vijc7HovOu+bAVH/9Ann3ypx4+f4euvH8VV/YCNwHs3AL+KvwC3V0A6BnItJCqlxEJnikmdbTInALpkiBjVXnkv2qzfZi1tr/b2+Z3Jv/Sh3oYPEnEJ3wkrgAS01GOFVuCKtOOZFQgO0UF1ACvBKs6sINZelKKVGcEsNlbASD8GtW1eQmByRh6Bu00kJiRMJk5GTQImuGWwGYiKqXjNZmkSPEuYXJ47Wa5uybUpXZeyZRiHsdhqsjSO5NJoN29UM3BmA/fvf+pPn4ZLcNEIxGT4YT1912sAGparwn4YtucdojA9pTb0XXSAFoc0I6TWUFekkVAkvpMGxIOp+bDNbGEkDrP/f4Z3wwpaC+QoyBLnGoS5e5EzIXQDR3MP5hbnaqsdoy33huhctO1uDIRWAEUEQdozBMQkeGMINgGYqmsyYkrUJGKCK4RDchLqlIhJUJ/AyVCyq5tSV3OtTH1f83Sm1N0e8uZsaTV7OVqCPF5V/izi9g18+y3w1VeXGQF8YEM/cP0G4DaAX3anfQ/kkpgAVHemmPlpiYBEI+GuUACiuI0uMN4D5sFPtMfzst95wH8X/1NWoOYRxu0JbUdga23uzSgASa31ORlsgFAHzkupBSvwZgjmbEO0lZdBxB6YDJZDC4iZncTksonUZOBG4AR4CInkBsCkWqfimKznJnnpXN3k8q44U+pTrstifddnElzniUdLI8dVxWvgohF48OBrReP7b7irMPxwTIHhGvAFgHvt+PR0IgBsNoUAUEplB6BCTAYgAWaAO+lOusjIRwFiVm8B//aXxEMHzDPVYcZ/99BWW8HetW7WF2Ib3gRIhiLDiIxvE7ISFBmaikzNToqGLaEDqCfQG9BTGASNIke5Ylk16UjCEaPvw3bBVYjHENvS8dErwueaEeEWyVsCbxHxmku3Qb9t5C2D3TLgVm3t5ayzY1XeFNJxUr2R4EcuHbnKInX9WNzHUjl0Q+nXufSrKXXdeCP1/TKNI+zbb2FfHX1K4Dmj/wUwL3PWrsUHgffOAC6auq8u/dQM5/xMBQMgyRbgt0g1M8Z+35DOvHSfn76JD+aa/9HQHur/gBWQcQfZ2qXvsQIGYzAQ4TUQTtGpYAUCnGJb9VmdFKFEtqQicnYRWjix9SmIsmNlIyZ3ZYKTGTcSJ3cfSWxcGAHbABrcNaSU1nLvBOsE75IsVSi5siX1hl5MaQCOOuD1GVbjCY5ObwGbZTABAMvnQEQHnuHhw0gf/nDm/yswAL+GvwD4AQCOACx3r5fmFM7wRv1numIw+JzWd24WQjDOD+gC/1nwW1oB97INw0BAkCjspR7vllWTomhLFFwxZByAW0QTkkPO1r2IRAXReTQ5LeEyoBkAFoEZrgFE6AOt7bm7Rho2FqsdDYBPRg0SBzP07poXd+1iQ0pSciZzZUtuLBRrKexuHwOvz5D6jXSHUoHu1VfCUAhs+OTJl/jpp2ctPPiNPhRB8FoNwL9+WRFHwHqdOSzGuMV7SG3vBriHjx/75v1vH7IL1/HCo3jAleMNVqA9VhBWOozBOeEQoIWouAsnBl8+zwp2y6MlbdOOz3cxcldPzi3PVUBmyGMPRQ/D6FI0CJgQBDN78AAAIABJREFUC8huEIVkA6TewN6juUwHWCcoiUxJMnZkYgKsAhVIKkJPrHpqkY4kQT/2SRnA+gVw69b3/uDBfAGErad6zbhWA7CPESHx9oi7chl8m9DzJi6aAklvelrc+8AB7x3nWAFjWG/PLrCC9tnLhEPGcGmsQFGQ1IbQvO5BEuQkq4AEh5uxAMEKGMVIvcjCaGE2gNHBWDXWQgxBEAPEgYYeQl+FPhGdHJ0lJHclSzSD0b2wqiB5B9SKLKiWAZ2klU61WHT6i5vgN/VtBx4dgcCn3I8KfAgs4NoMwI8/nXK4mfAfgXhzpB/w+8AlLsK/xQp0gRWETTjHCrYRhGj4OtcgJHksn06iuBSGINrGhSEAepgywR5AT2CSqafYC+jN0Ll7R6KrzlhSXgxJQolgRVWBS0iehK4omflRGrwuB/9lA+VjqKuvNAyFT59u+PXXc1Tgw2AB12YA3ooecWv2YHjDOzjg9w0Cs4twnhUAOC8cXsYKFKwApBBagYsQ0WoQ9kRDEFViIlU5M4JYG7FXNCPJEHqHBpIbCD2A3sDoJGVMJM3cTU6TxZezJBCdSDhS9VqzG+W5yF3Jx25y/WXwVGB9n1TKHQULeP5BsYAPzwD8G/CW5NMmiQN+p3i7cNiswtuSjPa0gv0IggDbFw0JOISEVposojJSjDtExKDbGgIiA+wQq0d3ghLNkuTJpUSY0ZpXIpMAGegOuSG5UnWj1b5X9cK6nuCjb9wWo6dfTJ8fv/IXWxaw46/XN/QDv0sDcMAfEm+ygreFE9uLQrMHErjrbbhzD1r9AaU4FpJoFXIHLSHCiAUIoU9SR6IjcK7XBEOAIB2UtcQGSAVyij6hOpVcUJWnmkzVjvu6KkiLs437Jzf8x3xqXWMBT558yp9+eobnz7+5sCDJ1eNgAA74oPCbrKBpBVuJYHYPGkmID0htZwTd4x9HMVJz3h1KjC7Hqc38iWSCmGQ0uCcpelNQIkGyo+QutSImk1WHV4NVhq5QrKulFNWkUi2lyoRqBjO76V33ivfv30EsT7bDdboBBwNwwIeM5grgVyMIbxMN992D9n+JUCJojN4EFtUjqhBNQGJkKRpoBohU5J0SkFxSkIDqTkdrfUapIDFTKbOqp9WSM7pU+7LqkEZDTQn2WbrjwEsCGwKzGHi9bsC1pAIfcMB/hGAF84adKyAisoeIGO02f04t7ZiRSd6SypEkdIjFYzsRPVxtYRkMjFWmBgAjEGnHIBYQjgQdATpKxEKuI0ALkqNooxtHuUZXGap5b4bOErqc151tclouN8lew37q/mnAXQKRIvz48TPO6cHXhQMDOOD3hq1P8G+7B/EZQRSaTqAoKQ+NILRkOmBRZuKGedoHQFIgXC4XWWCqJmbBozuRcXLXAHDoqqZC9cYu05R4Q2aFdtq9sgVvErjNFy/+N1+9Oi8GXpcbcGAAB/xeQWCOAm3JAYFIAJtZAWfNLo4iiVTbBWKj1yTQOdQb0InqIfagBkmjEQOgUdJIcpR8AXF0YCFhFDSqaqRhINm7WW9ER0NnqSabajKD3bmz4F/tBn/88Xvrurv86ivgyZMvt7P/1Q/9wMEAHPC7hn7FPdg3BIgekVtDACjZnhEgmAR0cPQieog9yV7CQGIgbQAxCBwhjNZeIzGIGEj1NPV076unvtbckV2arEubTUk8g/0SYiA//xzA80/54AFw3W7AwQU44I+Ec+6B9sKI4QqQLbQY7gMRS58QkBQBxLAK8ggvCqTL5SCqgaXVEwzuGEFNJm4S1bs4mFkUEAkdxa5g6qxaumG0pdGm01e2WPQEMnH/DgDg668v/TuuDAcDcMAfEeEPnMs03NcJWrJAK00mAIGKFMNINTRQCvPQgawAeocPJLOgwcx6wXuBISCKvVw924I07C1ZYRoHWc202Q3IeSR+AHFvjgZgj/w3znKFOBiAA/6wmHMKLjMEc2IRIl5oRrhvG5hSikYlotgamKKzSBbqCfYuH0AOlHrQelA9WwEREjtUdmRNOfepZKXUy87OZOO44o9Wufr2LpdL8J///JRRJSjsCMzV4aABHPCHx6wTnBcMt4yAiPDAvGy8tS0ZaCASWscita5FMHRm6EI0ZC+pl9S7ggHQa0cvHZkSrSYSxg3sJkeenNDMbjKSgoCdDvDo6kc/DgzggD8RLmEEjYKTiOQiQqAjmpFASDBWgAYoAY3ehzGIWZ/s5tcBdNieWyI9laJEMzPCVgb76KMFp2nJlO7wxYuXb4QDrxoHA3DAnw6zIQCgYALUnEUIyDiXJhsIqUUJdD5aQCZIbdCjg9iB6qDawSxWrapKA80qSyKTcb00LhLNbvDe3BTzDVytDnAwAAf8aRFDbU4lxswCBMUaFASNIAUZYCYpgepAJDg7NV1gziz0ubGpo4Nq1xlTgSeb16280fPszG29/sVy7rhaXb8OcDAAB/xp0ZjAXkHRttpwzhegovbXICUQBjASiRgVgy4P2i/ERkukEmCpGhNRE0CbCEsb2M00cjLRbBE6AO7g/oPf+KLvEQcR8IA/NWZhkKEGNKFQhER5rEBlIGlzlgCiMxCQDEhGJgpdAhPbMR0d6YnwRMBK8cSMnQ5gC5JLfvYZ8GJ42ab8ZwSuXgg8GIAD/tSY9YBZFZwTguYVZyWYpHOrVCu6DbU1DdCBSC7vXOpApdgs0S2xWiJ7I2Ebox1zIrmh2Q3+8MMdfoFYL3P/O7VoxJXgYAAOOADAzvcON+BcinFzBdAqDMGtS5AEtWXqmRIYx7BEKFUqFVeEAUlbsONqTYONJFc0O+W3rS4A2KUEXp0EeDAABxwAYBsejB13x4qaAhpACEY1AwAYpQRyb/Znmjd3JrondjBWb0ZgbWTmcnlqfHVEe3mTnwN4/vxTPnnyvFmgKxz9OIiABxywxSwGtj3nvQNmYCxALxkFcyHahUWn4C0bgNSJ0U4sWTKvSKCMhE0TLRmNtwZyvSaT87suX6sQeGAABxzwBsL/n3WA0AIUWkBUEJ53BwwmBhsAWg4ALbkrAa0EmTAajOhIDqQtiLvAZ5/9X9cqBB4MwAEHbLEbe5fpAARm58A4D2whmocqZn1JCVKiK5FKpKdKTyywEYm8IATih9f8AgCuSQg8GIADDghsdYB56LUoQJQQK4wA5MY2+6vlBkhMxqYJRLPR5PRUnQmkAbGa3UQaLgiBPzYhENckBB4MwAEH7EHS3FIMTQAEZgYgEMZdRKAxASPMpeRgMpq5mAzJOsDcQwBcXRACyQ0/BCHwYAAOOOASNAEwXIHmBkiwliLYiEJ0EgZhZmZs7gCp5IwwIFK4CvM2TTQc9VyuaLQ1P/kE+K57xfuIysCrxsEAHHDApZiFwDb6GxOQZGpCoGsvMSiKhmze05XcleiWUC2RsFxgGBNtg2ABtuB/ccnPAGBeK+DxM+IKS4MPYcADDmgIn38WAHb+v7gTArEVAhVagCIKEE2EWkgQTE6lZGb7nyOzMXcGVvJmz5PNhkd2gz8k8N6Ll3z6asOvrrg0+GAADjigYS4O2op/wP7PrRAouYEh7KHN+iYk0AyUuZQSYdXV8gHYKgth41C5LDBDoVklf3HacSW+QOiA59C+yXvEwQU44IAL2HYLIYC5u/BeKJAW0j5iiwpBWhMClcywNQIJMK+RDoxCy5k2oiPZkxz4yjYEgG+/vduoxxwJeK/jfouDATjggLdgFgKBOUY4H0YLMWy3qPc3i4iAxDACrsSUtglD7I0gbJqiRRiZ+dFHH2FuFX4+EnA1OBiAAw54K3bZP5hdgK0GEFGBiAyEGyApydnEQCYmCyPQwoUgrGTYYlFJlsgI5Jr8ecnvvttFAq6yR+BBAzjggH2ECrA9lWK0tzLh7cC3rUvQ1iQkDAgNICoFaXAlGIMlVBg7WD8kTrlY2roBIO4u8dlfgRcvXvIL3L3StQIODOCAA/YwD33O8zyaEeDWCTg3+8/0fu4XICDBYNETIMKBERKMdGAWGIbEjdHIiTz59d4A7xsHBnDAAXu40CYMYPABn7MD55Rgiga2vAAZyYgGtKxAI82jV4AhwVBpIK0gG7NsYWTGgqcGLrii2fVEAg4M4IADfg0SL00J5pspwTMbMMxGAOZU9AZIc1UgjUwEOm42SyM3fPVqw7/jeiIBBwNwwAG/CW5rBNCiALGFJtCkwj0xkIkwc2fLDWgCIGE9dpGAI/acIwE/XVMk4GAADjjgVzGnBLMNd4AkJM5ZwjHwtyFBi71aKzAgkoBqHJcPLBJw0AAOOOAiiDciAVBrD7Y1A+cFQcwuABCpwYBB/04kYCJPjiMSsI4uwV/gLq4qEHAwAAcccBF7KcHAToK7NBIAmFkLBbaogGLdAFNjAe7RJCQZjaXpBUgESwsFtkhAAoGXePr0+yurCfhdugBGCgDIq7lIB/w5sd8bYBsBwHYfkQDOFYIe2X779QEGU2sLhrk2gLTCbGS2aYIBhac2kb+saD+d8otLIgFzDPJ94HdpAA444Cqh34oEtD4B53oFtkgACJtrAghYJaxHrCEyLnY1AfgYwN9bJOBcdyC9xyDgh2gA8psv+ZsvHXDAFWO3pHDjAUTrGgyGGAiEr2+ImgBuhcFgBqkj52gAMoyzC3CWSR7R7LLuQO8X12YA/v7Jzf/crglhDd7yL/dfZnMT3vqBAw74t7GLBAAhCHKOAELhArQ1A+RKqnNNgBlTuAN1NgS1iYFD4jTRjpB5fPMm+HpNILoD/do3ede4NgOwj8Wi16Yd7xOAijb7NwpgbwxqYR7V594Q9t864ID/Ji5EAvbe0FYMJMlYOpAUAe3SgwmDY9sa3AnrkpOdM5dsYOKaPcmJJ7YhuSQA3L9/daHAa40CfPzRkX7YnMTJGsDw9s+aUZBgRrnaDB93RedMwGHQH/AO0EQ/7EcCdmnAwNwcpLUP4bxmAIyUa5cdKDPQWxiQVlMwgYHGgsrNptiQFrx9e8DtaYkf0hlfvCj84ourKQq6Vgbw83ywit0wmACgQ+yTSUCNmd/3tQA/N+zZhv28vxwHy3DAv4+d4t8yALkzBmh5AdDcHQhsSoDBYTQSiNoANkPgrSAIFVYrLLdW4WTHVSsK+tluEPgUwNUVBb13A3Dxr3h64fzmzUEAMI6dpmnvjRR038wEOBwOA+XuiLArgOYSOAA167Dz/dXODyP/gP85dmM/EoJgwf+NhjkfACA1i38KY+B7IiBYDdt1AiqBjmQhMPDUxggFWgsFXogFvq9Q4Hs3AJfhBYAf3vJe1yUVIAQAULXtzSiHNx2AIqE26mWESCoMgQBACidNjcbFfQscDMIB/zEiFDinARIQ2oMotoJBAm4GcO4WfE4LAC0lo1dYTyMYRiDag8U6Afg4ftebRUFbwvvOcS0G4BxeAzeOuu2flzPQoQopRnJq1xmgrO3dY+ADFAi5BERMRvOMT8bgB/Yv3nu6igf8aSDtCYAKx2C/SsBbURDptqX/iMVF6WEMSoURxrwXCrwJYD8UeD4d6P09t9dvAAAsERqg+qS+NyGZUIBZetG8ES5IpDkcAiQ4RNDbDH9uI2eDMF/AAws44L+LORQYo3/WBFo/AApzKNBbc5Ag/YAbFS5ABSwlsuucpcIwhBsAZIIj51AgPgeeP//hSnIBrjUKgJ+B10fAeAaMY1GdOqCvEpIKihJMgMdMLzokgXRJIuGQOQl3SQypxqWdARDizuwNfGKWDfcODjjgMsQA3z0iulAUpJj+EQ4o2voBMxsIDQDNFfA5FOjVIFrfOcnEKU+WCskk4g7A/3/J7zaZ9+/fwf15sZD3iPduADR74Y8A3Ae++vrTNkBf6b/+q9et4YbSBsolC6iSOgGulJKjymEpFEC6A3AITrICcsAdoJORMiBJBroIDyu8YwK77xN3bM8IAAdDcMAl0K8VBRGAN1egaQBUZAJqT/hTpAnvGYO2nsDsKVAkjEtOHPeqAmc8fvyMz58/wsOH74e1vncDMKON/zfLHF+/AoYjrUD0SgKqkKVmYGPQow1+skKopKoLFWQFUAE5gQqwCkgQ2r9r/pojbs0W83g/GIIDfhu60B5MANCKhBzYaQChDpIM51OS0Ug59ga9CJGlyIhsRBdVgcueJ92GR7/c4A/H4NmLl3z1asOv33NV4LVpAN99B/xVN6Rbo84AAEVQFZSkrnMIHvzfq8gqsQqqJIo7q5GFQgFUQRYXaxyrEqh7RsBBuHxfH9ja8iB1ewQBh7DhAW/BdtrAPNR3DIDWjtn6BMrNSFKtXBgwOlpBULWeTiCRrCQ7wgpv3wbwl7f//veBK2MADx8+FPAIeAI+/xtw//4d/fQT0Gsh6VTjeNO7uvbqMfC7ZFVAlaMiocBRICsyFUJZUnGwGJgl9CQKweSOJMKCXO3GttCGO2Rxn0JRQCi5bTkoNRuPRv4OjOCAHVoxEOcwIBDVPxLn/EBiXkHYQG+qPzyeRyfMYEwAS5UxzQ2DMnF0A6en4GK14r3/5yh+4YWkGYZxeacT1JUzgCcA7t+/J3wLfOKnwi+/QOolZUkLD10frsQqea1SrdWrhCJ6NjGTyBBzMk0AMqFMcBKQSWRKRUSBo0KoACqJ6sDu/x8sQM3Ta5eVu6hBXOZz+sEBB5zzEhlsQBRngwCIUqwcbBadg0E3p5tBdK/mFcbOiJCzuEFHrne5AD/+eMpvvz3hxcYA73boB66MAcx48OC+gH/wW3yKIwCDj5ImHWn0ExV1gnfw6mJNhmLGXBxZZIYjVygbMYmYIPQAegEdGGKLJNIIuW/tM2I4p7DbFHaCTaNszaSTTfihMFOBmREc9IEDwBjibbBzZpDkLjcAJOaW4Q6DuUEkXObbpCAnQJZKG7pETpmk8yYSyqsNcdQB+BzAPQAfA3iO9/UIXiEDmL/8Y+Ap8Hl5qb/7TcmPdHx8y880aHT50HdVKVUpZv1SUCRmc0wkJpIbOSZKG5IbShsD15Q2Lp8ATBImkBOgDCALKhAKiIJWZOiSa44qhCluIUS1WX9OQNqa3dmQHPBnArc/tqe2/wrn49k9CFFQiJoAhlZoAJnY3k7RJ5Rw5pYSjKMbOGMm5rUCcTW5AFfDAIjzQ+erFgr87pW89tIvpqNx4dPY11zX3slqp644SjGzLGgSMBm5EbwH2cvZyZFAJBJNaTVKDjNG5lDcFSfpADoICYJAGBkhG4eMIFupAQA2qhVEAdscgkPE4M+Ii4/uPtRYgLiLBLhgJBmugEdjUJJkNXdaIuiVlpKz0ohc2MqIeYyb+Pn1mkdHiyAAz9/yi98hroYBzMLFI+Dx4/bacwCf3dFfP/rE79z6yHUD7g4fvKvuVt1Rklk2w2TbmV8bOTeS1iLWNKwAriSsRa1ArUiuJK4JrhkJhhsIE4RJQBaREXmGjQ1EKFFsx0IrNaRA7LUfuSRicGAEf3g0uj9P7ZBAKejhTA7INhcoAn2Q2/wODIxzEhZCIOisNVwBIhEjwE3hkhPv3AE+AbBtEX7pt3p3uBoGMOPhQ32NR3jyBHzw4HsB/6/gP+tnQZ3g0pm7W+27vlRHUbIcGUKczLxTsg5Qqq7UQeYKGiUQhEkuMbRaB+QC3YgqoZLoAVRIHYwJQgLgFGINtxj1xhAEW8ZnzPq8EDGIaWGPEXD784A/A+Y7T7RkIDHIgEii5QC0xJ/mCkCku8zMtp/vKRZUYupIGrmceDIV5oXHs3S/be8RV8MAtoi/68GDZ3r6FHjx4n8B9ZX+UuG3HX5Uu+q1q3KUrkvZvWa3bjLaxsWNO9ZyrBNsWcEVgKWAJYEzwZcwnoE4I7AUuCS4lLgSsG7bhuTMCEIfmBkBUdhYAckKoqolIrVpP9KPiUg2viRigEPE4A8L7fcF2L6IFhGcjQAoB9ujsd0A0uVmDI80MgBn6ckYpcEAjo9xG3cAAJ/t/e732RnoyhhAo0+Bxy0l+DmEDkJ/qn/9nNSN5j5O1YtVeild7XMVkiPWXrdkJrgJICoZpdiQRzqww1UVV7MCKgCKWhgQVDGySOgl9SQrpI7GBDJRSgKjj7uUSM5BV7Om+grzEA8COEcM4m/b5RDMVPHyK3HA7xnzTZUa8xe4PYjkc8a8GgYBACVvLAAESNAJGQvEoQ+6WXMll+JJp2024L32u95nY6ArMwDbmgA8FL5+BOA+cP8fwotRP/hd9beXfrKU/6V2dd3XwkJjV8xrZy4z60AvokRaEhD9ASRQBnc5nGYV8gKwUCyCCskCIQs2QBgAFZoVSD3IDhFKTII6RJ5AMtAlJbSZPwSBnSEAD6HDPz242ySRai7AzAYMkM9GgLTZIBCEjEE0ReSOE8QygenYcXsD5L8A2AAvWjrw+1wk5MoMwA4E8A2AxwC+FCboXgf/0Zw3b96ovgR9NZkPpUyTWeqLVXcDOjpiiiYYhExQMlRVq2YochTSiuCFYAEtA8qCRoJZ8GJgL2kgUISmC1AdxAqgA5li8NMhJRpa33fIJQtmACKWhNZ5Q7CdH9jG/nzjDobgDwK1VuDt7pJsPmHc4cYF4jNmBm9tKtxJY2MAcFaKnYAMp9G5WCTkVSEs/dqvx46YvhtcsQawiwYAX+rJEwD3vxfKS/09V68VXo9X9WhQqVml61LukqYjs02qtjFiTdSVV185sCR45hVnMJwSOCVxAq+nRp6AODH4CYRTwE4BnRl5CuBMwBLgEtCKwArCGuBawAZzLgEU+oBHxEBhsguA6pADrJp7EiDCjtu/L0KH2o1/tPMDfv84b8ulVmfW9sEWtwyR8Xq4BI4wBoCIapxrASY4NyzEEXBq05VOFtfAAAA8/EbAN3zw4JmAL/F8gm500JjgpMjjsS5WI60DNhlA16NiEx2BXTKYCDlhVaiVsOJiiHhkcVcmLTuUCWSjTwInB0ZCo9GyXKMiMagHMIQugAqwI9FBqIA6kAmRReiIiEHzCILMASQEA9usHxMCgdktAA6M4I+Ai7cs5vot5uLz+ZMEXNqyADODuwgnq8CUgFKcTD0GAAl52xKfv6x47yjqAS720HzXs8gVMwBgniUfNRYA3Ndq9b0+/xx+7x78r3+9UUtZ1nqE4gVl7PtcS841aapmG2O/NtiKlSs2FkDwDNCpS6cwnIA8Qcz+JyBPHDwBeULXqYBTAKcgTo08lSKKQOMSwBLCWrFtBG4ATGh1BiIygRxViCEuKgJBVa3GAEHPImKweyRahODACH6/ePvt0ta6b4W/YAYE3IMZuItmgENMCajV2SUgogIBrnvexC0AwI92SlyyTuC7fmquhwEAeNhYwOPHj/HJJ18K+B7Apw7ExQGWwNENYAXUfkI3UbmDUIqUOq8yF0s1oRJWCA/RD8gCMo2TKjLhk8QJ1AQyA5ra7J8JDKQyYINcxYheQAHU01iwjRigY5QYdyKS2PIHDMYW72WrMVDkgnCOAvC3cggCB0bwu0GQv98aiXN1MEzBAPZusVcRs8SMWA6jYoFL18V7wwK8W1yTAdhFBL7++hGAZwC+BPA9XrwYtVh0rcn3EtjcwMI7rXqqS1Jy81yyW+rcyFrB2lFFiYUZBWCmlGtVNlqGMNE0UZwEz5CFMQAnOcIQEAMjH2CAIUs2UD4ADDEx3IQODLeAZBLQmWDnQodNCpRgIfhgLhJpUcM9QxDX4ZwhOIQPP0DMGl8IviApaBfRjnNJDtB270VLKrW6n2hMsU+3OwCVTighs9KwJ/59DGACvv32hJ9//iur5bwDXIMLsA/uuQLPBHyqL77Y+Hpd/O9/v1n/mm/UslnWcsPLYjHkUjZ56DUlS5uay6YzrY22qqyrWnzFxDPKzirqGcxOAZ0i4QTACcAT0F7HMU4gNaEQJ3KdSuEW0HVG4AziGYCliJWEFSKteC1FIhGhjSLCkCUVAzOglnOAKkT5MVuxkQBBl7gG2LkG7ak6lCB/SFD8aFPWvv4uABKi8wwYK1Y1Sy4izs3mbtY7WKIKgKRYACc6YV0PrtEAxKV8+PAbXWYEADg28Hz7Ri3lqJaCslh0ueYhj91sBGyTTOtamiGodVWpJcAzFj8jdErhFMIpjCcAT4x47eLWKLh4AlMzBDh12CmAUwFnAM4InBFaIjIOV1F/gDXIDcANEZWHapWH0C6jEHiLIcCvGYLt9KLd+wdcCziP5xjAktCM8/a+ULOsL7VnercPPtDOKcTSAqoVSLBY/wJArIez1wiw4fPPb733+3+NBgB4mxF48uRTPX36vbCEbzbwzeZVzfm05uylblB+ySql3+TSa6pFU+K4LllrwlbGuiK0rNCS4lklzwg7JXQK6NSh0xAIeeLwxgaaUGg4Af0EUAiFwKmgM4C70KH2Q4e4EDqchUJmAIWt/Ji/aQj2w4d7KcbtIuHACq4D2p/9w3mLEHysQwGBcR9jozhnpEqSIBrdITkos7jP2jMIsQRe1WwCjhZ93ON/7X2Li2GAd4xrNgDh9wLnjcBPPz3Tycmnwn34comtS5DzjZqPUY6OxrzYdDnnTS6dptJh6lLedIZ1zVobuRp6XxZgWYuWRD1z+BmlU0inydpgF8MVAE6gMAoAY0+cAI09UJE/IC3V6g8ArCSsjVwhKg83BDaUJodCiFQYAvBNRhBeY3QyRoiDDkQvgni+9iMHB1Zwhdi7xgJm+q6W8SWKZBjt9l+4+HE/IXjcy71eE2EzXICnBE8GjyWsqqQkwAR1WmKJU5zg44+O9He/Kbx4yzd8h+A7TCr6H2I2BQLwqB0/I/Alge8JfErgL/zuu/9tfZ8sJbOUaGdnU7qT7th6c9ZZNyQ7Lskyu1y8Nxu7WmtvyfvqHAZLvQsDDYNcIw2DS6OkkbBR1EhxpGGEOEIaYRoljhRGhFg4uGM0ohc5QOoZXYl6AB2JTkIHRQ6BgGSgCUpgZBUKc7UhKLV+BJFHMF+D9vZOEAyBcPv6Pt544YD/DBd8e5wb+NxSAAFtYMdWEa5eBjgBPgFYAy2cDJ2hsUuYXkP2GtIC/CUMAAAgAElEQVTrOMZrJpyUwjOinhHdMrFblW7ajBtN+WjMmw3K2dnL+urVxr/66l8e7Pib2TC9s0F7TVGAyyDFY04AEPANm0uAJ0++xIMHEDByvS4o5Y7GEfrrX0/949r7L6dI41+O3ZabtCqebqahqqZKU7eR6oJWHF4q1FuyXL1mixs3EMoGTiInhbg3SZwIn2Q2UZgMmmScJIzcCx0iEo0GCQOoArFXGIAeZDUgQYrQIeCmtmIst6WiRAsfApz/+G2tQQsp8Hy9ARAGAthdq3bGeaI64N+EgHk4zZdxG7iJd2LGlxyaZ3YBTqJS0UeCUhUYTE/RpVpiYSSTVYgV8ApDhawC1SV6Bzi73mspwkI6yoPqLQj/fAkc373k627v8TvDB2QAgN2fRoa1E4BHbfA/I54Ar25t/OgI/Ly8FHCXP2SoO4ZSgdli9OkM/rrbeJoGt1t9pZdasjpLLFZK4ThkUoWy7HPI0DCYMAHROAT0CbJm1Tm5OBFvhg7lGMFWVgwMBPpgBBE6dKFDVCcmSp0TCWz1oKCBastIhTGYaw0kkWj7Vm9w3hjsxvg+M9hzE7Zv44DLoDcP95V6CWzyHiQ5zw/+yAmpDlS6KiJnpEiILtVAgVAYeSfZhWIWXa0dXmFWGUtaOgUfenhZFSFJr1+vsPjoSPfWr4Qv7iq+4L4o8G5x7RrA5dgaAgA7beDxT8/01Vf/8vv34WiRgnv3XtadSIiy2XhZbLo8dpqGjKnrbJMsbRK1TiNXtWht6JYGLVkUmYSFZxV+xjlaIIYmgD2NYKZzoQ2cyBU1B8ApDKcGnsJanYFhCWhJYGURRtzQuCa0IbCZowbyeFCgbR+CJhq2LkXa+ZGzViBB7foI+3oBZqGwPTPtQl7Y/rzgxeswK/rnhNc20BnqffPdMWd6ArUJu222RwGZ3VFiIthGgjKJSVJWLP2bq1BgKEaU6HdpVcmrFHqQ1EmadMtH/VU39B2wbQn2+PGcOQvoHfvsH5AG8DbMfjEQbgEQ2sDXAJ5z1ge+/RbWda/Y98nSL2app9ld2nKZU0pjsk1JdtynlNlNhs4KOkve1+q9WeqrYxhM/ZQ1WsJAcpA4EhpFjPMxaU0z0ChylDAmYhA0SvHvQETFIdlD6iH2IDrESpCdpA5gApVAmoREbJnAViMQYEDTBiRaXAqq+QuNGWwZwEUXYPcecJEM/Bnchct9e+DcbH/ex0cYV0qQGA1hhOb3swm5HkY6k8pRd8INwDWhlYAVoDOCZw6dGngi6NRorwE/ceGUsNOKegbZmbGsknFVUtrk7NNivcp5OZVPbvytPF/C//lP+IMHcOCh4h6+2wH7OzAAMy43BE+efMkHD4Dnz2HD8JJdd5fjy+/NPrvNi0LhKk3JbEgpr7qc2VliZwldqd6bdb0l743WUxzcQyCkYZA0UholG2UhFIqYDcIQ72Hk2wyB2IPqCesE9ZobkQgdoAQxIcqOE8FYW05qLaTR6p/fNAbxRKiNfLA9HwTYnpWLA3zPd/hjG4QLD7UwZ/IBO8Nwfi9AbeBzN/DbeYXDxcYAdj0lp7ZtAKxBrCStSJ7Bo0pVjlMjThw4TcJJTThlrWcUzwq0NHKVqPXQ2aaOmspPXqbjWlarm/Xzz7+vwP/nwHO9LwPwgboAl0HamYCdWxDW8Zn++U/4q1cbXy7hZ3fGulpF2PDjqZbFos8vN7+UxbTKpWxy2fiULG3SDV8n0/potJXRVoZuybILHTLpdA4dsoUOjfbaiNdmfG3k63AR4j2HTjG7BdCpXGeMjMIzCUsRTSHmCq3oCOAaVGtTpkncK0XGroEpgUIwcgvI6s2HBLhzFeK8xaLP5Rhon+7iQogR8yS490J8/ncF7W2IQT+fbwe/EGNeiAsTIbz5OnK33qTabG9ghqM03WdiNJedAG1AbLQb/GsiNgjRtBZYA74RuSG5ccMkMTste0KRW/UuVUkuh+vVqHpb7n5TpbzU06dA9M0ALhrsd4UPTAT8dcz+Tyhj3wgAHj36hg8ffqmffnrWxMJP+fTphkdHYCkvhe4u8wgdH5+qvEq26Ea3bqzWRcTA0lDThFqKqiV0Zlasq6VW9bWgDJYyU9QJVCn3roGGCdDkCHHQ5ZOEKSXbSBpBTCAHA4YKjRb9Hwe5DyB7Qj2AzhiMAAg2EKxAKc5b2JBRcCRECLExfQPINueTjSU4wLCT3Jv9ue8uaOsuYO8jmBnAzl3YMwh777+np/C/jwtGaj4NJT+YfVi3mQGw5fIDkLuglss/z/pExPHZjGoYBVVGw5giIEMqACcAE8GNpE1oPVwJWBnmbtW+JtOKrg2gjYOTJUx05iovXYeSVGoZuqrs7jfhyjdU6yt9cYkA2O7BO8XvygDM2AohJB82Q/D1828AAI8fP0OsqPop8XRDHIH3ykt9txj12fEd/6mDpQQzi4jBnTte6WN1X1ZjX2joSlE12wsdwnJVzR2Qa+JgjoHCBPlEaRJsMmLj1UehGYKq0aHRwClcAgwABwN6kfOKRrv8AbT8ASBJ6kglRJe5pF3YsC03HevPiTLE9Gbt8SDQ8lbZpnptfSe2wa/LDEL7CGacNwhAO7z4+F2pQZgp+3mcH/S7z50f9DPF97hIAiCSwkz3CadDaL6+A06qAqwEi2xW9iPTU+Ak+ARhA2oNcAVoha0OgBXBlcMbG+DGwA0dUzXPiZZrVjGlqpVcHVw/r+THVaXc0fPnwP1/AnjwpR49Ah4+3Hvu3yF+RxrAr4F7D+I3cfz4GfH1eaEQeMnvvuus/zmZ3bvJMASwdLZJyy6nlIZkNiSb1l1O6KywM/OeNnTVy2BuvTsH9h4zunyMvUYyDQ6FDiCNAsZEi2NiYNMFBB8A9mphQ4WB6ST1IDo1YwAgAbHwCaLS0BRLn8/agAkwA8MAEORWKwhmAIhqDKBN95Ra73qgxbkIbAfyjgG8MeMTWyuwe+FSvGujcMkDet6nB4A3Z/p5vHCm+sKbW2TtzTH+aBTrIFrsXhV7Pj+BLDBDymBkfv6f9r5mO6oj6XbvyDynVJKw6Ct3e8HygLsWIzzkBXgJnsf28/ASvACza40YeMDCt7FpIxD1c05m7G8QeapKQvinv3b7R7VX43OqSi1EqWLHjh2RmWIrAYSVIvu3naq5APRe1IIVMZqOtGDWwmjLXLSqqazr6EOffajrPI6HXsbxsN55/7rifO34DQeAJvxFCGDCNUSwYxRe1zEwO+a7d8t0mmmL1ZhundyyVRqSDcxmNVlCHkvuzJir146WOjMPInD0ptq7oSdzrxoEsEsEJHsyJg+DCNgL6M3USegldgyzsDOyDREhA0yEMogkXSYDgBZ/YIAbmnFoaAQQ8UthUgZbQkBTCm2kAE0hxP0VQtiqgGsI4dLrm2fwE/hZYrg+wwMTB3wQ9IB2yWA36IkwSQAK2Er8RgbeyoAgAE7HybNC7jQWOSL4Y2fpQmJEtPUGAgOptcS1qDWdK1pIfsAWgi9BWxBYMNrBC3cuK+qSsGUyrcpo65zGdZ/ngw/rsRx6+dtQCz47rjiD40F4WxsCIPCxd+d/g78YAUz4OSK4w+fP/5/lfMpf2zqsybuZIdfKnt6IwKwzQ+9Tlq9l5kRPS62DEM+zKQHRewE9xJ5UB7BzR2+2mSLMcnSET+PEGUAiEQeaBCGYeLl9CMHEdjSVND3P9oa0tiLCO9BECvEnkmcEuRHQljA2wb9LCNO7/POkAPyC2N/B9vN4NeC3BPHLgh5R7mwk/pTpCbrQzoaEnIhsrzgZqnJ7RkQROcK90NquUM2sJSL4Aa7IOK+CxJLQ0sFlohYCl05fsnJp4LISKzOtarF1trLu88HgZT3WQeVS9r+/9qdP7+rRI3jI/6/0W2R/4C9LAABJTv+0MAqnV4IIbt16yfn8Ln9p63Acl/nQukRDNkMe63aGgG6de90hgtq7IuBN7EH0MmwUgtprYKgAir2obtMuZCsJIvCzwGxQIwIlgqEKYl8Zmwih7T5pEhMh6tLaAxKxH/XWM2gm4lVCEETsKATbJQBsiSLe558nhQnXk8P0GqfYvvJCy9XxN8d9k/shZLDTx78S9C3wKThI9/iwOxmZHmBl27sB0/kRQhFbxp/cf2EUMbAZf4DWLgyJWglcS1iZYSnHiolxpYcH4Fo5tSKxSsyrWsu6jhpy8qEMeTzo+rEcoozjRf1seVyxuCb7A/itCOBPaQL+ErS00Igg3sQPOgZP7/LZrdYxOJkpL485m0Gf1guvB52/vniTcqbnLP8kpboalC2VukqsNrJaYimllJn1ozJHeu1q4UhLA1R7wjpMykDsEe2+3qheQC9nb4md5H1sV44eYAcpE+wEdRQyqCyEP4DWMQBbtwAwxlqDqVQwAOZA4rRdGdjUgSzC90rJMAU/J7UwkYMIXjUVd7oMRAvYLVnsZOUW6Ffj/aNqQB/ctoCP70eEXw8ofjCBrbaPH1FBAtugFyC1VXjQlOndoTj9SYpj4xBTl3GGBFFsWs0Zrb9R0EjYQGAQtZY0GLh2YU1iZcTKgZUlrNx9RWBVoZW5rQxYqWjt5BqmoZY05qyxDrXMe5VyuKy1zP2zsTrKa+HBWk+f3sWjR18IXwP4Evitgh/4CxPAhOuI4GzqGHz/DR4/gn6qdZjOk1meec2wMa89rTyl3FdLpZgxe7VSWXIpXmbGUdlGeu2Y0gB6V8Wexo5qsh/oAetA7w3qvaonrXN5TA5SnYsdpQ6GjOgYZAjZ6NnFDGKzWzEcWVACmQQlg5moxC0ZJEBGg1Fsaw/YTEQ3kZupww0hTF5B8xKArTIgGZHGIAJNER1ewm72587/NuQAYGeeA+3/uv2Ik+1bSJuAR/s1ijGyyym7o+mAlvF3gx5tes/A2LgV7ro8Zl1JFHdUUm3OAqPHMXGjpBGwAa4RbHtKSgPEtdHWFT4kciXXGslWlK8hrCiuSa3ItK6oa9HWqc9rVA21YMhJw6zrRmdX6hy1loWXAv+2nGgxQA8ATbtlx+7Zvy3+siXAx7H78fuKQJy99vgxAHxBPHtJzO8S/Wu+OMiW0gnz1Dp8C3vfrdNJgi1TSbbu0zAiHx7VFJOFyDTmWr2jddncO1Kdm3Wu2pPWsaBnbtJ/CnxnJzQCgHWUOjFGiLlZXbjTKmxLjs2UJEbHIPyAJI8xY1GJkf2ncqGRwaaDsFUIkeUNcFOQwxT4lzwEcDr+Ot5IqJFCxHyogxbBoQhEMP7iHWK49BsAWr7fIQCPv1RqVwBTmS9gx9TbqekdCnNvGuxhZPttpo+zHLg542E7z68W/ACKpNHMBsRWbyPIGP4RBhrXEgayDfc416KvjVy7a/Oc0dduXHvFkJIGrxpymg21jOOs60YvKHWOUsqifvrpYcW3cNyDP3v2Ug8fxuTfb137T7iBBDDhQyL4qdbh5+mE2xkC2Pv3ExHMkq3HS0RwcJDSYundLCEXU2fMma7OzTu6BSkIPamOxq4UD3LYBL06iZ2ELoxBdaBltuB3qUM75ZhqHQN5hjE1goizDIQ0kQHagJGEZM1AxI6ByB2/AKBBHoYiuOks2KQELqmECHI0QgB2FcD2ukMUH8UU8JtrMMkm25NwxRiPMN23VXots/vVoCc5je9WhyqBAlghtHH3HSoER4BN7msUOJAY4Boj8GNKk+Ra3q7SYNSa5Lq4BpqtvWpIjsFNQzIMtZaxS/3Qd3n0GlvdT8Ffq/tnnx3Hz/3spZ6+u6vvv/9Gjx//9rX/hBtMABOuIYJrWoe7m5GYbWcIrhKBpZLMurRZcGTMNDRVgGzuXXV1XZdzdXUkO5ci6N06mjo4O0kdEjIVpqA7OsaBJbm2rcotgjtD4Q8YmSTPLdAzDIkexiHIRChJsQhJYCJgHyUETGSAti6BhGAwUdqqBGIT9Js/Cn9g8gi2VwC6/IajPTdl+qARtafZgh1xJeFtkMcBOWQxtUdVhPz/IOgVG7UWiFVE4dTTZ8h9kqOokWqr+BIHSSOFwaWRZAT+FPSxym+QY8g5FIGIwR2DmYZUMcht9FTGWsrY5TTWLo0HVeVtXdf5/NYm+Mex+mpV/P79tePpXeH7b4T/YvADewLYwc8RwR0C330wQ/ABEaxKOjo+svPWNRhG5INUU2lEwMJcPcjAXR27nOnekcwu70IJRJZ3V5eY8vRYRIYjk5vTi8IYlGcRoRDaIiNdWXBENlKY5glij4IkMAFKgFl4CEEK4NYrAHRpJJkAo1QQ4+tCDWinPKDCNJzeWG0VAsCtPNh8+oIFNCkAxDdtk3uMRTm7220hNuVwb5tzIHZj3mZ6K5AqGX18sEn9dhw8ydHdC2P9/kjDAHGU1JbyYjQ26U8MogYTBjENpIZSNBo1OGO+34jBvY652liTjV0uo1eV2qkc1MNyXtb1aFzWctyH7Af8+fPXbQPcu9q6/l9q8wb9F4JzTwA7CKMw7q9rHV5HBJ9/fsLvv9+WBmawxWKdzGgxVTgms5rGgnxgOY3GbHXIQQjMVhHEwIkYcgS8twNJHBlkltR5C3q2rcdcaETALHgogGYYik0RuLb3TR1AymQrDzYDRkiCEjcrExspKLwE7IwjI0jCQFmckIqNItB0TFqYAWze4IYEdgJ/Q7jb7E+1z6OMcCnqfUTGjyvZhnaak++xuR4Y8p6w4lBlC3oCBVIRUaBYmy94AWPPRlGjFNN9ke01kjaoajREcIsaaBjkPpqluLbAd/NRzjFZGt1b0GeUvnqpvUqtuZayqkdDX8uteS0FfmcdNT/wUrvBv637gf9G9gf2BHAtfg0RTKXBJSJ4C7PIxbZMQzo22MpKsnWXhhIThgcHKY2FmXXM7FNiRa6GzMq4tuAPMqiZZHYPD4BCdjAnMm2IAH6JEKbsL3oYhmBSIxBEyzAblSRktb0JGC3GIIDWVqQU1BbHpW/KA3BngVIjBHJLAMYIfOwoAUgEbUpu2zZi6zQijDwhPv0SmsO/4+qzbZSiMPJaho8hHu5kemtBT7JJfYxwtb4+R1CNADhKPoJsmT9UQKbi3jVaZ4PcR8lGp49pJ/C9oqRkUd93KF1V8TrW2ns5LF2tR7PqP7z2/3NrVr978Vbr07t+rxl+797dnRz/3yX4gT0B/CT+LSKYzMLz18bTQ5rFZOEto61WfTo6pq2G8AloJZE5iMBqqhWZTIlWcq3IHVOqjszsiY7s3qR/tPmyEznBkreuANxzSkwTEXgrFyK4p81KkUkl33gGaFOGO/7BtEcBm5EYBmGYiTDjRAa7i5QQ6xJA2aQIhLbh6eQDTGVAy/1ScxbiPpRAPG5Zv10VwztCDO+ECoi99+Axr98IIZZPt1pfbZiHjJ15oHD5SY4SRmvZX6ZRztHEUS2wO2KQBTmY2Tg6SvI6utkoqUTGV/GM0jtK7VTcu+o+1FrX9fCwq/5aXkf5p58c1hf1XJ+vip8Np3rwAA480JMnTxCGX5P907vyX8SeAH4BfhkRXO4apHTCO3bBH9pkob2jWWKoguYTrIYxHR7C1kOXyJJGq4ljTqUO2SwlMiXSU3Xkjp5qZaZZe445Zyb3mkELgmAEN515Uy5YdAg26gDWVINnTsuQqSAN42bNgaridYZxGHME4Rm4kMxg2lmXwKYGaOJWGZBCrFgEWu6nKG+lgEWRj7gXm+Sf6n7s1vtS9SgFqoGb49rdtdmkI+S9Yi8+eZmCfpL6gIoY+0CKLeDpY9TwGlVQZBxlHM19TGajXMWTjXIU97HkuY2+suoVpe9Q3Mdau3mZ+1DfubyUVS1Ffnzch8s/Vv+2nKiU6+p94PcMfmBPAL8Kv4oInr8m8im/m8HMLpjemNnfD2kGs4soD2iw1WpIPKYNQ0lz0gbLycaaZgewccyJVhOZUimepuAnLdWhZnLnsdecs6XI+hbE4MjMEznEugL65A+oZX+LcsDaY27ahbEk2ZsSgJKLiRMhMAjAaFEOTKqgrUcAFIoApGLBEiGRZpCLtKkMYAh8Y0vw5pCi5bfp6cdiHRoKoKq2Np9EEIAxgnvaiPPaoI8grxNRyEczjhKKnKOZRkhFjmJm4yiV5Chp1oI/o2hdapdVlp5r1zL+FPiHZVa9wL3A68krL+UffmcNf15eaxhOtVxelvzxuflqJ/h+n0DcE8C/gZ8igs1ehW2g6Hlba3AvnxOTT3AO4+mSkyp4n2BhGsJImg0lkbRhzOngADaWmkgYmRNLTZzBWFIqLfhZPYFK4REEKbgzAp6eSbbXonRgsuTuObXnSSaf5D+ZbfIDqKS67SL4ZBIiygGDmUs7asDCIyDM5ZMy4MYbQFuFaAgSAFrgA9h2AARBit2M2tz+NNRjxZuzD0cVp5ZeC3pqlFCMGCuCBCBvrb72NeZjLShGbglAiMDv43F2FE8ow7rWnFW6PCvupcpLdU/V61h9lqvvBv4n8FrhpcBrPdfnnxfH2amwfCk8jKz/5Anw+PHlep8E9DsG4Z4A/hf4KBHsDBQ9exaLjh48ACafIKUTXlIFb9/YRaadnByQ72GLiQxWNBrMCBtSTQex0s+GMSWSRqupFE993xmLp2JbQiBTWnvJHS2hKQLCwuxrgZ8m6d+ej/tJ9m8DH80jcHmmMzmVzMILcCgZYfLoHkhtzwIg6Ey+nSGYCCA+9EEAOwaggYqJPnNJorG6eyOB2GOfRBGtwFXFCOQIYsU9vFjbhZc7Qd/q/yJGDW9CSWajTEWj19iiSyWnrki1uqt4TVV9qX1N1b0F/Tv4/KCv5/XcS5F/Um57PYH/vcBfTIGPU20d/gfCkyeI/j7wR8j6u9gTwH8Au0QQvtXXBHZGjJ9+QTwCpvLg+fMdVZBO+H1+ZeQxP7VDvnkLu8jndsIDvk8wW9KOjnuSsJUtjKRxHeqAhG0VAo2sCew/IIPavAR6qIPrCAG05ONUVsTgELAtC4gIfHiUAVE6TNmfaVICiJxuLiWQZBiFhEd3oE0JY5oMjGE+CoQMkDtEg8slku08RVWQlYbitQ35QGWq/dXGeScyMPooxTbcQQwR9LL2tVJJhpKUy+Bec1aR16q11e4QxT1Ftu9T1QLus666X/jhYVfd5e7yWuXShUr5R8v4/9eBf20C/+lT4I8m96/DngD+g7hMBMB2oAjY9Qkuq4LXBE6JF+f857+S2Z0FyWOahTKgHdASDTbjwi7smD1psCVpXIc6oDEGdbhbLngie2OtqdBTx84KfaMO6lQ+eBACoVRbcJOWQE90bUoHRxBDohkmPwBKvkMCALdeQOsSxJxw8wAi9xMuYuMFtNrfWs+/HcKhVv+bsUpqC3jaFl1T4BPFhCJEy2+S9HAUWWsFKu6TVEZZTYbijiLVGtk+ZH3flSrP1X2scvnBLNcLh7vLDw9n1T227KqfyGt1dz9WvSbjXw38P5Lcvw57AvjNwE3wf1geAJdMw7PwCu7fByYyQDoh7II/vDGzdEieLknOaRfnxpMDvn8PO+askcHCbB1EsCbNhjAYSVqYiUEGpdTUz2ClBAmAsI1CqJ7YwVB3jUXtKIZQAYmwUAKWHNo8JszgsZEpW/A7YHAYKRpIhyy4QXSJFqkeRgqgABfAGAJq7r9XOC2O15Jir8YqVbMIbiOKlIqZghQMRcXr9UFvVV6r51qPclekXFdaeV9TXQje92PVhXx+kKuOIvj140r+yW2vFe5+Ife3urO+G0t37/95A3/CngB+c2yJIHBZFUym4bNnL/nwIYCzu8SkDL495Yt8zskzMDsmuaDZIckwEXn7gO/fv7Nb7Lkw2hF7Lgmz9cJojJLBQh2EfzCVC40QDFboCaSxWmLXSKGmhHYfJUGyUAmeMpNVKrkrJcCcTG3CZ2MCogW/E5YguocHADAGkV3b98EYq/IhmZlX12aRj4k1pntZZaxmKJBqEaupHbllqah4TYYyqtZkKBqtuu0GfaqdSt3U9X2qvoAf9F19L7g7/NDfueqt2J23ZftPqzv8WC/quUpr5w3DqR5szL0Hiq27/1yBP2FPAP8lXC0PdlXBdjnytBIRAF7y7CzKhMkziNFjAN+d8J87hJDe0mhz0la8SLRPdsqF5WQmHnbkenmJEAbSOIZCmBmMfW+l1gQwCKOpglKjhKjtca2eMrNV344JT9dLCqC25yBGNdCORXQPipjgAMxCAchkkFdImxKgwmFeTVZhrHG0lldoCnLWlBBHbrnVjbzvStUa7jXVvi9VLejl8INZV+VwHcIl+Js3K926JdfrherJ6Tbb37nrwGsBpzo7A5bLl3rYXH08wcbc+7MF/oS//IYgfxRc/kCQ27HP7QYl7TA4hTKAXr0KAjg/X/Phw5ehDgDg/WsuGyGkdMJ6dOGf4QI/vDGbp0OW0yVnPOaPF2EmIvVcjBd2nHYJYWRah0KoB7QywDiWRg4ykoauEQGYKoohbxYHpSJZZ7RKbDI/6jb4a6mhBGREMqIqgj8WELX5vwSgAow3CDBBUoUrITksSgFadYnVJRdYE1SBVJW90q0CtdpoVdmriNp1ua5WclG1n6fKhbwMyQ/YVSW4bsHfvF3ruMq9l0tzzecHPgwX8qNT1fWU7dfCGYQHa8XvA3j06Ec9efJjTPA9BiZz78svt4H/5wj9wF4B/I740DS8OlfwEXXw7CXP5lt1cP8+8HPlAjnnxUQIVxQC0HMqGdakzZkJwgbCOMLIwUjaSBhLlBJRUsBQaF1nLO0xC6yQluGsFYbOyOlA5BrXSufVzCM1BQAT5EoJXopJCS7Jc/IqwDXAlazmbBXD4MqpuluVBu87q6slvO9SdX2Y6fF2La9yvxVB//33C92+vTX0ymZi71RnZ99gufxby/aXZX5s1bUl8D9Txr+KvQL4HbH7oZnIYFcZAMLjs6/b/Y46eAi9erpVBwBwtgAfPDjZlAv37gF4MfK7BJpVmoEHBx1Hm5EMhVC44vqC9omBi5Ubb/W8xZ7L1cLWBpuzoxEGGmmwOkTwo0/kOBhBY2eslLdHMnUAAAX9SURBVNUR1vWJBbBOzkIaspMSY+sBJ1MiqjMnopQggdL+dRkSlKQcu3rV0dTF/kY+jlWlwHO2yg4uudfi3vVdleBm8IV3bmmsdggfdeBzvybTz+fy7xeqM3d36Oho1HK5G/TAcjll+y/w6NE3LdtDwBfYjO1uCDp+f3/O0A/sCeAPgg8zCNk+bJcIIdIP8OgR1NSBgMd49ersUrkQ/sEJ3u/6BwB2CYF0zueHLG+WnKVjcrVivQ2OpVpiz54dl8v3xuOOXC0tsSPmHW0tA42DwWYwDgPs4KByGIsRiZVOIpNjsREkOLDveoCVUCIAMMb7QAA5J2EE0FVRScNY0OXsFVVdkRdkAfC00x2Q5CXJ54K/X4zKVT6a/NDlb32tvgX9fD7XuBP09WhUWZ7oXnPxLwf9FYmPL3B2Bmx7+F/tlCt/DewJ4A+LD9VBfPomQhDOdtTBVUJ48OqMuEIIeIDrCeGo0l6DTM5PDxcos1skl/zXu5VZLjxZZyIZycTFuYwcyeOOhsKL9WBz61hGZ0ImWEjmyPp9xwMWAh2HoRBMnPXCMNZLrZFaCvo+aT0YoCL2nRJGrVZZo4r6vjiQVEY4NMpn8Lkd+vvzQXUun91OrvOV3qxn6m/J569n+v91ods/EfS4EvR48iMetaB/fKW2b++32tv+l8LeA/gzguSHH0QBX3/NrTzFZuYAeAw8PSMexRDSw4fA1Q7DPQCTh3DnDvDPf+76CEvyzSHDITggbc13PKDZQLInOe5cO2JZSHY8nANLdsRqJFkIzEGMm9hfsfJAafMvEToBS0jTKeqjpFGYZ+lilNTpcC5/p0FHR7dcb1aSr3T7k9v+gy8kHSrc+21Nvxv0U+tu27MHtpN6wOWVeX/u2v6XYk8AfwlcnTUAWrlw+fkdQnj69GwzlXiVEO7fB779dlclNGPx9YL4+z+wSwrntubt27dBrsh3B3zHNc0GHuMWyDXfc+QRjrHgwCMAi8VIHB0BAA4BLKaf7f17HB52eg/gUL2gtS4ASIPce93STPKV5AeSLyVfyOtcn952x2fH+u67l6j16IqR9+uDPnBzgmJfAvwl8HPlQrv9iZJh10MAgMXiGwJf4Hn/msBr5PyO9w7v4cV6IoVT2tEF58gYR5D/cuJ0gbkd8s0b58HfluD5mrPbt1EAzN46ywmwHgo/WcdPUT8BZm/j/m0u6GdJs3PgX1jhEz/Q7GQp/Jih2zMNLcPje8BPq9xPdaeeC8sTAa/1/v0M9++fbNx7NHn/4Iq8D+wG/VftenOCfhd7BfAXx3WtxsCHJcO25dhGlQFcLht+5INGCvcBoCmFe/eAFy+2auEOgH/aBQHAXh8Tfwf+DuCHfy2I0+3f9ymAH3AZn+pQ37d79wvF9Vh36rleAPi8nOhbAJey/IOXevYMeLiT6aelt9vvfLMz/cewJ4Abhp8ihK+//vrSDAKAnbJhd/3ClhSAbfkAtBICwLf5HYF7uAcA94IgAODz6ftubhpeAC+mlz4/Eb4FvgVw795r4TnwHMD94VRnuC7go0+/D/pfjz0B3HD8pEIA8IGPAFwihV0/AWjEAADtP2dn3xFALG94gJ/HWZt4APDgwR0BzzAFOwD8VMBf3lhzF/sP+cew9wBuOK53udsMQvuSna+Oy8ZLACY/AQDw5Bs+fLz79X/Dq1e/kgBeAa/a7YMHfxPwIx4+BPDkxxi9f/yFgiK+wOMzYDfLT+rlJrj3/ynsFcAevxDXdRqAS/xwtQ35ETx58g0BbETEk3a9LN+v4Os2gfvldbIe2Gf5fw97BbDHL8TPKoUrU4vAx6Zmzi4piK3kj2x+Fe37fzlN4H4Vz+6z/H8EewWwx38cH/cV/j3sg/23w54A9tjjBmN3W4Y99tjjhmFPAHvscYOxJ4A99rjB2BPAHnvcYOwJYI89bjD2BLDHHjcYewLYY48bjD0B7LHHDcaeAPbY4wZjTwB77HGDsSeAPfa4wdgTwB573GDsCWCPPW4w9gSwxx43GHsC2GOPG4w9Aeyxxw3GngD22OMGY08Ae+xxg/E/MRoRiU+/lpgAAAAASUVORK5CYII="
          />
        </g>
      )}
      <g id="ba6b9098-cb61-41c0-8152-f788d836f189">
        <g>
          <path
            d="M60.66,163.72s-7.14,7.75-.07,13.38,89.92,33.51,95.92,37.51,95.56,7.85,95.56-43.55C252.07,140,60.66,163.72,60.66,163.72Z"
            fill="#a13172"
            opacity="0.47"
          />
          <g>
            <polygon
              points="198.35 128.19 197.61 194.67 156.51 214.61 157.28 145.72 198.35 128.19"
              fill="#c04d00"
            />
            <polygon
              points="156.51 214.61 51.49 171.05 52.21 106.6 157.28 145.8 156.51 214.61"
              fill="#af4904"
            />
            <polygon
              points="156.56 209.94 156.49 216.21 144.37 210.85 144.43 204.8 156.56 209.94"
              fill="#7c3709"
            />
            <polygon
              points="144.42 206.28 51.41 167.63 51.57 164.09 144.34 202.06 144.42 206.28"
              fill="#8e3f09"
            />
            <line
              x1="146.79"
              y1="203.09"
              x2="51.63"
              y2="164.15"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <path
              d="M156.07,210.39h.48a1,1,0,0,0,1-.9l.1-9a.94.94,0,0,0-1-.92h-.49a1,1,0,0,0-1,.91l-.1,9A1,1,0,0,0,156.07,210.39Z"
              fill="#573828"
            />
            <polygon
              points="63.81 170.6 63.74 176.88 50.87 171.5 50.94 165.46 63.81 170.6"
              fill="#7c3709"
            />
            <polyline
              points="156.49 216.21 167.39 210.61 167.46 204.68 156.56 209.94"
              fill="#c04d00"
            />
            <polygon
              points="187.69 201.11 198.58 195.51 198.65 189.57 187.76 194.49 187.69 201.11"
              fill="#c04d00"
            />
            <path
              d="M197.55,189.45H198a1,1,0,0,0,1-.9l.1-9a1,1,0,0,0-1-.92h-.48a1,1,0,0,0-1,.91l-.1,9A1,1,0,0,0,197.55,189.45Z"
              fill="#573828"
            />
            <polygon
              points="155.2 200 140.99 193.81 129.67 193.02 129.64 195.3 139.41 202.7 154.97 209.01 155.2 200"
              fill="#573828"
            />
            <path
              d="M156.19,210.16A1.19,1.19,0,0,1,155,209l0-1.37c.85.92,2.46,0,2.46,0V209A1.2,1.2,0,0,1,156.19,210.16Z"
              fill="#472d22"
            />
            <path
              d="M156.28,202.63a1.18,1.18,0,0,1-1.22-1.15v-1.37c.85.92,2.46,0,2.46,0v1.37A1.19,1.19,0,0,1,156.28,202.63Z"
              fill="#472d22"
            />
            <path
              d="M129.77,195.3q2.52,1.83,5,3.72c1.65,1.26,3.32,2.49,4.95,3.78l-.08,0c2.6,1,5.21,2.05,7.8,3.12s5.18,2.11,7.75,3.23l-.36.24c.13-3,.27-6,.49-9,.06,3,.06,6,0,9v.37l-.36-.13c-2.62-1-5.2-2.06-7.81-3.08s-5.18-2.13-7.77-3.19l0,0,0,0c-1.63-1.29-3.21-2.63-4.82-3.95S131.34,196.66,129.77,195.3Z"
              fill="#352119"
            />
            <polygon
              points="51.59 165.49 66.99 171.52 78.33 171.2 78.31 170.26 68.45 162.96 51.65 156.34 51.59 165.49"
              fill="#472d22"
              opacity="0.43"
            />
            <path
              d="M155.19,200.23c-2.4-.94-4.8-1.92-7.18-2.91s-4.76-2-7.12-3.07l.08,0c-3.77-.28-7.54-.6-11.3-1,3.78.11,7.55.32,11.33.57h0l0,0c2.38,1,4.73,2.07,7.1,3.11S152.87,199.1,155.19,200.23Z"
              fill="#ad9b90"
            />
            <polygon
              points="51.61 164.12 67 170.15 78.33 171.17 78.33 168.89 68.47 161.59 51.67 154.97 51.61 164.12"
              fill="#573828"
            />
            <path
              d="M78.33,171.06a2.83,2.83,0,0,1,0-2.28,2.94,2.94,0,0,1,0,2.28Z"
              fill="#ad9b90"
            />
            <polygon
              points="157.53 200.7 164.34 197.35 164.24 206.13 157.43 209.38 157.53 200.7"
              fill="#573828"
            />
            <path
              d="M164.24,206c-1.08.66-2.18,1.26-3.29,1.85s-2.24,1.16-3.37,1.71l-.5.24v-.56c0-1.45,0-2.89.11-4.34s.17-2.89.34-4.33c.14,1.45.19,2.89.24,4.34s0,2.89,0,4.33l-.5-.32c1.14-.53,2.28-1.06,3.45-1.53S163.05,206.44,164.24,206Z"
              fill="#352119"
            />
            <path
              d="M157.53,200.59a27.8,27.8,0,0,1,3.3-1.89,29.22,29.22,0,0,1,3.51-1.47,30.82,30.82,0,0,1-6.81,3.36Z"
              fill="#ad9b90"
            />
            <polygon
              points="191.83 183.12 197.39 180.89 197.3 188.88 191.73 191.5 191.83 183.12"
              fill="#573828"
            />
            <polygon
              points="187.85 142.46 187.82 144.63 192.23 146.73 192.23 146.78 197.8 144.16 197.89 136.17 192.32 138.4 187.85 142.46"
              fill="#472d22"
              opacity="0.43"
            />
            <path
              d="M198.06,143.7h.48a1,1,0,0,0,1-.91l.1-9a1,1,0,0,0-1-.92h-.48a1,1,0,0,0-1,.91l-.1,9A1,1,0,0,0,198.06,143.7Z"
              fill="#573828"
            />
            <polygon
              points="187.86 141.44 187.83 144.29 192.24 145.7 192.24 145.76 197.81 143.13 197.9 135.14 192.34 137.37 187.86 141.44"
              fill="#573828"
            />
            <path
              d="M187.83,144.29c1.51.33,3,.74,4.49,1.15l.19.05v.27l-.38-.25c1.82-.94,3.67-1.84,5.53-2.69l-.19.3c0-1.33.06-2.66.14-4s.15-2.66.29-4c.11,1.33.17,2.67.2,4s.06,2.66.06,4v.22l-.2.09c-1.85.9-3.71,1.75-5.6,2.56l-.41.18,0-.43v-.05l.19.26C190.71,145.43,189.25,144.9,187.83,144.29Z"
              fill="#352119"
            />
            <polygon
              points="114.68 190.03 120.93 192.48 121.6 132.59 115.35 130.13 114.68 190.03"
              fill="#96440c"
            />
            <line
              x1="120.87"
              y1="192.37"
              x2="121.54"
              y2="132.47"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <polygon
              points="98.14 183.37 104.39 185.82 105.12 119.99 98.87 117.54 98.14 183.37"
              fill="#96440c"
            />
            <polygon
              points="83.43 177.18 89.68 179.63 90.41 113.81 84.16 111.35 83.43 177.18"
              fill="#96440c"
            />
            <polygon
              points="55.22 156.37 61.47 158.83 61.87 123.69 55.61 121.23 55.22 156.37"
              fill="#96440c"
            />
            <polygon
              points="147.85 196.69 154.09 199.53 154.53 160.55 148.28 158.06 147.85 196.69"
              fill="#96440c"
            />
            <polygon
              points="148.35 151.89 154.62 152.53 154.71 144.31 148.45 142.54 148.35 151.89"
              fill="#96440c"
            />
            <polygon
              points="198.35 128.19 157.28 145.82 52.21 106.6 92.53 89.41 198.35 128.19"
              fill="#f4c737"
            />
            <path d="M93.28,89s-27.94-12-41.07,17.64Z" fill="#96440c" />
            <path d="M198.34,128.64s-27.93-12-41.07,17.64Z" fill="#c04d00" />
            <g>
              <ellipse
                cx="79.7"
                cy="97.18"
                rx="0.55"
                ry="1.81"
                transform="translate(-18.22 175.97) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="81.52 96.93 81.51 97.2 77.89 97.17 77.9 96.89 81.52 96.93"
                fill="#d1a11e"
              />
              <ellipse
                cx="79.71"
                cy="96.91"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -17.95, 175.7)"
                fill="#f9df1e"
              />
            </g>
            <path
              d="M189.79,122.67,84.56,86.59l-9.25,1L175.46,122S184.65,120.27,189.79,122.67Z"
              fill="#af4904"
            />
            <polygon
              points="144.42 206.28 144.38 209.59 63.56 176.06 63.59 173.39 144.42 206.28"
              fill="#af4904"
            />
            <line
              x1="104.69"
              y1="186.17"
              x2="105.36"
              y2="126.27"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <line
              x1="89.74"
              y1="180.2"
              x2="90.4"
              y2="120.99"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <polygon
              points="63.49 176.87 65.1 176.32 65.16 170.27 63.56 170.83 63.49 176.87"
              fill="#7c3709"
            />
            <polygon
              points="65.29 170.52 51.3 164.47 51.31 165.46 63.7 170.91 65.29 170.52"
              fill="#a34607"
            />
            <line
              x1="167.41"
              y1="209.24"
              x2="167.52"
              y2="204.68"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <polyline
              points="187.69 200.99 187.82 194.38 198.65 189.57"
              fill="none"
              stroke="#af4904"
              strokeMiterlimit="10"
              strokeWidth="0.71"
            />
            <path
              d="M191.36,191.44s4.3-43.31-10-44.93-16.52,23.92-16.63,33.84,1.2,30.3,1.2,30.3l25-12Z"
              fill="#4f8e26"
            />
            <path
              d="M191,198.52c.07-2.68.09-5.35.24-8s.25-5.33.27-8a128.52,128.52,0,0,0-.61-15.95,68.32,68.32,0,0,0-1.28-7.83,27.43,27.43,0,0,0-2.66-7.31,11.09,11.09,0,0,0-2.37-2.88,6.75,6.75,0,0,0-3.26-1.4,9,9,0,0,0-6.91,2,14.1,14.1,0,0,0-2.55,2.78,25.89,25.89,0,0,0-1.91,3.37,41.62,41.62,0,0,0-2.49,7.46,85.78,85.78,0,0,0-2.06,15.74c-.21,5.31,0,10.66.09,16s.32,10.69.48,16c-.93-10.66-1.79-21.3-1.76-32.06a79.46,79.46,0,0,1,1.88-16,43,43,0,0,1,2.52-7.75,26.08,26.08,0,0,1,2-3.61,15.77,15.77,0,0,1,2.82-3.13,10.15,10.15,0,0,1,3.79-2,11.36,11.36,0,0,1,4.26-.31,8.26,8.26,0,0,1,4,1.75,12.7,12.7,0,0,1,2.67,3.29,28.74,28.74,0,0,1,2.75,7.72,59,59,0,0,1,1.16,8,126.92,126.92,0,0,1,.18,16.08c-.14,2.68-.34,5.35-.62,8S191.23,195.85,191,198.52Z"
              fill="#335b1a"
            />
            <g opacity="0.64">
              <ellipse
                cx="140.18"
                cy="199.04"
                rx="1.08"
                ry="1.79"
                transform="translate(-86.28 109.69) rotate(-33.31)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="140.19"
              cy="198.69"
              rx="1.08"
              ry="1.79"
              transform="translate(-86.09 109.63) rotate(-33.31)"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="68.27"
                cy="166.75"
                rx="1.08"
                ry="1.79"
                transform="translate(-80.36 64.89) rotate(-33.31)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="68.28"
              cy="166.4"
              rx="1.08"
              ry="1.79"
              transform="translate(-80.17 64.84) rotate(-33.31)"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="57.49"
                cy="162.43"
                rx="0.44"
                ry="0.73"
                transform="translate(-79.76 58.26) rotate(-33.31)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="57.64"
              cy="162.07"
              rx="0.56"
              ry="0.92"
              transform="translate(-79.54 58.28) rotate(-33.31)"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="149.44"
                cy="202.89"
                rx="0.82"
                ry="1.34"
                transform="translate(-91.57 129.34) rotate(-36.66)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="149.39"
              cy="202.55"
              rx="0.79"
              ry="1.31"
              transform="translate(-86.7 115.32) rotate(-33.31)"
              fill="#ad9b90"
            />
            <ellipse
              cx="156.31"
              cy="199.72"
              rx="0.63"
              ry="1.23"
              transform="translate(-44.81 354.23) rotate(-89.48)"
              fill="#8e6a5a"
              stroke="#573828"
              strokeMiterlimit="10"
              strokeWidth="0.12"
            />
            <polygon
              points="155.83 154.48 141.61 148.3 130.3 147.5 130.3 147.5 140.04 157.18 155.61 163.15 155.83 154.48"
              fill="#472d22"
              opacity="0.43"
            />
            <polygon
              points="155.85 152.77 141.63 146.59 130.32 145.79 130.29 148.07 140.06 155.47 155.62 161.78 155.85 152.77"
              fill="#573828"
            />
            <path
              d="M130.41,148.08q2.53,1.81,5,3.71c1.65,1.26,3.32,2.5,5,3.78l-.08,0c2.6,1,5.21,2.05,7.8,3.12s5.18,2.11,7.75,3.23l-.36.24c.13-3,.27-6,.48-9,.07,3,.07,6,0,9v.37l-.36-.13c-2.62-1-5.21-2.06-7.81-3.08s-5.18-2.13-7.77-3.19l0,0,0,0c-1.62-1.3-3.2-2.64-4.81-4S132,149.43,130.41,148.08Z"
              fill="#352119"
            />
            <path
              d="M155.84,153c-2.41-.94-4.8-1.92-7.18-2.91s-4.76-2-7.12-3.07l.08,0c-3.78-.28-7.54-.6-11.31-1,3.79.11,7.56.32,11.34.57h0l0,0c2.38,1,4.73,2.07,7.1,3.11S153.52,151.87,155.84,153Z"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="140.83"
                cy="151.81"
                rx="1.08"
                ry="1.79"
                transform="translate(-60.23 102.28) rotate(-33.31)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="140.83"
              cy="151.46"
              rx="1.08"
              ry="1.79"
              transform="translate(-60.04 102.23) rotate(-33.31)"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="150.09"
                cy="155.66"
                rx="0.82"
                ry="1.34"
                transform="translate(-63.25 120.39) rotate(-36.66)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="150.03"
              cy="155.32"
              rx="0.79"
              ry="1.31"
              transform="translate(-60.65 107.92) rotate(-33.31)"
              fill="#ad9b90"
            />
            <ellipse
              cx="156.96"
              cy="152.49"
              rx="0.63"
              ry="1.23"
              transform="matrix(0.01, -1, 1, 0.01, 3.06, 308.07)"
              fill="#8e6a5a"
              stroke="#573828"
              strokeMiterlimit="10"
              strokeWidth="0.12"
            />
            <path
              d="M78.35,168.91c-1.62-1.17-3.25-2.33-4.85-3.53s-3.2-2.39-4.8-3.61l.06,0c-2.81-1.07-5.6-2.21-8.4-3.33S54.8,156.17,52,155c2.84,1,5.66,2.06,8.47,3.13s5.62,2.16,8.41,3.29l0,0h0c1.58,1.23,3.16,2.46,4.72,3.71S76.8,167.65,78.35,168.91Z"
              fill="#ad9b90"
            />
            <path
              d="M50.71,164.43h.48a1,1,0,0,0,1-.9l.1-9a1,1,0,0,0-1-.92h-.48a1,1,0,0,0-1,.91l-.1,9A1,1,0,0,0,50.71,164.43Z"
              fill="#573828"
            />
            <path
              d="M52,155c.12,3.05.17,6.1.21,9.15l-.17-.25c2.59.95,5.15,2,7.72,2.95,1.29.48,2.56,1,3.85,1.52l3.83,1.53-.08,0,5.47.63q2.73.33,5.46.72c-1.84-.09-3.67-.2-5.5-.33l-5.49-.41h0l0,0L63.4,169c-1.28-.5-2.57-1-3.85-1.5-2.56-1-5.12-2-7.67-3.08l-.18-.08v-.18C51.78,161.07,51.87,158,52,155Z"
              fill="#352119"
            />
            <polygon
              points="52.7 121 68.1 127.04 79.43 127.05 79.42 125.77 69.56 118.48 52.76 111.85 52.7 121"
              fill="#472d22"
              opacity="0.43"
            />
            <polygon
              points="52.72 119.97 68.11 126.01 79.43 127.03 79.43 124.75 69.58 117.45 52.77 110.82 52.72 119.97"
              fill="#573828"
            />
            <path
              d="M79.43,126.91a2.94,2.94,0,0,1,0-2.28,2.83,2.83,0,0,1,0,2.28Z"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="69.38"
                cy="122.6"
                rx="1.08"
                ry="1.79"
                transform="translate(-55.93 58.25) rotate(-33.31)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="69.38"
              cy="122.26"
              rx="1.08"
              ry="1.79"
              transform="translate(-55.74 58.19) rotate(-33.31)"
              fill="#ad9b90"
            />
            <path
              d="M79.46,124.77c-1.63-1.17-3.25-2.33-4.85-3.53s-3.21-2.4-4.8-3.61l0,0c-2.81-1.07-5.59-2.22-8.39-3.33s-5.56-2.3-8.33-3.5c2.84,1,5.66,2,8.48,3.12s5.62,2.16,8.41,3.3h0l0,0c1.58,1.23,3.16,2.45,4.72,3.71S77.91,123.5,79.46,124.77Z"
              fill="#ad9b90"
            />
            <polygon
              points="158.04 154.61 157.96 162.26 164.76 159.36 170.38 152.45 170.27 150.74 164.85 151.6 158.04 154.61"
              fill="#472d22"
              opacity="0.43"
            />
            <path
              d="M51.81,120.28h.49a1,1,0,0,0,1-.91l.1-9a1,1,0,0,0-1-.93h-.49a1,1,0,0,0-1,.9l-.1,9A1,1,0,0,0,51.81,120.28Z"
              fill="#573828"
            />
            <path
              d="M53.14,110.83c.13,3,.18,6.1.22,9.15l-.17-.25c2.58,1,5.14,2,7.72,2.94,1.29.49,2.56,1,3.84,1.52l3.84,1.54-.08,0,5.46.63c1.83.22,3.65.45,5.46.71-1.83-.09-3.66-.2-5.49-.32l-5.49-.41h-.08l-3.86-1.49c-1.28-.5-2.58-1-3.85-1.49-2.56-1-5.13-2-7.67-3.09l-.18-.07V120C52.89,116.93,53,113.88,53.14,110.83Z"
              fill="#352119"
            />
            <polygon
              points="158.06 153.36 157.97 161 164.77 158.1 170.38 151.99 170.29 149.48 164.86 150.34 158.06 153.36"
              fill="#573828"
            />
            <path
              d="M156.72,163.16h.48a1,1,0,0,0,1-.9l.1-9a.94.94,0,0,0-1-.92h-.48a1,1,0,0,0-1,.91l-.1,9A1,1,0,0,0,156.72,163.16Z"
              fill="#573828"
            />
            <path
              d="M165.89,168.1h-.48a1,1,0,0,0-1,.91l0,2.5a1,1,0,0,0,1,.93h.48a1,1,0,0,0,1-.91l0-2.5A1,1,0,0,0,165.89,168.1Z"
              fill="#573828"
            />
            <path
              d="M156.84,163.27a1.18,1.18,0,0,1-1.22-1.15v-1.37c.86.92,2.47,0,2.47,0l0,1.37A1.19,1.19,0,0,1,156.84,163.27Z"
              fill="#472d22"
            />
            <path
              d="M156.92,155.4a1.18,1.18,0,0,1-1.21-1.15v-1.37c.85.92,2.46,0,2.46,0v1.37A1.2,1.2,0,0,1,156.92,155.4Z"
              fill="#472d22"
            />
            <g opacity="0.64">
              <ellipse
                cx="162.03"
                cy="155.89"
                rx="1.34"
                ry="0.82"
                transform="translate(-60.51 188.01) rotate(-52.11)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="162.1"
              cy="155.55"
              rx="1.31"
              ry="0.79"
              transform="translate(-57.96 200.78) rotate(-55.43)"
              fill="#ad9b90"
            />
            <g opacity="0.64">
              <ellipse
                cx="194.7"
                cy="140.57"
                rx="1.34"
                ry="0.82"
                transform="translate(-35.81 207.89) rotate(-52.11)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="194.77"
              cy="140.23"
              rx="1.31"
              ry="0.79"
              transform="translate(-31.22 221.05) rotate(-55.43)"
              fill="#ad9b90"
            />
            <path
              d="M164.65,158.1c-2,1.31-4.14,2.46-6.28,3.56l-.51.26v-.58a61.27,61.27,0,0,1,.44-7.64,61.19,61.19,0,0,1,.26,7.65l-.5-.31C160.21,160,162.39,159,164.65,158.1Z"
              fill="#352119"
            />
            <path
              d="M158.55,153.25a26,26,0,0,1,3.31-1.72,28.05,28.05,0,0,1,3.49-1.3,26.6,26.6,0,0,1-3.3,1.73A27.17,27.17,0,0,1,158.55,153.25Z"
              fill="#ad9b90"
            />
            <path
              d="M192.33,137.37a15.09,15.09,0,0,1,2.39-1.17,14.1,14.1,0,0,1,2.56-.72,14.29,14.29,0,0,1-2.39,1.17A13.66,13.66,0,0,1,192.33,137.37Z"
              fill="#ad9b90"
            />
            <path
              d="M164.86,150.34a15.47,15.47,0,0,1,2.66-.6,14.51,14.51,0,0,1,2.72-.14,14.43,14.43,0,0,1-2.66.61A15.4,15.4,0,0,1,164.86,150.34Z"
              fill="#ad9b90"
            />
            <path
              d="M187.86,141.44a19.92,19.92,0,0,1,4.62-4.1,20.55,20.55,0,0,1-4.62,4.1Z"
              fill="#ad9b90"
            />
            <line
              x1="153.67"
              y1="198.84"
              x2="154.08"
              y2="162.11"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <line
              x1="154.56"
              y1="152.3"
              x2="154.64"
              y2="145.05"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <line
              x1="61.79"
              y1="158.49"
              x2="62.17"
              y2="124.15"
              fill="none"
              stroke="#7c3709"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <g opacity="0.64">
              <ellipse
                cx="57.99"
                cy="117.26"
                rx="0.44"
                ry="0.73"
                transform="translate(-54.87 51.11) rotate(-33.31)"
                fill="#352119"
              />
            </g>
            <ellipse
              cx="58.14"
              cy="116.89"
              rx="0.56"
              ry="0.92"
              transform="translate(-54.64 51.13) rotate(-33.31)"
              fill="#ad9b90"
            />
            <path
              d="M50.84,119.13l.08-7.77c.11,2.54.52,7,2,8.6l-.17.13-.64.19h-.07A1.19,1.19,0,0,1,50.84,119.13Z"
              fill="#472d22"
            />
            <path
              d="M49.85,163.39l.09-7.77c.11,2.54.52,6.95,2,8.6l-.18.13c-.22.07-.43.14-.64.19h-.06A1.19,1.19,0,0,1,49.85,163.39Z"
              fill="#472d22"
            />
            <path
              d="M191.83,183.12a13.82,13.82,0,0,1,2.38-1.17,14.1,14.1,0,0,1,2.56-.72,13.51,13.51,0,0,1-2.39,1.16A13.8,13.8,0,0,1,191.83,183.12Z"
              fill="#ad9b90"
            />
            <path
              d="M197,180.89a62.69,62.69,0,0,1,.26,8v.22l-.2.09a60.48,60.48,0,0,1-5.72,2.31,59.28,59.28,0,0,1,5.42-2.94l-.19.31A64.56,64.56,0,0,1,197,180.89Z"
              fill="#352119"
            />
            <path
              d="M118.52,132.44c.39,1.88.92,3.73,1.18,5.64a21.52,21.52,0,0,1,.24,2.89,11.41,11.41,0,0,1-.24,2.9,8.63,8.63,0,0,1-.63,1.33,6.67,6.67,0,0,0-.43,1.33,12.65,12.65,0,0,0-.29,2.81,17.22,17.22,0,0,0,.35,2.84A21,21,0,0,1,119,155c-.14-1.92-.83-3.73-.94-5.69a11.24,11.24,0,0,1,.26-2.89,6.54,6.54,0,0,1,.43-1.41,7.73,7.73,0,0,0,.6-1.28,10.82,10.82,0,0,0,.25-2.8,27.26,27.26,0,0,0-.18-2.85C119.22,136.22,118.79,134.35,118.52,132.44Z"
              fill="#683009"
            />
            <path
              d="M143.72,112.32c1.95.58,3.93,1,5.85,1.74a26.66,26.66,0,0,1,2.82,1.18,13.72,13.72,0,0,1,2.64,1.59,8.15,8.15,0,0,1,1,1.18,7.45,7.45,0,0,0,1.08,1,15.33,15.33,0,0,0,2.54,1.61,23.51,23.51,0,0,0,2.83,1.07,24.9,24.9,0,0,1,2.83,1.13c-1.87-.8-3.89-1.12-5.77-2a13.59,13.59,0,0,1-2.63-1.6,8.14,8.14,0,0,1-1.14-1.06,7.76,7.76,0,0,0-1-1.13,13.42,13.42,0,0,0-2.55-1.57c-.9-.45-1.83-.85-2.77-1.22C147.59,113.57,145.63,113,143.72,112.32Z"
              fill="#683009"
            />
            <path
              d="M179.66,147.63c.4,1.88.92,3.73,1.18,5.64a21.38,21.38,0,0,1,.24,2.88,11.45,11.45,0,0,1-.24,2.91,7.69,7.69,0,0,1-.63,1.32,6.56,6.56,0,0,0-.43,1.34,12.65,12.65,0,0,0-.29,2.81,17,17,0,0,0,.35,2.83,21.34,21.34,0,0,1,.31,2.87c-.14-1.92-.83-3.73-.94-5.69a11.7,11.7,0,0,1,.26-2.89,5.91,5.91,0,0,1,.44-1.41,8.55,8.55,0,0,0,.59-1.28,10.82,10.82,0,0,0,.25-2.8,27.09,27.09,0,0,0-.18-2.85C180.36,151.41,179.93,149.53,179.66,147.63Z"
              fill="#1e560e"
            />
            <path
              d="M100.42,133.3c.39,1.87.92,3.72,1.18,5.64a23,23,0,0,1,.23,2.88,11.08,11.08,0,0,1-.24,2.91,9,9,0,0,1-.62,1.32,5.59,5.59,0,0,0-.43,1.33,12.18,12.18,0,0,0-.3,2.82,17,17,0,0,0,.36,2.83,21.34,21.34,0,0,1,.3,2.86c-.14-1.92-.83-3.73-.93-5.68a11.77,11.77,0,0,1,.25-2.9,6.49,6.49,0,0,1,.44-1.4,9.57,9.57,0,0,0,.59-1.28,10.86,10.86,0,0,0,.26-2.81c0-.95-.08-1.9-.18-2.85C101.12,137.07,100.68,135.2,100.42,133.3Z"
              fill="#683009"
            />
            <path
              d="M85.43,141.71c.39,1.88.92,3.73,1.18,5.64a23.13,23.13,0,0,1,.23,2.88,11,11,0,0,1-.24,2.91,8.5,8.5,0,0,1-.62,1.32,5.52,5.52,0,0,0-.43,1.34,12.09,12.09,0,0,0-.3,2.81,17,17,0,0,0,.36,2.83,21.32,21.32,0,0,1,.3,2.87c-.14-1.92-.83-3.73-.93-5.69a11.69,11.69,0,0,1,.25-2.89,6.4,6.4,0,0,1,.44-1.41,8.55,8.55,0,0,0,.59-1.28,10.82,10.82,0,0,0,.26-2.8c0-1-.08-1.91-.18-2.85C86.13,145.49,85.69,143.61,85.43,141.71Z"
              fill="#683009"
            />
            <path
              d="M119.66,157.84a6.43,6.43,0,0,1-.52,1.47c-.2.48-.39,1-.56,1.45a11.26,11.26,0,0,0-.61,3c-.13,2.06.78,4,1.41,6a13.41,13.41,0,0,1,.72,3.08,4.56,4.56,0,0,1-.12,1.6,3.88,3.88,0,0,1-.75,1.42,9.83,9.83,0,0,1-1,1.18,2.37,2.37,0,0,0-.76,1.26,11.06,11.06,0,0,0,.07,3.09,10.52,10.52,0,0,1-.25-3.12,2.58,2.58,0,0,1,.76-1.4,10.86,10.86,0,0,0,1-1.18,3.74,3.74,0,0,0,.79-2.83,13.32,13.32,0,0,0-.73-3c-.34-1-.7-2-1-3a8.7,8.7,0,0,1-.39-3.13,10.42,10.42,0,0,1,.72-3.07,14,14,0,0,1,.65-1.42A6.66,6.66,0,0,0,119.66,157.84Z"
              fill="#683009"
            />
            <path
              d="M188.49,156.1a5.82,5.82,0,0,1-.51,1.47c-.2.48-.39,1-.56,1.46a11.11,11.11,0,0,0-.61,3c-.13,2.06.78,4,1.41,6a13.73,13.73,0,0,1,.72,3.07,4.56,4.56,0,0,1-.12,1.6,4.17,4.17,0,0,1-.75,1.43,13.05,13.05,0,0,1-1,1.17,2.36,2.36,0,0,0-.76,1.27,11.37,11.37,0,0,0,.06,3.08,10.83,10.83,0,0,1-.24-3.12,2.52,2.52,0,0,1,.76-1.4,12.13,12.13,0,0,0,1-1.18,3.79,3.79,0,0,0,.79-2.83,13.11,13.11,0,0,0-.73-3c-.34-1-.7-2-1-3a9,9,0,0,1-.4-3.14,10.61,10.61,0,0,1,.73-3.06,14.21,14.21,0,0,1,.65-1.43A6.62,6.62,0,0,0,188.49,156.1Z"
              fill="#1e560e"
            />
            <path
              d="M179.48,181.12a6.6,6.6,0,0,1-.52,1.47c-.2.48-.39,1-.56,1.45a11.19,11.19,0,0,0-.61,3c-.13,2.07.78,4,1.41,6a13.32,13.32,0,0,1,.72,3.07,4.62,4.62,0,0,1-.12,1.61,4,4,0,0,1-.75,1.42A9.74,9.74,0,0,1,178,200.3a2.4,2.4,0,0,0-.76,1.27,11.06,11.06,0,0,0,.07,3.09,10.59,10.59,0,0,1-.25-3.13,2.62,2.62,0,0,1,.76-1.4,10,10,0,0,0,1-1.18,3.76,3.76,0,0,0,.79-2.82,13.06,13.06,0,0,0-.73-3c-.34-1-.7-2-1-3a8.72,8.72,0,0,1-.39-3.13,10.42,10.42,0,0,1,.72-3.07,15.3,15.3,0,0,1,.65-1.43A6.87,6.87,0,0,0,179.48,181.12Z"
              fill="#1e560e"
            />
            <path
              d="M170,160.83a6.27,6.27,0,0,1-.52,1.47c-.2.48-.39,1-.56,1.45a11.26,11.26,0,0,0-.61,3c-.13,2.06.78,4,1.41,6a13.2,13.2,0,0,1,.72,3.07,4.56,4.56,0,0,1-.12,1.6,3.88,3.88,0,0,1-.75,1.42A9.83,9.83,0,0,1,168.5,180a2.36,2.36,0,0,0-.76,1.27,11,11,0,0,0,.07,3.08,10.49,10.49,0,0,1-.25-3.12,2.58,2.58,0,0,1,.76-1.4,10.86,10.86,0,0,0,1-1.18,3.79,3.79,0,0,0,.79-2.83,13.11,13.11,0,0,0-.73-3c-.34-1-.7-2-1-3a8.78,8.78,0,0,1-.39-3.14,10.42,10.42,0,0,1,.72-3.07,14,14,0,0,1,.65-1.42A7.2,7.2,0,0,0,170,160.83Z"
              fill="#1e560e"
            />
            <path
              d="M117.57,151.26a2.49,2.49,0,0,0-.18,1.89,9.29,9.29,0,0,1,.31,2A4,4,0,0,0,118,157a3.52,3.52,0,0,1,.24,2,4.37,4.37,0,0,0-.49-1.88,3.9,3.9,0,0,1-.39-2,11.78,11.78,0,0,0-.23-2,2.74,2.74,0,0,1,0-1A2.29,2.29,0,0,1,117.57,151.26Z"
              fill="#683009"
            />
            <path
              d="M188.58,175.79a2.47,2.47,0,0,0-.18,1.88,9.38,9.38,0,0,1,.31,2,3.85,3.85,0,0,0,.29,1.89,3.63,3.63,0,0,1,.24,2,4.41,4.41,0,0,0-.49-1.88,3.9,3.9,0,0,1-.39-2,12,12,0,0,0-.23-1.95,2.74,2.74,0,0,1,0-1A2.18,2.18,0,0,1,188.58,175.79Z"
              fill="#1e560e"
            />
            <path
              d="M103.08,147.93a2.47,2.47,0,0,0-.18,1.88,9.48,9.48,0,0,1,.31,2,4,4,0,0,0,.29,1.88,3.63,3.63,0,0,1,.24,2,4.44,4.44,0,0,0-.49-1.88,3.88,3.88,0,0,1-.39-2,12,12,0,0,0-.23-1.95,2.74,2.74,0,0,1,0-1A2.25,2.25,0,0,1,103.08,147.93Z"
              fill="#683009"
            />
            <path
              d="M102.71,126.13a2.5,2.5,0,0,0-.19,1.89,9.29,9.29,0,0,1,.32,2,3.87,3.87,0,0,0,.29,1.89,3.53,3.53,0,0,1,.23,2,4.36,4.36,0,0,0-.48-1.88,3.91,3.91,0,0,1-.4-2,10.89,10.89,0,0,0-.22-2,3,3,0,0,1,0-1A2.45,2.45,0,0,1,102.71,126.13Z"
              fill="#683009"
            />
            <path
              d="M86.16,119.59a2.47,2.47,0,0,0-.18,1.88,9.38,9.38,0,0,1,.31,2,3.87,3.87,0,0,0,.29,1.89,3.63,3.63,0,0,1,.24,2,4.37,4.37,0,0,0-.49-1.88,3.9,3.9,0,0,1-.39-2,12,12,0,0,0-.23-2,2.74,2.74,0,0,1,0-1A2.18,2.18,0,0,1,86.16,119.59Z"
              fill="#683009"
            />
            <path
              d="M88.21,124.17a2.43,2.43,0,0,0-.19,1.88,9.48,9.48,0,0,1,.31,2,4,4,0,0,0,.29,1.88,3.54,3.54,0,0,1,.24,2,4.44,4.44,0,0,0-.49-1.88,3.88,3.88,0,0,1-.39-2,12,12,0,0,0-.23-2,3.23,3.23,0,0,1,0-1A2.14,2.14,0,0,1,88.21,124.17Z"
              fill="#683009"
            />
            <path
              d="M117,171.56a4.2,4.2,0,0,0,.54,1.51,2.74,2.74,0,0,1,.5,1.6,2.52,2.52,0,0,1-.86,1.45,2.59,2.59,0,0,0-.78,1.29,7.53,7.53,0,0,0,.28,3.14c.11.53.24,1.06.32,1.6a3,3,0,0,1-.14,1.62,3.06,3.06,0,0,0,0-1.59c-.12-.53-.27-1-.42-1.57a7.38,7.38,0,0,1-.36-3.28,2.88,2.88,0,0,1,.91-1.44,2.44,2.44,0,0,0,.81-1.26,2.64,2.64,0,0,0-.38-1.48A3.84,3.84,0,0,1,117,171.56Z"
              fill="#683009"
            />
            <path
              d="M188.59,186.17a4.1,4.1,0,0,0,.55,1.51,2.88,2.88,0,0,1,.5,1.59,2.58,2.58,0,0,1-.87,1.46A2.57,2.57,0,0,0,188,192a7.53,7.53,0,0,0,.28,3.14c.12.53.24,1.06.32,1.6a3,3,0,0,1-.13,1.63,3.21,3.21,0,0,0,0-1.6c-.11-.52-.27-1-.42-1.56a7.27,7.27,0,0,1-.35-3.29,2.83,2.83,0,0,1,.9-1.43,2.56,2.56,0,0,0,.82-1.26,2.78,2.78,0,0,0-.39-1.49A4,4,0,0,1,188.59,186.17Z"
              fill="#1e560e"
            />
            <path
              d="M170.29,182.23a4.1,4.1,0,0,0,.55,1.51,2.88,2.88,0,0,1,.5,1.59,2.58,2.58,0,0,1-.87,1.46,2.57,2.57,0,0,0-.78,1.28,7.53,7.53,0,0,0,.28,3.14c.12.53.24,1.06.32,1.6a3,3,0,0,1-.13,1.63,3.21,3.21,0,0,0,0-1.6c-.11-.52-.27-1-.42-1.56a7.27,7.27,0,0,1-.35-3.29,2.83,2.83,0,0,1,.9-1.43,2.5,2.5,0,0,0,.82-1.26,2.78,2.78,0,0,0-.39-1.49A4,4,0,0,1,170.29,182.23Z"
              fill="#1e560e"
            />
            <path
              d="M176.58,147.83a4.1,4.1,0,0,0,.55,1.51,2.89,2.89,0,0,1,.5,1.6,2.63,2.63,0,0,1-.86,1.45,2.5,2.5,0,0,0-.79,1.29,7.47,7.47,0,0,0,.28,3.13c.12.53.24,1.06.32,1.61a2.89,2.89,0,0,1-.13,1.62,3.06,3.06,0,0,0,0-1.59c-.11-.53-.26-1-.41-1.57a7.1,7.1,0,0,1-.36-3.28,2.93,2.93,0,0,1,.9-1.44,2.5,2.5,0,0,0,.82-1.26,2.66,2.66,0,0,0-.39-1.48A4,4,0,0,1,176.58,147.83Z"
              fill="#1e560e"
            />
            <path
              d="M102.48,158.19a4.27,4.27,0,0,0,.54,1.51,2.8,2.8,0,0,1,.5,1.59,2.51,2.51,0,0,1-.86,1.46,2.49,2.49,0,0,0-.78,1.29,7.3,7.3,0,0,0,.27,3.13c.12.53.25,1.06.33,1.61a3,3,0,0,1-.14,1.62,3.06,3.06,0,0,0,0-1.59c-.12-.53-.27-1.05-.42-1.57a7.24,7.24,0,0,1-.36-3.28,2.88,2.88,0,0,1,.91-1.44,2.48,2.48,0,0,0,.81-1.26,2.64,2.64,0,0,0-.38-1.48A3.84,3.84,0,0,1,102.48,158.19Z"
              fill="#683009"
            />
            <path
              d="M87,134.43a4.06,4.06,0,0,0,.55,1.5,2.89,2.89,0,0,1,.5,1.6,2.6,2.6,0,0,1-.86,1.46,2.48,2.48,0,0,0-.79,1.28,7.53,7.53,0,0,0,.28,3.14c.12.53.24,1.06.32,1.6a2.88,2.88,0,0,1-.13,1.62,3.06,3.06,0,0,0,0-1.59c-.11-.52-.26-1-.41-1.57a7.1,7.1,0,0,1-.36-3.28,2.93,2.93,0,0,1,.9-1.44,2.42,2.42,0,0,0,.82-1.26,2.66,2.66,0,0,0-.39-1.48A4,4,0,0,1,87,134.43Z"
              fill="#683009"
            />
            <path
              d="M99.77,169.12a4.1,4.1,0,0,0,.55,1.51,2.88,2.88,0,0,1,.5,1.59,2.58,2.58,0,0,1-.87,1.46,2.55,2.55,0,0,0-.78,1.29,7.5,7.5,0,0,0,.28,3.13c.12.53.24,1.06.32,1.6a3,3,0,0,1-.13,1.63,3.21,3.21,0,0,0,0-1.6c-.11-.52-.27-1-.42-1.56a7.27,7.27,0,0,1-.35-3.29,2.83,2.83,0,0,1,.9-1.43,2.56,2.56,0,0,0,.82-1.26,2.78,2.78,0,0,0-.39-1.49A4,4,0,0,1,99.77,169.12Z"
              fill="#683009"
            />
            <path
              d="M85.78,165.56a4.27,4.27,0,0,0,.54,1.51,2.89,2.89,0,0,1,.5,1.6,2.52,2.52,0,0,1-.86,1.45,2.53,2.53,0,0,0-.78,1.29,7.3,7.3,0,0,0,.27,3.13c.12.53.24,1.06.32,1.61a2.89,2.89,0,0,1-.13,1.62,3.06,3.06,0,0,0,0-1.59c-.11-.53-.26-1.05-.41-1.57a7.1,7.1,0,0,1-.36-3.28,2.93,2.93,0,0,1,.9-1.44,2.5,2.5,0,0,0,.82-1.26,2.58,2.58,0,0,0-.39-1.48A3.83,3.83,0,0,1,85.78,165.56Z"
              fill="#683009"
            />
            <path
              d="M119.32,182.43c0,.28-.1.57-.17.85a3.52,3.52,0,0,1-.13.43.41.41,0,0,1-.15.21.16.16,0,0,1-.19,0s-.05-.07-.08-.11a4.74,4.74,0,0,1-.2-1.78,6.82,6.82,0,0,1,.11-.88,1.66,1.66,0,0,1,.17-.45.31.31,0,0,1,.28-.17.35.35,0,0,1,.23.19,2.1,2.1,0,0,1,.19.87A3.24,3.24,0,0,1,119.32,182.43Zm0,0a2.48,2.48,0,0,0-.28-1.66c-.11-.11-.09-.09-.14,0a1.51,1.51,0,0,0-.09.38,7.91,7.91,0,0,0-.06.85,7.31,7.31,0,0,0,0,1.69c0,.06,0,.1,0,.08a.26.26,0,0,0,.11-.12,2.32,2.32,0,0,0,.18-.39C119.19,183,119.25,182.71,119.32,182.43Z"
              fill="#683009"
            />
            <path
              d="M116.67,165.74a6.23,6.23,0,0,1-.17.86,3.52,3.52,0,0,1-.13.43.44.44,0,0,1-.15.2.14.14,0,0,1-.18,0,.38.38,0,0,1-.08-.11,4.75,4.75,0,0,1-.21-1.78,7,7,0,0,1,.12-.89A1.15,1.15,0,0,1,116,164a.31.31,0,0,1,.27-.18.35.35,0,0,1,.23.19,2.15,2.15,0,0,1,.19.88A3.16,3.16,0,0,1,116.67,165.74Zm0,0a2.39,2.39,0,0,0-.27-1.65c-.12-.11-.1-.09-.15,0a1.93,1.93,0,0,0-.09.38,7.77,7.77,0,0,0,0,.85,7.34,7.34,0,0,0,0,1.69s0,.1,0,.08a.3.3,0,0,0,.11-.13,1.55,1.55,0,0,0,.18-.39A7.38,7.38,0,0,0,116.67,165.74Z"
              fill="#683009"
            />
            <path
              d="M168.34,191.45c-.05.29-.1.58-.17.86a3.38,3.38,0,0,1-.13.42.41.41,0,0,1-.15.21.15.15,0,0,1-.19,0s0-.08-.08-.11a5,5,0,0,1-.2-1.78,7,7,0,0,1,.11-.89,1.79,1.79,0,0,1,.17-.45.34.34,0,0,1,.28-.17.38.38,0,0,1,.23.19,2.15,2.15,0,0,1,.19.88A3.16,3.16,0,0,1,168.34,191.45Zm0,0a2.45,2.45,0,0,0-.28-1.65c-.11-.11-.09-.1-.14,0a1.33,1.33,0,0,0-.09.38,7.73,7.73,0,0,0-.06.85,7.93,7.93,0,0,0,0,1.69c0,.05,0,.1,0,.08a.3.3,0,0,0,.11-.13,2.32,2.32,0,0,0,.18-.39A7.38,7.38,0,0,0,168.34,191.45Z"
              fill="#1e560e"
            />
            <path
              d="M169.09,201.27a6.23,6.23,0,0,1-.17.86,3.38,3.38,0,0,1-.13.42.41.41,0,0,1-.15.21.14.14,0,0,1-.18,0,.42.42,0,0,1-.08-.12,4.68,4.68,0,0,1-.21-1.77,7,7,0,0,1,.12-.89,1.19,1.19,0,0,1,.17-.45.31.31,0,0,1,.27-.17.35.35,0,0,1,.23.19,2.15,2.15,0,0,1,.19.88A3.16,3.16,0,0,1,169.09,201.27Zm0,0a2.39,2.39,0,0,0-.27-1.65c-.12-.11-.1-.1-.15,0a1.77,1.77,0,0,0-.09.38,7.77,7.77,0,0,0-.05.85,7.34,7.34,0,0,0,0,1.69s0,.1,0,.08a.3.3,0,0,0,.11-.13,1.73,1.73,0,0,0,.18-.39A8,8,0,0,0,169.09,201.27Z"
              fill="#1e560e"
            />
            <path
              d="M176.91,196a8.2,8.2,0,0,1-.18.86,2.3,2.3,0,0,1-.12.43.37.37,0,0,1-.16.2.14.14,0,0,1-.18,0,.76.76,0,0,1-.08-.11,4.55,4.55,0,0,1-.2-1.78,5.55,5.55,0,0,1,.11-.89,1.33,1.33,0,0,1,.17-.44.33.33,0,0,1,.28-.18.41.41,0,0,1,.23.19,2.32,2.32,0,0,1,.19.88A3.16,3.16,0,0,1,176.91,196Zm0,0a2.45,2.45,0,0,0-.28-1.65c-.11-.11-.09-.09-.15,0a2,2,0,0,0-.08.38,5.87,5.87,0,0,0-.06.85,7.33,7.33,0,0,0,0,1.69c0,.05,0,.1,0,.08a.3.3,0,0,0,.11-.13,2.22,2.22,0,0,0,.18-.38C176.78,196.55,176.84,196.27,176.91,196Z"
              fill="#1e560e"
            />
            <path
              d="M101.19,163.66a8.58,8.58,0,0,1-.18.85,3.52,3.52,0,0,1-.13.43.41.41,0,0,1-.15.21.15.15,0,0,1-.18,0,.28.28,0,0,1-.08-.11,4.75,4.75,0,0,1-.21-1.78,6.64,6.64,0,0,1,.12-.88,1.38,1.38,0,0,1,.17-.45.31.31,0,0,1,.28-.17.4.4,0,0,1,.23.18,2.13,2.13,0,0,1,.18.88A3.23,3.23,0,0,1,101.19,163.66Zm0,0a2.48,2.48,0,0,0-.28-1.66c-.12-.11-.1-.09-.15,0a1.51,1.51,0,0,0-.08.38,6,6,0,0,0-.06.85,7.33,7.33,0,0,0,0,1.69c0,.06,0,.1,0,.08a.33.33,0,0,0,.12-.12,1.92,1.92,0,0,0,.17-.39C101.05,164.22,101.12,163.94,101.19,163.66Z"
              fill="#683009"
            />
            <path
              d="M88.17,172a8.2,8.2,0,0,1-.18.86,2.35,2.35,0,0,1-.13.43.34.34,0,0,1-.15.2.14.14,0,0,1-.18,0,.76.76,0,0,1-.08-.11,4.75,4.75,0,0,1-.21-1.78,7,7,0,0,1,.12-.89,1.33,1.33,0,0,1,.17-.44.33.33,0,0,1,.28-.18.41.41,0,0,1,.23.19,2.13,2.13,0,0,1,.18.88A3.14,3.14,0,0,1,88.17,172Zm0,0a2.45,2.45,0,0,0-.28-1.65c-.12-.11-.1-.09-.15,0a1.42,1.42,0,0,0-.08.38,5.87,5.87,0,0,0-.06.85,7.34,7.34,0,0,0,0,1.69c0,.06,0,.1,0,.08a.33.33,0,0,0,.12-.12,1.92,1.92,0,0,0,.17-.39C88,172.54,88.1,172.26,88.17,172Z"
              fill="#683009"
            />
            <path
              d="M88.87,153.27a8.77,8.77,0,0,1-.18.86,2.25,2.25,0,0,1-.13.42.36.36,0,0,1-.15.21.17.17,0,0,1-.18,0,.83.83,0,0,1-.08-.12,4.48,4.48,0,0,1-.2-1.77,5.41,5.41,0,0,1,.11-.89,1.38,1.38,0,0,1,.17-.45.32.32,0,0,1,.28-.17.38.38,0,0,1,.23.19,2.1,2.1,0,0,1,.18.88A3.18,3.18,0,0,1,88.87,153.27Zm0,0a2.44,2.44,0,0,0-.28-1.65c-.12-.11-.1-.1-.15,0a1.5,1.5,0,0,0-.08.39,5.83,5.83,0,0,0-.06.84,7.33,7.33,0,0,0,0,1.69c0,.06,0,.11,0,.09a.38.38,0,0,0,.12-.13,1.71,1.71,0,0,0,.17-.39C88.73,153.84,88.8,153.55,88.87,153.27Z"
              fill="#683009"
            />
            <path
              d="M118.05,142.13c0,.49-.11,1-.18,1.46,0,.24-.07.48-.12.73a.76.76,0,0,1-.17.37s-.06,0-.1,0a.21.21,0,0,1-.07-.05.37.37,0,0,1-.06-.1,1.8,1.8,0,0,1,0-.19,14.67,14.67,0,0,1-.18-3c0-.49.06-1,.11-1.47a6.06,6.06,0,0,1,.15-.74,1.08,1.08,0,0,1,.08-.19.26.26,0,0,1,.21-.19c.17,0,.18.12.22.18a1.34,1.34,0,0,1,.07.18,6.25,6.25,0,0,1,.15,1.48A8.87,8.87,0,0,1,118.05,142.13Zm0,0a7.35,7.35,0,0,0-.26-2.88,1,1,0,0,0-.11-.21s-.05.13-.06.23a5.51,5.51,0,0,0-.08.71c0,.48-.05,1-.06,1.45a25.52,25.52,0,0,0,0,2.9l0,.17c0,.06,0,.08,0,.07a.66.66,0,0,0,.14-.28c.07-.23.13-.47.18-.71C117.91,143.1,118,142.62,118.05,142.13Z"
              fill="#683009"
            />
            <path
              d="M177.5,175.67c0,.49-.1,1-.17,1.46,0,.24-.07.49-.12.73a.86.86,0,0,1-.17.37s-.07,0-.1,0a.21.21,0,0,1-.07-.05.37.37,0,0,1-.06-.1,1.8,1.8,0,0,1-.05-.19,14.67,14.67,0,0,1-.18-2.95c0-.49.06-1,.11-1.47a4.85,4.85,0,0,1,.15-.74,1.08,1.08,0,0,1,.08-.19.27.27,0,0,1,.21-.19c.17,0,.18.13.22.18a1.07,1.07,0,0,1,.07.19,6.12,6.12,0,0,1,.15,1.47A7.9,7.9,0,0,1,177.5,175.67Zm0,0a7.16,7.16,0,0,0-.25-2.88,1,1,0,0,0-.11-.21s0,.13-.06.23a5.51,5.51,0,0,0-.08.71c0,.48-.05,1-.06,1.45a25.69,25.69,0,0,0,0,2.91l0,.16c0,.07,0,.08,0,.07a.66.66,0,0,0,.14-.28c.07-.23.13-.47.18-.71C177.37,176.64,177.44,176.16,177.5,175.67Z"
              fill="#1e560e"
            />
            <path
              d="M186.25,186.37c-.05.49-.1,1-.17,1.45,0,.25-.07.49-.13.73a.73.73,0,0,1-.16.38.13.13,0,0,1-.11,0s-.06,0-.07-.06a.47.47,0,0,1-.05-.1,1.06,1.06,0,0,1-.06-.19,14.57,14.57,0,0,1-.17-2.95c0-.48,0-1,.11-1.47a4.85,4.85,0,0,1,.15-.74c0-.06,0-.12.07-.19a.28.28,0,0,1,.22-.18c.16,0,.18.12.22.17a.82.82,0,0,1,.06.19,6.13,6.13,0,0,1,.16,1.47A10.34,10.34,0,0,1,186.25,186.37Zm0,0a7.14,7.14,0,0,0-.26-2.88c0-.1-.14-.24-.1-.21s-.06.13-.07.23-.06.46-.08.7c0,.48-.05,1-.06,1.46a23.38,23.38,0,0,0,0,2.9.47.47,0,0,0,0,.17c0,.06,0,.08,0,.07a.88.88,0,0,0,.13-.29,4.23,4.23,0,0,0,.18-.7C186.11,187.34,186.19,186.85,186.25,186.37Z"
              fill="#1e560e"
            />
            <path
              d="M104.11,143.94c0,.49-.1,1-.17,1.46,0,.24-.07.48-.13.72a.73.73,0,0,1-.16.38s-.07,0-.11,0-.06,0-.07-.06l0-.1-.06-.19a14.57,14.57,0,0,1-.17-2.95c0-.48.06-1,.11-1.47a5.11,5.11,0,0,1,.15-.74,1,1,0,0,1,.08-.19.26.26,0,0,1,.21-.18c.17,0,.18.12.22.17s.05.13.07.19a6.67,6.67,0,0,1,.15,1.47A8,8,0,0,1,104.11,143.94Zm0,0a7.13,7.13,0,0,0-.25-2.88,1,1,0,0,0-.11-.21s0,.13-.06.23a5.16,5.16,0,0,0-.08.7c0,.48,0,1-.06,1.46a25.52,25.52,0,0,0,0,2.9l0,.17c0,.06.05.08,0,.07a.87.87,0,0,0,.14-.29c.07-.23.13-.46.18-.7C104,144.91,104.05,144.42,104.11,143.94Z"
              fill="#683009"
            />
            <path
              d="M117.13,190.93a8.31,8.31,0,0,0,.09-1.84c0-.29-.12-.61-.13-.93a3.82,3.82,0,0,1,.08-1l.19.92c.07.3.15.59.21.93A3.13,3.13,0,0,1,117.13,190.93Z"
              fill="#683009"
            />
            <path
              d="M101.31,185.53a8.25,8.25,0,0,0,.09-1.83c0-.3-.12-.62-.13-.94a3.82,3.82,0,0,1,.08-1l.19.92c.06.31.15.59.21.93A3.13,3.13,0,0,1,101.31,185.53Z"
              fill="#683009"
            />
            <path
              d="M87.72,179a8.9,8.9,0,0,0,.09-1.83c0-.3-.12-.62-.13-.94a3.43,3.43,0,0,1,.08-1l.19.92c.06.31.14.59.21.93A3.28,3.28,0,0,1,87.72,179Z"
              fill="#683009"
            />
            <path
              d="M119.26,191.83a.9.9,0,0,0-.25-.92,3.32,3.32,0,0,1-.73-.8,3,3,0,0,1,.07-2.17c.24-.65.45-1.32.64-2a11.77,11.77,0,0,0,.44-2,7.12,7.12,0,0,1-.17,2.11,18.16,18.16,0,0,1-.57,2,2.83,2.83,0,0,0-.17,1.93,3.2,3.2,0,0,0,.62.8A1,1,0,0,1,119.26,191.83Z"
              fill="#683009"
            />
            <path
              d="M102.78,179.23a.9.9,0,0,0-.25-.92,3,3,0,0,1-.73-.8,2.88,2.88,0,0,1,.08-2.16c.23-.66.44-1.32.63-2a11.77,11.77,0,0,0,.44-2,7.08,7.08,0,0,1-.17,2.1,18.32,18.32,0,0,1-.57,2.05,2.83,2.83,0,0,0-.17,1.93,3.2,3.2,0,0,0,.62.8A1,1,0,0,1,102.78,179.23Z"
              fill="#683009"
            />
            <path
              d="M88.4,166.43a.92.92,0,0,0-.25-.92,3.17,3.17,0,0,1-.74-.8,2.93,2.93,0,0,1,.08-2.16c.24-.66.44-1.32.64-2a11.86,11.86,0,0,0,.43-2.05,6.51,6.51,0,0,1-.17,2.11,19.79,19.79,0,0,1-.56,2,2.78,2.78,0,0,0-.17,1.93,2.84,2.84,0,0,0,.62.8A1,1,0,0,1,88.4,166.43Z"
              fill="#683009"
            />
            <line
              x1="184.34"
              y1="147.56"
              x2="183.73"
              y2="202.12"
              fill="none"
              stroke="#335b1a"
              strokeMiterlimit="10"
              strokeWidth="0.47"
            />
            <line
              x1="173.7"
              y1="148.86"
              x2="173.11"
              y2="206.56"
              fill="none"
              stroke="#335b1a"
              strokeMiterlimit="10"
              strokeWidth="0.47"
            />
            <ellipse
              cx="186.34"
              cy="180.77"
              rx="4.08"
              ry="2.45"
              transform="translate(-68.24 231.65) rotate(-55.43)"
              fill="#d9e227"
            />
            <g opacity="0.47">
              <path
                d="M188.14,182.4a4,4,0,0,1-1.41,1.92,3,3,0,0,1-2.55.52,1.81,1.81,0,0,1-1.18-1,2.5,2.5,0,0,1-.18-1.35,4.37,4.37,0,0,1,.91-2.19,17.81,17.81,0,0,0,0,2.2,2,2,0,0,0,.26.83.68.68,0,0,0,.51.37,2.63,2.63,0,0,0,1.76-.18A11,11,0,0,0,188.14,182.4Z"
                fill="#335b1a"
              />
            </g>
            <path
              d="M188.74,178.7c-.15-.19-.4-.2-.56-.25a3,3,0,0,0-.51-.08,12,12,0,0,1-1.27-.15,1.24,1.24,0,0,1,.58-.53,1.4,1.4,0,0,1,.79-.14,1.32,1.32,0,0,1,.76.36A.67.67,0,0,1,188.74,178.7Z"
              fill="#e3efda"
            />
            <polygon
              points="118.23 191.29 118.65 170.72 117.05 170.37 116.7 190.79 118.23 191.29"
              fill="#573828"
            />
            <line
              x1="118.71"
              y1="170.78"
              x2="118.24"
              y2="191.32"
              fill="none"
              stroke="#352119"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <line
              x1="87.64"
              y1="158.05"
              x2="87.17"
              y2="178.58"
              fill="none"
              stroke="#352119"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <line
              x1="102.73"
              y1="151.92"
              x2="102.12"
              y2="184.77"
              fill="none"
              stroke="#352119"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <path
              d="M118.7,171.58s1,.52,1.23,0c1.26-2.27-1.68-4-1.9-6.06-1.26,2.84-2.63,4.31-2.15,5.23s2,0,2,0Z"
              fill="#573828"
            />
            <path
              d="M87.7,158.73s1,.52,1.23,0c1.26-2.27-1.68-4-1.9-6.07-1.27,2.84-2.64,4.31-2.15,5.23s2,0,2,0Z"
              fill="#573828"
            />
            <path
              d="M102.69,152.23s1.24.59,1.61,0c1.64-2.6-2.2-4.59-2.5-7-1.65,3.25-3.44,4.94-2.8,6s2.57,0,2.57,0Z"
              fill="#573828"
            />
            <path
              d="M118,170.78c.33.22.64.46,1,.7l0,0a1.29,1.29,0,0,0,.83.13c.1,0,.1-.05.16-.23a1.66,1.66,0,0,0,.14-.43,2.57,2.57,0,0,0-.31-1.73c-.27-.57-.65-1.12-1-1.72a4.08,4.08,0,0,1-.6-1.94c.4,1.3,1.44,2.15,2.09,3.4a2.73,2.73,0,0,1,.31,2.12,2.33,2.33,0,0,1-.2.52.74.74,0,0,1-.51.44,1.64,1.64,0,0,1-1.08-.3h0C118.47,171.38,118.21,171.09,118,170.78Z"
              fill="#352119"
            />
            <polygon
              points="102.05 185 102.61 151.67 101.02 151.1 100.53 184.2 102.05 185"
              fill="#573828"
            />
            <path
              d="M101.69,151.11c.4.25.77.52,1.16.78l0,0a1.93,1.93,0,0,0,1,.17.3.3,0,0,0,.26-.21,2.39,2.39,0,0,0,.19-.48,2.61,2.61,0,0,0-.34-2c-.35-.64-.82-1.24-1.22-1.9a4.33,4.33,0,0,1-.81-2.18,6,6,0,0,0,1.14,1.94,12.51,12.51,0,0,1,1.39,1.86,2.82,2.82,0,0,1,.35,2.42,2.48,2.48,0,0,1-.27.57.76.76,0,0,1-.64.4,2.4,2.4,0,0,1-1.2-.34h0C102.33,151.79,102,151.46,101.69,151.11Z"
              fill="#352119"
            />
            <polygon
              points="87.22 178.67 87.64 158.11 86.05 157.75 85.7 178.17 87.22 178.67"
              fill="#573828"
            />
            <path
              d="M87,158.16c.33.22.63.46,1,.7l0,0a1.37,1.37,0,0,0,.83.14c.1-.05.1-.06.16-.24a1.36,1.36,0,0,0,.14-.43,2.56,2.56,0,0,0-.3-1.73c-.28-.57-.65-1.12-1-1.72a3.85,3.85,0,0,1-.6-1.94c.4,1.3,1.44,2.15,2.09,3.4a2.85,2.85,0,0,1,.31,2.13,2.49,2.49,0,0,1-.21.51.72.72,0,0,1-.51.44,1.64,1.64,0,0,1-1.08-.3h0C87.47,158.77,87.2,158.48,87,158.16Z"
              fill="#352119"
            />
            <ellipse
              cx="118"
              cy="169.07"
              rx="0.6"
              ry="1.02"
              transform="translate(-68.94 82.11) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="86.86"
              cy="156.68"
              rx="0.6"
              ry="1.02"
              transform="translate(-66.93 64.81) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="101.6"
              cy="149.29"
              rx="0.6"
              ry="1.02"
              transform="matrix(0.86, -0.5, 0.5, 0.86, -61.23, 71.2)"
              fill="#ad9b90"
            />
            <polygon
              points="157.34 145.88 156.03 142.1 55.79 105.07 52.27 106.54 157.34 145.88"
              fill="#c1540a"
            />
            <path
              d="M198.35,128.19S170,117.31,157.4,145.82c-1.31-3.77-1.31-3.66-1.31-3.66s11.07-21.89,36.37-16.13C198.35,128.23,198.35,128.19,198.35,128.19Z"
              fill="#96440c"
            />
            <polygon
              points="165.71 168.28 173.56 166.09 177.49 166.1 177.48 167.12 173.51 170.16 165.72 172.37 165.71 168.28"
              fill="#573828"
            />
            <path
              d="M177.37,166.06l0,1v0l0,0c-1.27,1.09-2.57,2.13-3.87,3.17l0,0h0c-1.3.37-2.59.78-3.89,1.12s-2.6.73-3.91,1.05l-.22.05v-.21c0-1.37.08-2.73.16-4.1.09,1.37.14,2.73.18,4.1l-.22-.16c1.29-.42,2.59-.78,3.88-1.16s2.6-.73,3.9-1.09l-.06,0q2-1.5,4-2.93l0,.05Z"
              fill="#352119"
            />
            <path
              d="M165.34,168.47c1.28-.48,2.57-.91,3.87-1.3s2.61-.75,3.92-1.09h0c.72-.06,1.44-.07,2.16-.1s1.44,0,2.16,0c-.71.11-1.43.22-2.14.3s-1.43.18-2.15.24h0c-1.3.4-2.6.76-3.92,1.1S166.68,168.22,165.34,168.47Z"
              fill="#ad9b90"
            />
            <ellipse
              cx="168.59"
              cy="169.19"
              rx="0.66"
              ry="0.4"
              transform="translate(-66.39 212.03) rotate(-55.43)"
              fill="#ad9b90"
            />
            <ellipse
              cx="173.04"
              cy="168.21"
              rx="0.66"
              ry="0.4"
              transform="matrix(0.57, -0.82, 0.82, 0.57, -63.65, 215.26)"
              fill="#ad9b90"
            />
            <path
              d="M166.35,192.74h-.48a1,1,0,0,0-1,.91l0,2.5a1,1,0,0,0,1,.93h.49a1,1,0,0,0,1-.91l0-2.5A1,1,0,0,0,166.35,192.74Z"
              fill="#573828"
            />
            <polygon
              points="166.18 192.93 174.02 190.74 177.95 190.75 177.94 191.77 173.98 194.81 166.19 197.02 166.18 192.93"
              fill="#573828"
            />
            <path
              d="M177.83,190.71l0,1v0l0,0q-1.9,1.62-3.87,3.16l0,0h0c-1.29.37-2.58.78-3.89,1.12s-2.6.73-3.91,1.05l-.22,0V197c0-1.37.07-2.73.16-4.1.08,1.37.14,2.73.17,4.1l-.21-.17c1.28-.41,2.59-.77,3.88-1.16s2.6-.72,3.9-1.08l-.07,0c1.34-1,2.68-2,4.05-2.93l0,.05Z"
              fill="#352119"
            />
            <ellipse
              cx="169.06"
              cy="193.84"
              rx="0.66"
              ry="0.4"
              transform="translate(-86.48 223.07) rotate(-55.43)"
              fill="#ad9b90"
            />
            <ellipse
              cx="173.5"
              cy="192.86"
              rx="0.66"
              ry="0.4"
              transform="translate(-83.75 226.31) rotate(-55.43)"
              fill="#ad9b90"
            />
            <path
              d="M166.05,193.12c1.29-.45,2.58-.86,3.88-1.24s2.61-.75,3.93-1.1h0c1.43-.09,2.87-.16,4.31-.18-1.43.2-2.86.35-4.29.49h0c-1.3.39-2.61.76-3.92,1.1S167.38,192.84,166.05,193.12Z"
              fill="#ad9b90"
            />
            <polygon
              points="119.88 131.89 119.71 141.75 117.81 141.11 117.8 131.09 119.88 131.89"
              fill="#573828"
            />
            <line
              x1="120.07"
              y1="132"
              x2="119.71"
              y2="141.7"
              fill="none"
              stroke="#352119"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <polygon
              points="88.37 120.41 88.2 130.27 86.3 129.63 86.28 119.61 88.37 120.41"
              fill="#573828"
            />
            <line
              x1="88.55"
              y1="120.52"
              x2="88.2"
              y2="130.22"
              fill="none"
              stroke="#352119"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <polygon
              points="103.33 125.77 103.11 139.6 101.22 138.7 101.25 124.66 103.33 125.77"
              fill="#573828"
            />
            <line
              x1="103.51"
              y1="125.93"
              x2="103.12"
              y2="139.52"
              fill="none"
              stroke="#352119"
              strokeMiterlimit="10"
              strokeWidth="0.59"
            />
            <ellipse
              cx="118.86"
              cy="136.03"
              rx="0.4"
              ry="0.68"
              transform="translate(-52.24 78.08) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="102.14"
              cy="133.36"
              rx="0.4"
              ry="0.68"
              transform="translate(-53.16 69.32) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="87.06"
              cy="128.08"
              rx="0.4"
              ry="0.68"
              transform="translate(-52.54 61.04) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="87.34"
              cy="124.66"
              rx="0.4"
              ry="0.68"
              transform="translate(-50.79 60.72) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="118.69"
              cy="139.56"
              rx="0.4"
              ry="0.68"
              transform="translate(-54.03 78.47) rotate(-30.14)"
              fill="#ad9b90"
            />
            <ellipse
              cx="102.1"
              cy="136.67"
              rx="0.4"
              ry="0.68"
              transform="translate(-54.82 69.75) rotate(-30.14)"
              fill="#ad9b90"
            />
            <path
              d="M101.48,128.6a2.1,2.1,0,0,1-.82.77,1.5,1.5,0,0,1-1.23,0,2.13,2.13,0,0,1-1.33-2,1.57,1.57,0,0,1,.64-1.16,2.2,2.2,0,0,1,1.15-.47,1.28,1.28,0,0,1,1.1.59,2.75,2.75,0,0,1,.46,1c-.39-.57-1-1.18-1.5-1.06a2,2,0,0,0-.79.44.94.94,0,0,0-.36.68,1.74,1.74,0,0,0,.86,1.47A1.65,1.65,0,0,0,101.48,128.6Z"
              fill="#352119"
            />
            <path
              d="M105.86,128.34l-12.22-4.77s-.3-6-6.76-3.84a23.59,23.59,0,0,1,2.73,2.53l-.77,1.86L85.16,123s1.4,6.51,6.72,3.27c3.42,1.24,12.8,5.07,12.8,5.07s.28,4.88,5,3.75a29.23,29.23,0,0,1-2.21-2.7l-.05-1.38,1.7-.6,1.17.5s1.17.49,1.16,1.41S113.35,126.41,105.86,128.34Z"
              fill="#7e6b5b"
            />
            <path
              d="M85.16,123a8.73,8.73,0,0,0,1,2.05,4.5,4.5,0,0,0,1.57,1.5,2.81,2.81,0,0,0,2,.26,5.25,5.25,0,0,0,1-.32l1-.52.16-.09.14.06,3.22,1.24c1.07.41,2.15.8,3.21,1.25,2.12.88,4.26,1.71,6.37,2.63l.18.07v.2a4.47,4.47,0,0,0,1.36,3.07,3,3,0,0,0,1.56.71,5.79,5.79,0,0,0,1.81,0l-.9.21a4.82,4.82,0,0,1-.93,0,3.3,3.3,0,0,1-1.78-.62,3.93,3.93,0,0,1-1.21-1.5,5.73,5.73,0,0,1-.53-1.85l.19.27c-2.16-.77-4.28-1.63-6.42-2.44-1.08-.4-2.13-.86-3.19-1.29l-3.19-1.29.31,0c-.36.19-.71.37-1.08.53a5.74,5.74,0,0,1-1.17.3,3.31,3.31,0,0,1-2.36-.46,4.54,4.54,0,0,1-1.56-1.76A7.4,7.4,0,0,1,85.16,123Z"
              fill="#5e5147"
            />
            <path
              d="M111.49,132.28c0,.17.08,0,.08-.09a2.36,2.36,0,0,0,0-.28,5.15,5.15,0,0,0,0-.56,4.42,4.42,0,0,0-.16-1.09,2.64,2.64,0,0,0-1.29-1.64,4,4,0,0,0-2.08-.37,10,10,0,0,0-2.16.39l-.1,0-.09,0-6.13-2.33-6.09-2.43-.18-.07v-.2a4.53,4.53,0,0,0-2-3.69,4.68,4.68,0,0,0-2.16-.51,11,11,0,0,0-1.14.1l-1.13.24,1.11-.36a11,11,0,0,1,1.15-.19,4.55,4.55,0,0,1,2.35.38,4.06,4.06,0,0,1,1.73,1.68,6,6,0,0,1,.72,2.32l-.19-.27,6.13,2.34,6.09,2.43h-.18a10.33,10.33,0,0,1,2.29-.29,4.39,4.39,0,0,1,2.29.53,2.81,2.81,0,0,1,1.3,1.92,4.43,4.43,0,0,1,.08,1.15,3.43,3.43,0,0,1-.08.56,2.86,2.86,0,0,1-.07.28s0,.09,0,.13S111.48,132.32,111.49,132.28Z"
              fill="#af9887"
            />
            <path
              d="M102.22,126s-7,1.76-.06,5.48"
              fill="none"
              stroke="#573828"
              strokeMiterlimit="10"
              strokeWidth="1.19"
            />
            <g>
              <ellipse
                cx="150.14"
                cy="129.1"
                rx="0.91"
                ry="3.02"
                transform="translate(19.64 278.01) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="153.16 128.67 153.15 129.12 147.12 129.07 147.13 128.61 153.16 128.67"
                fill="#d1a11e"
              />
              <ellipse
                cx="150.14"
                cy="128.64"
                rx="0.91"
                ry="3.02"
                transform="translate(20.1 277.57) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="139.54"
                cy="129.91"
                rx="0.91"
                ry="3.02"
                transform="translate(8.33 268.22) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="142.56 129.48 142.56 129.94 136.53 129.88 136.53 129.42 142.56 129.48"
                fill="#d1a11e"
              />
              <ellipse
                cx="139.55"
                cy="129.45"
                rx="0.91"
                ry="3.02"
                transform="translate(8.79 267.78) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="144.08"
                cy="131.55"
                rx="0.91"
                ry="3.02"
                transform="translate(11.18 274.38) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="147.1 131.12 147.09 131.58 141.06 131.52 141.07 131.06 147.1 131.12"
                fill="#d1a11e"
              />
              <ellipse
                cx="144.08"
                cy="131.09"
                rx="0.91"
                ry="3.02"
                transform="translate(11.64 273.94) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="150.34"
                cy="133.43"
                rx="0.91"
                ry="3.02"
                transform="translate(15.5 282.51) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="153.36 133.01 153.35 133.46 147.32 133.4 147.32 132.95 153.36 133.01"
                fill="#d1a11e"
              />
              <ellipse
                cx="150.34"
                cy="132.98"
                rx="0.91"
                ry="3.02"
                transform="translate(15.96 282.06) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="134.03"
                cy="127.02"
                rx="0.55"
                ry="1.81"
                transform="translate(5.76 259.86) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="135.85 126.77 135.84 127.04 132.22 127.01 132.23 126.73 135.85 126.77"
                fill="#d1a11e"
              />
              <ellipse
                cx="134.04"
                cy="126.75"
                rx="0.55"
                ry="1.81"
                transform="translate(6.03 259.59) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="114.82"
                cy="116.57"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.83 230.29) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="116.63 116.32 116.63 116.59 113.01 116.56 113.01 116.28 116.63 116.32"
                fill="#d1a11e"
              />
              <ellipse
                cx="114.82"
                cy="116.3"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.55 230.03) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="135.93"
                cy="122.82"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 11.83, 257.59)"
                fill="#d1a11e"
              />
              <polygon
                points="137.74 122.56 137.74 122.84 134.12 122.8 134.12 122.53 137.74 122.56"
                fill="#d1a11e"
              />
              <ellipse
                cx="135.93"
                cy="122.55"
                rx="0.55"
                ry="1.81"
                transform="translate(12.11 257.32) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="136.64"
                cy="125.45"
                rx="0.55"
                ry="1.81"
                transform="translate(9.91 260.9) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="138.45 125.2 138.45 125.47 134.83 125.44 134.83 125.16 138.45 125.2"
                fill="#d1a11e"
              />
              <ellipse
                cx="136.64"
                cy="125.18"
                rx="0.55"
                ry="1.81"
                transform="translate(10.18 260.64) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="121.9"
                cy="122.12"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -1.36, 242.86)"
                fill="#d1a11e"
              />
              <polygon
                points="123.71 121.86 123.71 122.13 120.09 122.1 120.09 121.83 123.71 121.86"
                fill="#d1a11e"
              />
              <ellipse
                cx="121.9"
                cy="121.84"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -1.08, 242.6)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="124.45"
                cy="124.88"
                rx="0.55"
                ry="1.81"
                transform="translate(-1.59 248.16) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="126.27 124.62 126.26 124.9 122.64 124.86 122.65 124.59 126.27 124.62"
                fill="#d1a11e"
              />
              <ellipse
                cx="124.46"
                cy="124.61"
                rx="0.55"
                ry="1.81"
                transform="translate(-1.31 247.89) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="126.26"
                cy="128.32"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -3.24, 253.37)"
                fill="#d1a11e"
              />
              <polygon
                points="128.07 128.06 128.07 128.34 124.45 128.3 124.46 128.03 128.07 128.06"
                fill="#d1a11e"
              />
              <ellipse
                cx="126.27"
                cy="128.05"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.96 253.1) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="121.24"
                cy="125.76"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -5.65, 245.82)"
                fill="#d1a11e"
              />
              <polygon
                points="123.06 125.5 123.05 125.78 119.43 125.75 119.44 125.47 123.06 125.5"
                fill="#d1a11e"
              />
              <ellipse
                cx="121.25"
                cy="125.49"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -5.37, 245.55)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="134"
                cy="130.31"
                rx="0.91"
                ry="3.02"
                transform="translate(2.43 263.08) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="137.02 129.88 137.01 130.34 130.98 130.28 130.99 129.82 137.02 129.88"
                fill="#d1a11e"
              />
              <ellipse
                cx="134"
                cy="129.85"
                rx="0.91"
                ry="3.02"
                transform="translate(2.89 262.63) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="124.94"
                cy="125.2"
                rx="0.91"
                ry="3.02"
                transform="translate(-1.43 248.97) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="127.96 124.78 127.96 125.23 121.93 125.17 121.93 124.72 127.96 124.78"
                fill="#d1a11e"
              />
              <ellipse
                cx="124.95"
                cy="124.75"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, -0.97, 248.52)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="128.08"
                cy="119.87"
                rx="0.91"
                ry="3.02"
                transform="translate(7.01 246.82) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="131.1 119.44 131.1 119.9 125.06 119.84 125.07 119.39 131.1 119.44"
                fill="#d1a11e"
              />
              <ellipse
                cx="128.09"
                cy="119.41"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 7.47, 246.37)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="133.9"
                cy="116.73"
                rx="0.91"
                ry="3.02"
                transform="translate(15.92 249.53) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="136.92 116.31 136.92 116.76 130.88 116.7 130.89 116.25 136.92 116.31"
                fill="#d1a11e"
              />
              <ellipse
                cx="133.91"
                cy="116.28"
                rx="0.91"
                ry="3.02"
                transform="translate(16.38 249.08) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="121.96"
                cy="116.28"
                rx="0.91"
                ry="3.02"
                transform="translate(4.55 237.14) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="124.99 115.85 124.98 116.31 118.95 116.25 118.95 115.79 124.99 115.85"
                fill="#d1a11e"
              />
              <ellipse
                cx="121.97"
                cy="115.82"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 5.01, 236.7)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="128.13"
                cy="115.08"
                rx="0.91"
                ry="3.02"
                transform="translate(11.86 242.13) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="131.16 114.65 131.15 115.11 125.12 115.05 125.12 114.59 131.16 114.65"
                fill="#d1a11e"
              />
              <ellipse
                cx="128.14"
                cy="114.62"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 12.32, 241.68)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="111.91"
                cy="112.99"
                rx="0.91"
                ry="3.02"
                transform="translate(-2.13 223.83) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="114.93 112.56 114.92 113.01 108.89 112.96 108.89 112.5 114.93 112.56"
                fill="#d1a11e"
              />
              <ellipse
                cx="111.91"
                cy="112.53"
                rx="0.91"
                ry="3.02"
                transform="translate(-1.66 223.38) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="103.68"
                cy="110.85"
                rx="0.91"
                ry="3.02"
                transform="translate(-8.14 213.49) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="106.7 110.42 106.7 110.88 100.67 110.82 100.67 110.37 106.7 110.42"
                fill="#d1a11e"
              />
              <ellipse
                cx="103.69"
                cy="110.4"
                rx="0.91"
                ry="3.02"
                transform="translate(-7.68 213.04) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="137.19"
                cy="119.73"
                rx="0.91"
                ry="3.02"
                transform="translate(16.18 255.79) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="140.21 119.3 140.21 119.76 134.18 119.7 134.18 119.25 140.21 119.3"
                fill="#d1a11e"
              />
              <ellipse
                cx="137.2"
                cy="119.27"
                rx="0.91"
                ry="3.02"
                transform="translate(16.64 255.34) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="141.22"
                cy="123.31"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 16.59, 263.36)"
                fill="#d1a11e"
              />
              <polygon
                points="144.24 122.88 144.23 123.33 138.2 123.28 138.2 122.82 144.24 122.88"
                fill="#d1a11e"
              />
              <ellipse
                cx="141.22"
                cy="122.85"
                rx="0.91"
                ry="3.02"
                transform="translate(17.05 262.91) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="148.72"
                cy="123.83"
                rx="0.91"
                ry="3.02"
                transform="translate(23.49 271.38) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="151.74 123.41 151.74 123.86 145.7 123.81 145.71 123.35 151.74 123.41"
                fill="#d1a11e"
              />
              <ellipse
                cx="148.72"
                cy="123.38"
                rx="0.91"
                ry="3.02"
                transform="translate(23.96 270.94) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="153.24"
                cy="127.07"
                rx="0.91"
                ry="3.02"
                transform="translate(24.73 279.11) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="156.26 126.64 156.25 127.1 150.22 127.04 150.23 126.59 156.26 126.64"
                fill="#d1a11e"
              />
              <ellipse
                cx="153.24"
                cy="126.62"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 25.19, 278.66)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="157.28"
                cy="129.16"
                rx="0.91"
                ry="3.02"
                transform="translate(26.64 285.22) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="160.3 128.74 160.29 129.19 154.26 129.13 154.27 128.68 160.3 128.74"
                fill="#d1a11e"
              />
              <ellipse
                cx="157.28"
                cy="128.71"
                rx="0.91"
                ry="3.02"
                transform="translate(27.1 284.77) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="156.23"
                cy="134.97"
                rx="0.91"
                ry="3.02"
                transform="translate(19.79 289.93) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="159.25 134.54 159.24 135 153.21 134.94 153.22 134.49 159.25 134.54"
                fill="#d1a11e"
              />
              <ellipse
                cx="156.23"
                cy="134.52"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 20.26, 289.48)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="159.35"
                cy="131.24"
                rx="0.91"
                ry="3.02"
                transform="translate(26.62 289.35) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="162.37 130.81 162.36 131.27 156.33 131.21 156.34 130.75 162.37 130.81"
                fill="#d1a11e"
              />
              <ellipse
                cx="159.35"
                cy="130.78"
                rx="0.91"
                ry="3.02"
                transform="translate(27.08 288.9) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="167.76"
                cy="127.67"
                rx="0.91"
                ry="3.02"
                transform="translate(38.52 294.22) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="170.78 127.24 170.78 127.69 164.74 127.64 164.75 127.18 170.78 127.24"
                fill="#d1a11e"
              />
              <ellipse
                cx="167.76"
                cy="127.21"
                rx="0.91"
                ry="3.02"
                transform="translate(38.98 293.77) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="173.96"
                cy="123.96"
                rx="0.91"
                ry="3.02"
                transform="translate(48.37 296.74) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="176.98 123.53 176.97 123.99 170.94 123.93 170.94 123.47 176.98 123.53"
                fill="#d1a11e"
              />
              <ellipse
                cx="173.96"
                cy="123.5"
                rx="0.91"
                ry="3.02"
                transform="translate(48.83 296.3) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="130.75"
                cy="122.98"
                rx="0.91"
                ry="3.02"
                transform="translate(6.55 252.57) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="133.78 122.55 133.77 123.01 127.74 122.95 127.74 122.49 133.78 122.55"
                fill="#d1a11e"
              />
              <ellipse
                cx="130.76"
                cy="122.52"
                rx="0.91"
                ry="3.02"
                transform="translate(7.02 252.12) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="108.56"
                cy="115.01"
                rx="0.91"
                ry="3.02"
                transform="translate(-7.46 222.48) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="111.58 114.58 111.58 115.04 105.54 114.98 105.55 114.52 111.58 114.58"
                fill="#d1a11e"
              />
              <ellipse
                cx="108.56"
                cy="114.55"
                rx="0.91"
                ry="3.02"
                transform="translate(-7 222.03) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="109.86"
                cy="119.93"
                rx="0.91"
                ry="3.02"
                transform="translate(-11.09 228.65) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="112.88 119.5 112.88 119.95 106.84 119.9 106.85 119.44 112.88 119.5"
                fill="#d1a11e"
              />
              <ellipse
                cx="109.86"
                cy="119.47"
                rx="0.91"
                ry="3.02"
                transform="translate(-10.63 228.21) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="95.59"
                cy="107.47"
                rx="0.91"
                ry="3.02"
                transform="translate(-12.77 202.05) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="98.61 107.04 98.61 107.5 92.58 107.44 92.58 106.98 98.61 107.04"
                fill="#d1a11e"
              />
              <ellipse
                cx="95.6"
                cy="107.01"
                rx="0.91"
                ry="3.02"
                transform="translate(-12.31 201.6) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="98.58"
                cy="115.6"
                rx="0.91"
                ry="3.02"
                transform="translate(-17.94 213.09) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="101.6 115.17 101.6 115.63 95.56 115.57 95.57 115.11 101.6 115.17"
                fill="#d1a11e"
              />
              <ellipse
                cx="98.59"
                cy="115.14"
                rx="0.91"
                ry="3.02"
                transform="translate(-17.47 212.64) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="95.53"
                cy="113.06"
                rx="0.91"
                ry="3.02"
                transform="translate(-18.42 207.52) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="98.55 112.63 98.55 113.09 92.52 113.03 92.52 112.57 98.55 112.63"
                fill="#d1a11e"
              />
              <ellipse
                cx="95.54"
                cy="112.6"
                rx="0.91"
                ry="3.02"
                transform="translate(-17.96 207.08) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="85.38"
                cy="107.14"
                rx="0.91"
                ry="3.02"
                transform="translate(-22.56 191.51) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="88.4 106.71 88.39 107.17 82.36 107.11 82.37 106.66 88.4 106.71"
                fill="#d1a11e"
              />
              <ellipse
                cx="85.38"
                cy="106.68"
                rx="0.91"
                ry="3.02"
                transform="translate(-22.1 191.06) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="86.39"
                cy="104.41"
                rx="0.91"
                ry="3.02"
                transform="translate(-18.83 189.82) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="89.42 103.98 89.41 104.44 83.38 104.38 83.38 103.93 89.42 103.98"
                fill="#d1a11e"
              />
              <ellipse
                cx="86.4"
                cy="103.96"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, -18.36, 189.38)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="86.81"
                cy="111.38"
                rx="0.91"
                ry="3.02"
                transform="translate(-25.38 197.14) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="89.83 110.95 89.83 111.41 83.79 111.35 83.8 110.89 89.83 110.95"
                fill="#d1a11e"
              />
              <ellipse
                cx="86.81"
                cy="110.92"
                rx="0.91"
                ry="3.02"
                transform="translate(-24.92 196.69) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="79.01"
                cy="104"
                rx="0.91"
                ry="3.02"
                transform="translate(-25.73 182.03) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="82.03 103.57 82.03 104.03 76 103.97 76 103.52 82.03 103.57"
                fill="#d1a11e"
              />
              <ellipse
                cx="79.02"
                cy="103.54"
                rx="0.91"
                ry="3.02"
                transform="translate(-25.26 181.58) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="77.58"
                cy="100.22"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, -23.37, 176.85)"
                fill="#d1a11e"
              />
              <polygon
                points="80.6 99.79 80.59 100.25 74.56 100.19 74.57 99.74 80.6 99.79"
                fill="#d1a11e"
              />
              <ellipse
                cx="77.58"
                cy="99.76"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, -22.91, 176.41)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="75.89"
                cy="107.74"
                rx="0.91"
                ry="3.02"
                transform="translate(-32.55 182.61) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="78.91 107.31 78.91 107.76 72.88 107.71 72.88 107.25 78.91 107.31"
                fill="#d1a11e"
              />
              <ellipse
                cx="75.9"
                cy="107.28"
                rx="0.91"
                ry="3.02"
                transform="translate(-32.09 182.17) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="115.4"
                cy="119.64"
                rx="0.91"
                ry="3.02"
                transform="translate(-5.31 233.91) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="118.42 119.21 118.42 119.67 112.39 119.61 112.39 119.15 118.42 119.21"
                fill="#d1a11e"
              />
              <ellipse
                cx="115.41"
                cy="119.18"
                rx="0.91"
                ry="3.02"
                transform="translate(-4.85 233.46) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="118.31"
                cy="123.54"
                rx="0.91"
                ry="3.02"
                transform="translate(-6.34 240.69) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="121.33 123.12 121.33 123.57 115.3 123.51 115.3 123.06 121.33 123.12"
                fill="#d1a11e"
              />
              <ellipse
                cx="118.32"
                cy="123.09"
                rx="0.91"
                ry="3.02"
                transform="translate(-5.87 240.24) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="141.06"
                cy="126.04"
                rx="0.91"
                ry="3.02"
                transform="translate(13.7 265.91) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="144.08 125.61 144.08 126.07 138.05 126.01 138.05 125.56 144.08 125.61"
                fill="#d1a11e"
              />
              <ellipse
                cx="141.07"
                cy="125.59"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, 14.16, 265.47)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="136.23"
                cy="129.1"
                rx="0.55"
                ry="1.81"
                transform="translate(5.85 264.11) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="138.04 128.84 138.04 129.12 134.42 129.08 134.42 128.81 138.04 128.84"
                fill="#d1a11e"
              />
              <ellipse
                cx="136.23"
                cy="128.83"
                rx="0.55"
                ry="1.81"
                transform="translate(6.13 263.84) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="129.5"
                cy="125.16"
                rx="0.55"
                ry="1.81"
                transform="translate(3.13 253.47) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="131.31 124.9 131.31 125.17 127.69 125.14 127.69 124.86 131.31 124.9"
                fill="#d1a11e"
              />
              <ellipse
                cx="129.5"
                cy="124.88"
                rx="0.55"
                ry="1.81"
                transform="translate(3.41 253.21) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="129.22"
                cy="127.78"
                rx="0.55"
                ry="1.81"
                transform="translate(0.24 255.8) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="131.04 127.52 131.03 127.8 127.41 127.76 127.42 127.49 131.04 127.52"
                fill="#d1a11e"
              />
              <ellipse
                cx="129.23"
                cy="127.5"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 0.51, 255.53)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="144.17"
                cy="134.77"
                rx="0.55"
                ry="1.81"
                transform="translate(8.05 277.66) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="145.98 134.51 145.97 134.78 142.36 134.75 142.36 134.47 145.98 134.51"
                fill="#d1a11e"
              />
              <ellipse
                cx="144.17"
                cy="134.49"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 8.33, 277.39)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="149.8"
                cy="137.33"
                rx="0.55"
                ry="1.81"
                transform="translate(11.07 285.83) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="151.61 137.07 151.61 137.35 147.99 137.31 147.99 137.04 151.61 137.07"
                fill="#d1a11e"
              />
              <ellipse
                cx="149.8"
                cy="137.06"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 11.35, 285.57)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="154.21"
                cy="139.2"
                rx="0.55"
                ry="1.81"
                transform="translate(13.57 292.1) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="156.02 138.94 156.02 139.22 152.4 139.18 152.41 138.91 156.02 138.94"
                fill="#d1a11e"
              />
              <ellipse
                cx="154.21"
                cy="138.92"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 13.85, 291.83)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="151.05"
                cy="135.97"
                rx="0.55"
                ry="1.81"
                transform="translate(13.66 285.74) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="152.86 135.72 152.86 135.99 149.24 135.96 149.24 135.68 152.86 135.72"
                fill="#d1a11e"
              />
              <ellipse
                cx="151.05"
                cy="135.7"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 13.94, 285.47)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="145.54"
                cy="133.3"
                rx="0.55"
                ry="1.81"
                transform="translate(10.88 277.57) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="147.35 133.04 147.35 133.31 143.73 133.28 143.73 133 147.35 133.04"
                fill="#d1a11e"
              />
              <ellipse
                cx="145.54"
                cy="133.02"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 11.16, 277.31)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="136.55"
                cy="132.75"
                rx="0.55"
                ry="1.81"
                transform="translate(2.52 268.06) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="138.37 132.5 138.36 132.77 134.75 132.74 134.75 132.46 138.37 132.5"
                fill="#d1a11e"
              />
              <ellipse
                cx="136.56"
                cy="132.48"
                rx="0.55"
                ry="1.81"
                transform="translate(2.8 267.79) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="140.11"
                cy="134.16"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 4.64, 273)"
                fill="#d1a11e"
              />
              <polygon
                points="141.92 133.9 141.92 134.17 138.3 134.14 138.3 133.87 141.92 133.9"
                fill="#d1a11e"
              />
              <ellipse
                cx="140.11"
                cy="133.88"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 4.92, 272.73)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="139.81"
                cy="127.54"
                rx="0.55"
                ry="1.81"
                transform="translate(10.97 266.15) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="141.63 127.28 141.62 127.55 138 127.52 138.01 127.25 141.63 127.28"
                fill="#d1a11e"
              />
              <ellipse
                cx="139.82"
                cy="127.26"
                rx="0.55"
                ry="1.81"
                transform="translate(11.25 265.88) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="141.73"
                cy="121.05"
                rx="0.55"
                ry="1.81"
                transform="translate(19.36 261.64) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="143.54 120.8 143.54 121.07 139.92 121.03 139.93 120.76 143.54 120.8"
                fill="#d1a11e"
              />
              <ellipse
                cx="141.74"
                cy="120.78"
                rx="0.55"
                ry="1.81"
                transform="translate(19.63 261.37) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="144.21"
                cy="130.77"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 12.09, 273.75)"
                fill="#d1a11e"
              />
              <polygon
                points="146.02 130.52 146.02 130.79 142.4 130.76 142.4 130.48 146.02 130.52"
                fill="#d1a11e"
              />
              <ellipse
                cx="144.21"
                cy="130.5"
                rx="0.55"
                ry="1.81"
                transform="translate(12.36 273.48) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="144.11"
                cy="128.26"
                rx="0.55"
                ry="1.81"
                transform="translate(14.5 271.17) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="145.93 128.01 145.92 128.28 142.31 128.25 142.31 127.97 145.93 128.01"
                fill="#d1a11e"
              />
              <ellipse
                cx="144.12"
                cy="127.99"
                rx="0.55"
                ry="1.81"
                transform="translate(14.78 270.9) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="148.08"
                cy="126.02"
                rx="0.55"
                ry="1.81"
                transform="translate(20.68 272.91) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="149.89 125.76 149.89 126.03 146.27 126 146.27 125.73 149.89 125.76"
                fill="#d1a11e"
              />
              <ellipse
                cx="148.08"
                cy="125.74"
                rx="0.55"
                ry="1.81"
                transform="translate(20.95 272.64) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="151.73"
                cy="129.93"
                rx="0.55"
                ry="1.81"
                transform="translate(20.38 280.43) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="153.54 129.68 153.54 129.95 149.92 129.91 149.92 129.64 153.54 129.68"
                fill="#d1a11e"
              />
              <ellipse
                cx="151.73"
                cy="129.66"
                rx="0.55"
                ry="1.81"
                transform="translate(20.65 280.17) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="154.28"
                cy="132.69"
                rx="0.55"
                ry="1.81"
                transform="translate(20.15 285.73) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="156.1 132.44 156.09 132.71 152.47 132.68 152.48 132.4 156.1 132.44"
                fill="#d1a11e"
              />
              <ellipse
                cx="154.29"
                cy="132.42"
                rx="0.55"
                ry="1.81"
                transform="translate(20.42 285.46) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="117.81"
                cy="124.47"
                rx="0.55"
                ry="1.81"
                transform="translate(-7.76 241.11) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="119.62 124.22 119.62 124.49 116 124.46 116 124.18 119.62 124.22"
                fill="#d1a11e"
              />
              <ellipse
                cx="117.81"
                cy="124.2"
                rx="0.55"
                ry="1.81"
                transform="translate(-7.49 240.84) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="145.78"
                cy="122.8"
                rx="0.55"
                ry="1.81"
                transform="translate(21.61 267.42) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="147.59 122.55 147.59 122.82 143.97 122.78 143.97 122.51 147.59 122.55"
                fill="#d1a11e"
              />
              <ellipse
                cx="145.78"
                cy="122.53"
                rx="0.55"
                ry="1.81"
                transform="translate(21.89 267.15) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="153.26"
                cy="125.04"
                rx="0.55"
                ry="1.81"
                transform="translate(26.79 277.12) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="155.07 124.78 155.07 125.06 151.45 125.02 151.45 124.75 155.07 124.78"
                fill="#d1a11e"
              />
              <ellipse
                cx="153.26"
                cy="124.77"
                rx="0.55"
                ry="1.81"
                transform="translate(27.06 276.85) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="157.55"
                cy="127.02"
                rx="0.55"
                ry="1.81"
                transform="translate(29.05 283.37) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="159.36 126.77 159.36 127.04 155.74 127 155.74 126.73 159.36 126.77"
                fill="#d1a11e"
              />
              <ellipse
                cx="157.55"
                cy="126.75"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 29.33, 283.1)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="162.58"
                cy="128.67"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 32.39, 290.03)"
                fill="#d1a11e"
              />
              <polygon
                points="164.39 128.41 164.39 128.68 160.77 128.65 160.77 128.38 164.39 128.41"
                fill="#d1a11e"
              />
              <ellipse
                cx="162.58"
                cy="128.39"
                rx="0.55"
                ry="1.81"
                transform="translate(32.67 289.76) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="160.69"
                cy="132.53"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 26.66, 291.96)"
                fill="#d1a11e"
              />
              <polygon
                points="162.5 132.27 162.5 132.54 158.88 132.51 158.88 132.24 162.5 132.27"
                fill="#d1a11e"
              />
              <ellipse
                cx="160.69"
                cy="132.25"
                rx="0.55"
                ry="1.81"
                transform="translate(26.93 291.7) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="122.08"
                cy="117.33"
                rx="0.55"
                ry="1.81"
                transform="translate(3.61 238.3) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="123.89 117.07 123.89 117.34 120.27 117.31 120.27 117.04 123.89 117.07"
                fill="#d1a11e"
              />
              <ellipse
                cx="122.08"
                cy="117.05"
                rx="0.55"
                ry="1.81"
                transform="translate(3.88 238.03) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="121.68"
                cy="119.83"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, 0.71, 240.38)"
                fill="#d1a11e"
              />
              <polygon
                points="123.49 119.58 123.49 119.85 119.87 119.82 119.87 119.54 123.49 119.58"
                fill="#d1a11e"
              />
              <ellipse
                cx="121.68"
                cy="119.56"
                rx="0.55"
                ry="1.81"
                transform="translate(0.99 240.11) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="116.7"
                cy="113.4"
                rx="0.55"
                ry="1.81"
                transform="translate(2.22 229.03) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="118.52 113.14 118.51 113.41 114.89 113.38 114.9 113.11 118.52 113.14"
                fill="#d1a11e"
              />
              <ellipse
                cx="116.71"
                cy="113.12"
                rx="0.55"
                ry="1.81"
                transform="translate(2.49 228.76) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="119.07"
                cy="111.02"
                rx="0.55"
                ry="1.81"
                transform="translate(6.93 229.04) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="120.88 110.77 120.88 111.04 117.26 111 117.26 110.73 120.88 110.77"
                fill="#d1a11e"
              />
              <ellipse
                cx="119.07"
                cy="110.75"
                rx="0.55"
                ry="1.81"
                transform="translate(7.21 228.78) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="108.85"
                cy="110.58"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.75 218.39) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="110.67 110.33 110.66 110.6 107.05 110.57 107.05 110.29 110.67 110.33"
                fill="#d1a11e"
              />
              <ellipse
                cx="108.86"
                cy="110.31"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.47 218.13) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="105.13"
                cy="113.06"
                rx="0.55"
                ry="1.81"
                transform="translate(-8.91 217.13) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="106.95 112.8 106.94 113.08 103.33 113.04 103.33 112.77 106.95 112.8"
                fill="#d1a11e"
              />
              <ellipse
                cx="105.14"
                cy="112.78"
                rx="0.55"
                ry="1.81"
                transform="translate(-8.63 216.86) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="104.59"
                cy="117.62"
                rx="0.55"
                ry="1.81"
                transform="translate(-14 221.1) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="106.4 117.36 106.4 117.63 102.78 117.6 102.78 117.33 106.4 117.36"
                fill="#d1a11e"
              />
              <ellipse
                cx="104.59"
                cy="117.34"
                rx="0.55"
                ry="1.81"
                transform="translate(-13.73 220.83) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="109.76"
                cy="117.55"
                rx="0.55"
                ry="1.81"
                transform="translate(-8.81 226.21) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="111.58 117.3 111.57 117.57 107.95 117.53 107.96 117.26 111.58 117.3"
                fill="#d1a11e"
              />
              <ellipse
                cx="109.77"
                cy="117.28"
                rx="0.55"
                ry="1.81"
                transform="translate(-8.54 225.94) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="111.54"
                cy="123.62"
                rx="0.55"
                ry="1.81"
                transform="translate(-13.12 233.99) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="113.35 123.36 113.35 123.63 109.73 123.6 109.73 123.32 113.35 123.36"
                fill="#d1a11e"
              />
              <ellipse
                cx="111.54"
                cy="123.34"
                rx="0.55"
                ry="1.81"
                transform="translate(-12.84 233.72) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="106.89"
                cy="121.4"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -15.51, 227.15)"
                fill="#d1a11e"
              />
              <polygon
                points="108.7 121.15 108.7 121.42 105.08 121.39 105.08 121.11 108.7 121.15"
                fill="#d1a11e"
              />
              <ellipse
                cx="106.89"
                cy="121.13"
                rx="0.55"
                ry="1.81"
                transform="translate(-15.24 226.88) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="102.73"
                cy="119.31"
                rx="0.55"
                ry="1.81"
                transform="translate(-17.54 220.91) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="104.54 119.05 104.53 119.33 100.92 119.29 100.92 119.02 104.54 119.05"
                fill="#d1a11e"
              />
              <ellipse
                cx="102.73"
                cy="119.04"
                rx="0.55"
                ry="1.81"
                transform="translate(-17.27 220.64) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="95.6"
                cy="117.99"
                rx="0.55"
                ry="1.81"
                transform="translate(-23.28 212.47) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="97.41 117.73 97.41 118 93.79 117.97 93.79 117.7 97.41 117.73"
                fill="#d1a11e"
              />
              <ellipse
                cx="95.6"
                cy="117.71"
                rx="0.55"
                ry="1.81"
                transform="translate(-23 212.21) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="92.5"
                cy="109.29"
                rx="0.55"
                ry="1.81"
                transform="translate(-17.65 200.75) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="94.31 109.03 94.31 109.3 90.69 109.27 90.69 109 94.31 109.03"
                fill="#d1a11e"
              />
              <ellipse
                cx="92.5"
                cy="109.01"
                rx="0.55"
                ry="1.81"
                transform="translate(-17.38 200.48) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="89.74"
                cy="113.6"
                rx="0.55"
                ry="1.81"
                transform="translate(-24.69 202.26) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="91.55 113.34 91.55 113.61 87.93 113.58 87.93 113.3 91.55 113.34"
                fill="#d1a11e"
              />
              <ellipse
                cx="89.74"
                cy="113.32"
                rx="0.55"
                ry="1.81"
                transform="translate(-24.42 202) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="90.45"
                cy="115.88"
                rx="0.55"
                ry="1.81"
                transform="translate(-26.28 205.24) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="92.27 115.63 92.26 115.9 88.64 115.87 88.65 115.59 92.27 115.63"
                fill="#d1a11e"
              />
              <ellipse
                cx="90.46"
                cy="115.61"
                rx="0.55"
                ry="1.81"
                transform="translate(-26 204.98) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="97.66"
                cy="110.13"
                rx="0.55"
                ry="1.81"
                transform="translate(-13.39 206.75) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="99.47 109.88 99.47 110.15 95.85 110.12 95.85 109.84 99.47 109.88"
                fill="#d1a11e"
              />
              <ellipse
                cx="97.66"
                cy="109.86"
                rx="0.55"
                ry="1.81"
                transform="translate(-13.11 206.48) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="105.33"
                cy="106.78"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.44 211.1) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="107.14 106.53 107.14 106.8 103.52 106.77 103.52 106.49 107.14 106.53"
                fill="#d1a11e"
              />
              <ellipse
                cx="105.33"
                cy="106.51"
                rx="0.55"
                ry="1.81"
                transform="translate(-2.16 210.84) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="101.74"
                cy="108.35"
                rx="0.55"
                ry="1.81"
                transform="translate(-7.56 209.06) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="103.55 108.09 103.55 108.36 99.93 108.33 99.93 108.06 103.55 108.09"
                fill="#d1a11e"
              />
              <ellipse
                cx="101.74"
                cy="108.07"
                rx="0.55"
                ry="1.81"
                transform="translate(-7.28 208.8) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="99.92"
                cy="105.59"
                rx="0.55"
                ry="1.81"
                transform="translate(-6.6 204.52) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="101.74 105.33 101.73 105.61 98.11 105.57 98.12 105.3 101.74 105.33"
                fill="#d1a11e"
              />
              <ellipse
                cx="99.93"
                cy="105.32"
                rx="0.55"
                ry="1.81"
                transform="translate(-6.33 204.25) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="95.62"
                cy="104.64"
                rx="0.55"
                ry="1.81"
                transform="translate(-9.91 199.28) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="97.44 104.38 97.43 104.66 93.81 104.62 93.82 104.35 97.44 104.38"
                fill="#d1a11e"
              />
              <ellipse
                cx="95.63"
                cy="104.36"
                rx="0.55"
                ry="1.81"
                transform="translate(-9.63 199.01) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="92.41"
                cy="105.98"
                rx="0.55"
                ry="1.81"
                transform="translate(-14.43 197.39) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="94.22 105.72 94.22 105.99 90.6 105.96 90.6 105.69 94.22 105.72"
                fill="#d1a11e"
              />
              <ellipse
                cx="92.41"
                cy="105.7"
                rx="0.55"
                ry="1.81"
                transform="translate(-14.15 197.12) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="88.32"
                cy="108.45"
                rx="0.55"
                ry="1.81"
                transform="translate(-20.95 195.74) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="90.13 108.19 90.13 108.46 86.51 108.43 86.51 108.16 90.13 108.19"
                fill="#d1a11e"
              />
              <ellipse
                cx="88.32"
                cy="108.17"
                rx="0.55"
                ry="1.81"
                transform="translate(-20.68 195.48) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="83.26"
                cy="109.2"
                rx="0.55"
                ry="1.81"
                transform="translate(-26.71 191.43) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="85.08 108.94 85.07 109.22 81.45 109.18 81.46 108.91 85.08 108.94"
                fill="#d1a11e"
              />
              <ellipse
                cx="83.27"
                cy="108.92"
                rx="0.55"
                ry="1.81"
                transform="translate(-26.43 191.16) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="82.24"
                cy="112.84"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -31.37, 194.01)"
                fill="#d1a11e"
              />
              <polygon
                points="84.05 112.58 84.05 112.86 80.43 112.82 80.43 112.55 84.05 112.58"
                fill="#d1a11e"
              />
              <ellipse
                cx="82.24"
                cy="112.56"
                rx="0.55"
                ry="1.81"
                transform="translate(-31.09 193.75) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="85.05"
                cy="114.23"
                rx="0.55"
                ry="1.81"
                transform="translate(-29.97 198.21) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="86.87 113.98 86.86 114.25 83.24 114.22 83.25 113.94 86.87 113.98"
                fill="#d1a11e"
              />
              <ellipse
                cx="85.06"
                cy="113.96"
                rx="0.55"
                ry="1.81"
                transform="translate(-29.7 197.94) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="79.57"
                cy="109.39"
                rx="0.55"
                ry="1.81"
                transform="translate(-30.57 187.93) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="81.38 109.13 81.38 109.41 77.76 109.37 77.76 109.1 81.38 109.13"
                fill="#d1a11e"
              />
              <ellipse
                cx="79.57"
                cy="109.12"
                rx="0.55"
                ry="1.81"
                transform="translate(-30.29 187.66) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="88.42"
                cy="110.39"
                rx="0.55"
                ry="1.81"
                transform="translate(-22.79 197.77) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="90.23 110.13 90.23 110.41 86.61 110.37 86.61 110.1 90.23 110.13"
                fill="#d1a11e"
              />
              <ellipse
                cx="88.42"
                cy="110.11"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -22.52, 197.5)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="96.87"
                cy="114.23"
                rx="0.55"
                ry="1.81"
                transform="translate(-18.27 210.03) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="98.69 113.98 98.68 114.25 95.06 114.22 95.07 113.94 98.69 113.98"
                fill="#d1a11e"
              />
              <ellipse
                cx="96.88"
                cy="113.96"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -17.99, 209.76)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="103.64"
                cy="114.87"
                rx="0.55"
                ry="1.81"
                transform="translate(-12.2 217.42) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="105.45 114.61 105.45 114.89 101.83 114.85 101.83 114.58 105.45 114.61"
                fill="#d1a11e"
              />
              <ellipse
                cx="103.64"
                cy="114.59"
                rx="0.55"
                ry="1.81"
                transform="translate(-11.92 217.15) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="83.34"
                cy="102.47"
                rx="0.55"
                ry="1.81"
                transform="translate(-19.91 184.84) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="85.15 102.21 85.15 102.48 81.53 102.45 81.53 102.17 85.15 102.21"
                fill="#d1a11e"
              />
              <ellipse
                cx="83.34"
                cy="102.19"
                rx="0.55"
                ry="1.81"
                transform="translate(-19.63 184.57) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="87.55"
                cy="100.45"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -13.72, 187.05)"
                fill="#d1a11e"
              />
              <polygon
                points="89.36 100.2 89.36 100.47 85.74 100.44 85.74 100.16 89.36 100.2"
                fill="#d1a11e"
              />
              <ellipse
                cx="87.55"
                cy="100.18"
                rx="0.55"
                ry="1.81"
                transform="translate(-13.45 186.78) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="93.19"
                cy="101.88"
                rx="0.55"
                ry="1.81"
                transform="translate(-9.55 194.11) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="95.01 101.62 95 101.89 91.38 101.86 91.39 101.58 95.01 101.62"
                fill="#d1a11e"
              />
              <ellipse
                cx="93.2"
                cy="101.6"
                rx="0.55"
                ry="1.81"
                transform="translate(-9.28 193.84) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="84.24"
                cy="98.82"
                rx="0.55"
                ry="1.81"
                transform="translate(-15.37 182.13) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="86.05 98.57 86.05 98.84 82.43 98.81 82.43 98.53 86.05 98.57"
                fill="#d1a11e"
              />
              <ellipse
                cx="84.24"
                cy="98.55"
                rx="0.55"
                ry="1.81"
                transform="translate(-15.09 181.86) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="73.41"
                cy="109.56"
                rx="0.55"
                ry="1.81"
                transform="translate(-36.83 181.94) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="75.22 109.3 75.22 109.58 71.6 109.54 71.6 109.27 75.22 109.3"
                fill="#d1a11e"
              />
              <ellipse
                cx="73.41"
                cy="109.29"
                rx="0.55"
                ry="1.81"
                transform="translate(-36.56 181.67) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="77.76"
                cy="105.49"
                rx="0.55"
                ry="1.81"
                transform="translate(-28.46 182.26) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="79.58 105.24 79.57 105.51 75.95 105.48 75.96 105.2 79.58 105.24"
                fill="#d1a11e"
              />
              <ellipse
                cx="77.77"
                cy="105.22"
                rx="0.55"
                ry="1.81"
                transform="translate(-28.18 182) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="72.85"
                cy="104.42"
                rx="0.55"
                ry="1.81"
                transform="translate(-32.25 176.29) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="74.66 104.16 74.66 104.44 71.04 104.4 71.05 104.13 74.66 104.16"
                fill="#d1a11e"
              />
              <ellipse
                cx="72.85"
                cy="104.15"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -31.97, 176.02)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="68.26"
                cy="107.57"
                rx="0.55"
                ry="1.81"
                transform="translate(-39.95 174.82) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="70.07 107.31 70.07 107.59 66.45 107.55 66.45 107.28 70.07 107.31"
                fill="#d1a11e"
              />
              <ellipse
                cx="68.26"
                cy="107.3"
                rx="0.55"
                ry="1.81"
                transform="translate(-39.67 174.55) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="77.09"
                cy="111.19"
                rx="0.55"
                ry="1.81"
                transform="translate(-34.83 187.23) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="78.9 110.94 78.89 111.21 75.28 111.17 75.28 110.9 78.9 110.94"
                fill="#d1a11e"
              />
              <ellipse
                cx="77.09"
                cy="110.92"
                rx="0.55"
                ry="1.81"
                transform="translate(-34.55 186.96) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="74.47"
                cy="102.38"
                rx="0.55"
                ry="1.81"
                transform="translate(-28.6 175.89) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="76.29 102.13 76.28 102.4 72.67 102.36 72.67 102.09 76.29 102.13"
                fill="#d1a11e"
              />
              <ellipse
                cx="74.48"
                cy="102.11"
                rx="0.55"
                ry="1.81"
                transform="translate(-28.33 175.62) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="67.81"
                cy="104.03"
                rx="0.55"
                ry="1.81"
                transform="translate(-36.85 170.86) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="69.62 103.77 69.62 104.05 66 104.01 66 103.74 69.62 103.77"
                fill="#d1a11e"
              />
              <ellipse
                cx="67.81"
                cy="103.76"
                rx="0.55"
                ry="1.81"
                transform="translate(-36.58 170.59) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="63.12"
                cy="104.67"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -42.13, 166.81)"
                fill="#d1a11e"
              />
              <polygon
                points="64.94 104.41 64.93 104.69 61.31 104.65 61.32 104.38 64.94 104.41"
                fill="#d1a11e"
              />
              <ellipse
                cx="63.13"
                cy="104.4"
                rx="0.55"
                ry="1.81"
                transform="translate(-41.86 166.54) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="70.17"
                cy="101.66"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -32.14, 170.87)"
                fill="#d1a11e"
              />
              <polygon
                points="71.99 101.4 71.98 101.67 68.36 101.64 68.37 101.36 71.99 101.4"
                fill="#d1a11e"
              />
              <ellipse
                cx="70.18"
                cy="101.38"
                rx="0.55"
                ry="1.81"
                transform="translate(-31.86 170.6) rotate(-89.46)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <ellipse
                cx="75.39"
                cy="97.83"
                rx="0.55"
                ry="1.81"
                transform="translate(-23.14 172.29) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="77.2 97.57 77.2 97.84 73.58 97.81 73.58 97.54 77.2 97.57"
                fill="#d1a11e"
              />
              <ellipse
                cx="75.39"
                cy="97.55"
                rx="0.55"
                ry="1.81"
                transform="matrix(0.01, -1, 1, 0.01, -22.87, 172.02)"
                fill="#f9df1e"
              />
            </g>
            <g>
              <polygon
                points="95.17 195.08 103.66 195.39 109.56 207.31 96.81 202.4 95.17 195.08"
                fill="#e20c49"
              />
              <polyline
                points="103.61 199.16 102.41 196.86 97.48 196.82"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="61.01 180.24 53.8 185.09 42.36 179.01 55.63 175.31 61.01 180.24"
                fill="#1ee00e"
              />
              <polyline
                points="51.77 182.03 54.02 183.16 58.13 180.23"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="140.96 128.67 142.47 125.88 148.07 125.86 144.08 129.31 140.96 128.67"
                fill="#e20c49"
              />
              <polyline
                points="143.93 126.51 142.84 126.54 142.02 128.18"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="123.46 116.29 127.62 117.4 128.97 123.96 123.31 120.09 123.46 116.29"
                fill="#e20c49"
              />
              <polyline
                points="127.1 119.25 126.81 117.98 124.38 117.41"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="93.2 107.45 97.08 105.67 102.86 109.66 95.86 110.35 93.2 107.45"
                fill="#e20c49"
              />
              <polyline
                points="98.05 107.36 96.91 106.61 94.69 107.7"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="112.03 115.77 113.45 115.82 114.43 117.8 112.31 116.98 112.03 115.77"
                fill="#e20c49"
              />
              <polyline
                points="113.44 116.44 113.24 116.06 112.42 116.05"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="75.29 104.23 79.62 104.39 82.63 110.47 76.13 107.96 75.29 104.23"
                fill="#0d9913"
              />
              <polyline
                points="79.6 106.31 78.98 105.14 76.48 105.12"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <ellipse
              cx="74.86"
              cy="122.9"
              rx="1.14"
              ry="1.42"
              transform="translate(-48.53 196.94) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <polygon
                points="102.3 116.71 103.68 115.1 107.29 115.78 104.22 117.52 102.3 116.71"
                fill="#0d9913"
              />
              <polyline
                points="104.53 115.69 103.82 115.57 103.05 116.52"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="128.75 129.74 130.12 128.13 133.74 128.81 130.66 130.55 128.75 129.74"
                fill="#0d9913"
              />
              <polyline
                points="130.97 128.72 130.27 128.6 129.5 129.56"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <polygon
                points="160.03 128.9 161.4 127.29 165.02 127.97 161.94 129.7 160.03 128.9"
                fill="#0d9913"
              />
              <polyline
                points="162.25 127.88 161.55 127.76 160.78 128.71"
                fill="none"
                stroke="#f2e2e8"
                strokeMiterlimit="10"
                strokeWidth="0.71"
              />
            </g>
            <g>
              <ellipse
                cx="71.6"
                cy="111.92"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M70.49,112.41a2,2,0,0,0,2.32-.31,1.21,1.21,0,0,1-1.22,1A1.25,1.25,0,0,1,70.49,112.41Z"
                fill="#c2c4c2"
              />
              <path
                d="M72.29,111.41a.76.76,0,0,0-.92-.44c.16.31.13.24.29.24a.51.51,0,0,1,.41.3C72.1,111.63,72.18,111.78,72.29,111.41Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="74.99"
              cy="122.9"
              rx="1.14"
              ry="1.42"
              transform="translate(-48.41 197.07) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="75.25"
                cy="116.06"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M74.14,116.55a2,2,0,0,0,2.32-.31,1.22,1.22,0,0,1-1.23,1A1.24,1.24,0,0,1,74.14,116.55Z"
                fill="#c2c4c2"
              />
              <path
                d="M75.93,115.55a.76.76,0,0,0-.91-.44c.15.32.13.24.29.24a.55.55,0,0,1,.41.3C75.75,115.77,75.82,115.92,75.93,115.55Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="74.68"
                cy="122.44"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M73.57,122.94a2.1,2.1,0,0,0,2.33-.31,1.21,1.21,0,0,1-1.23,1A1.24,1.24,0,0,1,73.57,122.94Z"
                fill="#c2c4c2"
              />
              <path
                d="M75.37,121.94a.76.76,0,0,0-.91-.45c.15.32.13.25.28.25a.53.53,0,0,1,.42.29C75.18,122.16,75.26,122.3,75.37,121.94Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="73.42"
                cy="125.17"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M72.31,125.66a2.06,2.06,0,0,0,2.33-.31,1.23,1.23,0,0,1-1.23,1A1.27,1.27,0,0,1,72.31,125.66Z"
                fill="#c2c4c2"
              />
              <path
                d="M74.11,124.67a.76.76,0,0,0-.91-.45c.15.32.12.24.28.24a.57.57,0,0,1,.42.3C73.92,124.88,74,125,74.11,124.67Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="71.97"
              cy="128.12"
              rx="1.14"
              ry="1.42"
              transform="translate(-56.62 199.24) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="71.79"
                cy="127.89"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M70.68,128.39a2.1,2.1,0,0,0,2.33-.31,1.22,1.22,0,0,1-1.23.95A1.25,1.25,0,0,1,70.68,128.39Z"
                fill="#c2c4c2"
              />
              <path
                d="M72.48,127.39a.76.76,0,0,0-.91-.45c.15.32.12.25.28.25a.53.53,0,0,1,.42.29C72.29,127.6,72.37,127.75,72.48,127.39Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="69.61"
              cy="130.27"
              rx="1.14"
              ry="1.42"
              transform="translate(-61.12 199.01) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="69.43"
                cy="130.04"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M68.32,130.53a2,2,0,0,0,2.32-.31,1.21,1.21,0,0,1-1.23,1A1.25,1.25,0,0,1,68.32,130.53Z"
                fill="#c2c4c2"
              />
              <path
                d="M70.11,129.53a.74.74,0,0,0-.91-.44c.16.31.13.24.29.24a.53.53,0,0,1,.41.3C69.93,129.75,70,129.9,70.11,129.53Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="66.76"
              cy="131.84"
              rx="1.14"
              ry="1.42"
              transform="translate(-65.52 197.72) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="66.58"
                cy="131.61"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M65.47,132.1a2,2,0,0,0,2.32-.31,1.21,1.21,0,0,1-1.22,1A1.25,1.25,0,0,1,65.47,132.1Z"
                fill="#c2c4c2"
              />
              <path
                d="M67.27,131.1a.76.76,0,0,0-.92-.44c.16.31.13.24.29.24a.51.51,0,0,1,.41.3C67.08,131.32,67.16,131.47,67.27,131.1Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="63.31"
              cy="132.03"
              rx="1.14"
              ry="1.42"
              transform="translate(-69.14 194.46) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="63.13"
                cy="131.8"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M62,132.3a2.08,2.08,0,0,0,2.32-.31,1.2,1.2,0,0,1-1.22.95A1.23,1.23,0,0,1,62,132.3Z"
                fill="#c2c4c2"
              />
              <path
                d="M63.82,131.3a.77.77,0,0,0-.92-.45c.16.32.13.25.29.25a.53.53,0,0,1,.42.29C63.63,131.52,63.71,131.66,63.82,131.3Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="60.21"
              cy="134.06"
              rx="1.14"
              ry="1.42"
              transform="translate(-74.24 193.37) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="60.03"
                cy="133.83"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M58.92,134.32a2,2,0,0,0,2.32-.31A1.21,1.21,0,0,1,60,135,1.25,1.25,0,0,1,58.92,134.32Z"
                fill="#c2c4c2"
              />
              <path
                d="M60.72,133.32a.76.76,0,0,0-.92-.44c.16.31.13.24.29.24a.51.51,0,0,1,.41.3C60.53,133.54,60.61,133.69,60.72,133.32Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="57.47"
              cy="137"
              rx="1.14"
              ry="1.42"
              transform="translate(-79.9 193.55) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="57.29"
                cy="136.77"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M56.18,137.26A2,2,0,0,0,58.5,137a1.21,1.21,0,0,1-1.22,1A1.25,1.25,0,0,1,56.18,137.26Z"
                fill="#c2c4c2"
              />
              <path
                d="M58,136.26a.74.74,0,0,0-.91-.44c.16.31.13.24.29.24a.51.51,0,0,1,.41.3C57.79,136.48,57.87,136.63,58,136.26Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="55.11"
              cy="139.26"
              rx="1.14"
              ry="1.42"
              transform="translate(-84.51 193.43) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="54.92"
                cy="139.03"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M53.81,139.52a2.06,2.06,0,0,0,2.33-.31,1.22,1.22,0,0,1-1.23,1A1.27,1.27,0,0,1,53.81,139.52Z"
                fill="#c2c4c2"
              />
              <path
                d="M55.61,138.52a.75.75,0,0,0-.91-.44c.15.31.13.24.28.24a.54.54,0,0,1,.42.3C55.42,138.74,55.5,138.89,55.61,138.52Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="52.97"
              cy="142.66"
              rx="1.14"
              ry="1.42"
              transform="translate(-90.03 194.68) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="52.79"
                cy="142.43"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M51.68,142.92a2.06,2.06,0,0,0,2.33-.31,1.22,1.22,0,0,1-1.23,1A1.27,1.27,0,0,1,51.68,142.92Z"
                fill="#c2c4c2"
              />
              <path
                d="M53.48,141.92a.76.76,0,0,0-.91-.44c.15.32.13.24.28.24a.57.57,0,0,1,.42.3C53.29,142.14,53.37,142.29,53.48,141.92Z"
                fill="#fff"
              />
            </g>
            <ellipse
              cx="76.5"
              cy="119.72"
              rx="1.14"
              ry="1.42"
              transform="translate(-43.73 195.42) rotate(-89.62)"
              fill="#573828"
              opacity="0.61"
            />
            <ellipse
              cx="67.52"
              cy="115.01"
              rx="2.15"
              ry="1.5"
              transform="translate(-21.61 15.8) rotate(-11.52)"
              fill="#573828"
              opacity="0.61"
            />
            <ellipse
              cx="68.08"
              cy="120.38"
              rx="2.15"
              ry="1.5"
              transform="translate(-22.67 16.02) rotate(-11.52)"
              fill="#573828"
              opacity="0.61"
            />
            <ellipse
              cx="66.43"
              cy="125.04"
              rx="2.15"
              ry="1.5"
              transform="translate(-23.63 15.78) rotate(-11.52)"
              fill="#573828"
              opacity="0.61"
            />
            <ellipse
              cx="62.2"
              cy="128.54"
              rx="2.15"
              ry="1.5"
              transform="translate(-24.41 15.01) rotate(-11.52)"
              fill="#573828"
              opacity="0.61"
            />
            <ellipse
              cx="58.11"
              cy="131.35"
              rx="2.15"
              ry="1.5"
              transform="translate(-25.06 14.25) rotate(-11.52)"
              fill="#573828"
              opacity="0.61"
            />
            <ellipse
              cx="53.77"
              cy="133.82"
              rx="2.15"
              ry="1.5"
              transform="translate(-25.64 13.43) rotate(-11.52)"
              fill="#573828"
              opacity="0.61"
            />
            <g>
              <ellipse
                cx="76.32"
                cy="119.26"
                rx="1.23"
                ry="1.14"
                fill="#dcf4dc"
              />
              <path
                d="M75.21,119.76a2.06,2.06,0,0,0,2.32-.31,1.2,1.2,0,0,1-1.22,1A1.23,1.23,0,0,1,75.21,119.76Z"
                fill="#c2c4c2"
              />
              <path
                d="M77,118.76a.77.77,0,0,0-.92-.45c.16.32.13.25.29.25a.5.5,0,0,1,.41.29C76.82,119,76.9,119.12,77,118.76Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="68.17"
                cy="109.94"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M67.4,110.29a1.41,1.41,0,0,0,1.62-.22.82.82,0,0,1-.86.67A.85.85,0,0,1,67.4,110.29Z"
                fill="#c2c4c2"
              />
              <path
                d="M68.65,109.59a.52.52,0,0,0-.63-.31c.1.22.09.17.2.17a.36.36,0,0,1,.29.21C68.52,109.74,68.58,109.85,68.65,109.59Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="100.26"
                cy="113.9"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M99.49,114.25a1.45,1.45,0,0,0,1.62-.22.86.86,0,0,1-.86.67A.85.85,0,0,1,99.49,114.25Z"
                fill="#c2c4c2"
              />
              <path
                d="M100.74,113.55a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17s.28.12.29.21S100.67,113.8,100.74,113.55Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="98.04"
                cy="114.56"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M97.26,114.91a1.43,1.43,0,0,0,1.63-.22.84.84,0,0,1-.86.67A.86.86,0,0,1,97.26,114.91Z"
                fill="#c2c4c2"
              />
              <path
                d="M98.52,114.21a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17a.36.36,0,0,1,.29.21C98.39,114.36,98.44,114.47,98.52,114.21Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="98.63"
                cy="116.51"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M97.86,116.86a1.45,1.45,0,0,0,1.62-.22.85.85,0,0,1-.86.67A.87.87,0,0,1,97.86,116.86Z"
                fill="#c2c4c2"
              />
              <path
                d="M99.11,116.16a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17a.39.39,0,0,1,.3.2C99,116.31,99,116.41,99.11,116.16Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="118.54"
                cy="120.12"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M117.76,120.47a1.46,1.46,0,0,0,1.63-.22.85.85,0,0,1-.86.67A.87.87,0,0,1,117.76,120.47Z"
                fill="#c2c4c2"
              />
              <path
                d="M119,119.77a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17a.36.36,0,0,1,.29.21C118.89,119.92,118.94,120,119,119.77Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="116.55"
                cy="121.93"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M115.77,122.28a1.46,1.46,0,0,0,1.63-.22.86.86,0,0,1-.86.67A.9.9,0,0,1,115.77,122.28Z"
                fill="#c2c4c2"
              />
              <path
                d="M117,121.58a.54.54,0,0,0-.64-.32c.11.23.09.18.2.18a.37.37,0,0,1,.29.2C116.9,121.73,117,121.83,117,121.58Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="118.38"
                cy="123.09"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M117.6,123.43a1.44,1.44,0,0,0,1.63-.21.86.86,0,0,1-.86.67A.88.88,0,0,1,117.6,123.43Z"
                fill="#c2c4c2"
              />
              <path
                d="M118.86,122.74a.54.54,0,0,0-.64-.32c.11.23.09.17.2.18s.28.12.29.2S118.78,123,118.86,122.74Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="120.23"
                cy="122.42"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M119.46,122.77a1.44,1.44,0,0,0,1.62-.22.84.84,0,0,1-.85.67A.87.87,0,0,1,119.46,122.77Z"
                fill="#c2c4c2"
              />
              <path
                d="M120.71,122.07a.52.52,0,0,0-.63-.31c.1.22.09.17.2.17a.37.37,0,0,1,.29.2C120.58,122.22,120.64,122.32,120.71,122.07Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="120.75"
                cy="120.6"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M120,121a1.46,1.46,0,0,0,1.63-.22.86.86,0,0,1-.86.67A.87.87,0,0,1,120,121Z"
                fill="#c2c4c2"
              />
              <path
                d="M121.23,120.25a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17a.37.37,0,0,1,.29.2C121.1,120.4,121.15,120.5,121.23,120.25Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="101.1"
                cy="116.19"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M100.32,116.54a1.46,1.46,0,0,0,1.63-.22.86.86,0,0,1-.86.67A.87.87,0,0,1,100.32,116.54Z"
                fill="#c2c4c2"
              />
              <path
                d="M101.58,115.84a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17a.36.36,0,0,1,.29.21C101.45,116,101.5,116.09,101.58,115.84Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="65.6"
                cy="108.89"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M64.82,109.24a1.46,1.46,0,0,0,1.63-.22.86.86,0,0,1-.86.67A.87.87,0,0,1,64.82,109.24Z"
                fill="#c2c4c2"
              />
              <path
                d="M66.08,108.54a.53.53,0,0,0-.64-.31c.11.22.09.17.2.17s.28.12.29.21S66,108.79,66.08,108.54Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="63.01"
                cy="108.98"
                rx="0.86"
                ry="0.8"
                fill="#dcf4dc"
              />
              <path
                d="M62.24,109.33a1.44,1.44,0,0,0,1.62-.22.84.84,0,0,1-.86.67A.87.87,0,0,1,62.24,109.33Z"
                fill="#c2c4c2"
              />
              <path
                d="M63.49,108.63a.52.52,0,0,0-.63-.31c.1.22.09.17.2.17a.36.36,0,0,1,.29.21C63.36,108.78,63.42,108.88,63.49,108.63Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="66.9"
                cy="114.04"
                rx="2.09"
                ry="1.94"
                fill="#dcf4dc"
              />
              <path
                d="M65,114.88a3.51,3.51,0,0,0,3.95-.53A2.05,2.05,0,0,1,66.88,116,2.13,2.13,0,0,1,65,114.88Z"
                fill="#c2c4c2"
              />
              <path
                d="M68.06,113.18a1.28,1.28,0,0,0-1.55-.75c.27.53.22.41.49.41a.94.94,0,0,1,.71.5C67.75,113.55,67.88,113.8,68.06,113.18Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="67.95"
                cy="119.41"
                rx="2.09"
                ry="1.94"
                fill="#dcf4dc"
              />
              <path
                d="M66.06,120.25a3.51,3.51,0,0,0,4-.52,2,2,0,0,1-2.09,1.62A2.1,2.1,0,0,1,66.06,120.25Z"
                fill="#c2c4c2"
              />
              <path
                d="M69.11,118.56a1.29,1.29,0,0,0-1.55-.76c.26.54.22.41.49.42a.88.88,0,0,1,.7.5C68.8,118.92,68.93,119.17,69.11,118.56Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="66.29"
                cy="124.07"
                rx="2.09"
                ry="1.94"
                fill="#dcf4dc"
              />
              <path
                d="M64.41,124.92a3.51,3.51,0,0,0,4-.53A2.06,2.06,0,0,1,66.27,126,2.1,2.1,0,0,1,64.41,124.92Z"
                fill="#c2c4c2"
              />
              <path
                d="M67.46,123.22a1.29,1.29,0,0,0-1.55-.76c.26.54.22.41.49.42a.88.88,0,0,1,.7.5C67.14,123.59,67.28,123.84,67.46,123.22Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="62.19"
                cy="127.46"
                rx="2.09"
                ry="1.94"
                fill="#dcf4dc"
              />
              <path
                d="M60.31,128.3a3.51,3.51,0,0,0,4-.53,2.06,2.06,0,0,1-2.09,1.63A2.11,2.11,0,0,1,60.31,128.3Z"
                fill="#c2c4c2"
              />
              <path
                d="M63.36,126.6a1.3,1.3,0,0,0-1.55-.76c.26.54.22.42.48.42a.9.9,0,0,1,.71.5C63,127,63.17,127.22,63.36,126.6Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="57.97"
                cy="130.5"
                rx="2.09"
                ry="1.94"
                fill="#dcf4dc"
              />
              <path
                d="M56.09,131.34a3.51,3.51,0,0,0,3.95-.53A2.06,2.06,0,0,1,58,132.44,2.11,2.11,0,0,1,56.09,131.34Z"
                fill="#c2c4c2"
              />
              <path
                d="M59.14,129.64a1.3,1.3,0,0,0-1.55-.76c.26.54.22.42.49.42a.9.9,0,0,1,.7.5C58.82,130,59,130.26,59.14,129.64Z"
                fill="#fff"
              />
            </g>
            <g>
              <ellipse
                cx="53.15"
                cy="132.73"
                rx="2.09"
                ry="1.94"
                fill="#dcf4dc"
              />
              <path
                d="M51.26,133.58a3.51,3.51,0,0,0,4-.53,2,2,0,0,1-2.08,1.62A2.12,2.12,0,0,1,51.26,133.58Z"
                fill="#c2c4c2"
              />
              <path
                d="M54.31,131.88a1.29,1.29,0,0,0-1.55-.76c.27.54.22.41.49.42a.9.9,0,0,1,.71.5C54,132.25,54.13,132.49,54.31,131.88Z"
                fill="#fff"
              />
            </g>
            <polygon
              points="63.33 91.87 66.46 109.01 75.3 110.92 70.69 94.38 63.33 91.87"
              fill="#aa781f"
              opacity="0.65"
            />
            <g>
              <path
                d="M75,112.63,68,86.1s11.12-3.78,7.57-17.28c1.11.59,3.07,1.06,3,0s-2.31-2.3-2.5-7.67c-.61-.23-2.45-1-3.85,2.82s2.15,16.79-5.26,19.12c-2.11-9.26-5-22.3-5-22.3s3.2-.31,3.45-1-6-10.67-7.51-10.69-2.83,11-2.1,12.08,2.7-.09,2.7-.09l4.8,22.64S59,85.1,55.24,77.42s-6.13-13.3-9-13c-.53,3.42-.33,8.1-1,9.34,1.72-.32,3.23-2.82,3.23-3.27.35,2,5,18.64,14.6,16.22l5.53,23.1Z"
                fill="#ffaf00"
              />
              <path
                d="M76.1,61.19c-.61-.24-2.45-1-3.85,2.81S74.41,80.79,67,83.12"
                fill="none"
                stroke="#d69000"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
              <line
                x1="63.75"
                y1="86.74"
                x2="69.28"
                y2="109.84"
                fill="none"
                stroke="#d69000"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
              <path
                d="M45.31,73.78c1.72-.32,3.23-2.82,3.23-3.27.35,2,5,18.64,14.6,16.22"
                fill="none"
                stroke="#d69000"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
              <path
                d="M55.92,60.77c.72,1,2.71-.09,2.71-.09l4.79,22.63"
                fill="none"
                stroke="#d69000"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
              <path
                d="M74.85,63s-.78,3.64,1.19,4.23"
                fill="none"
                stroke="#f2e2c4"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
              <path
                d="M58.61,51.43s2.32,1.62,3.5,6.09"
                fill="none"
                stroke="#f2e2c4"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
              <path
                d="M47.24,65.93a17.14,17.14,0,0,1,4.84,8.15"
                fill="none"
                stroke="#f2e2c4"
                strokeMiterlimit="10"
                strokeWidth="0.95"
              />
            </g>
            <path
              d="M198.35,128.19S189,114.63,161.81,126C144,119.34,69.27,89.19,69.27,89.19s6.13-8.73,29.52,2.51C119.63,99.42,198.35,128.19,198.35,128.19Z"
              fill="#af4904"
            />
            <path
              d="M124.27,101.64c1.94.57,3.93,1,5.84,1.73a29,29,0,0,1,2.82,1.19,13.23,13.23,0,0,1,2.64,1.59,8.35,8.35,0,0,1,1,1.18,6.55,6.55,0,0,0,1.08,1,14.28,14.28,0,0,0,2.54,1.6A20.92,20.92,0,0,0,143,111a24.54,24.54,0,0,1,2.83,1.13c-1.87-.8-3.89-1.12-5.78-2a13.51,13.51,0,0,1-2.62-1.6,7.07,7.07,0,0,1-1.14-1,8.53,8.53,0,0,0-1-1.14,13.7,13.7,0,0,0-2.55-1.56c-.9-.45-1.83-.85-2.77-1.22C128.13,102.89,126.17,102.34,124.27,101.64Z"
              fill="#683009"
            />
            <path
              d="M110.63,99.22c1.94.58,3.93,1,5.84,1.74a26.74,26.74,0,0,1,2.82,1.19,13.67,13.67,0,0,1,2.64,1.58,9,9,0,0,1,1,1.19,6.55,6.55,0,0,0,1.08,1,14.28,14.28,0,0,0,2.54,1.6,20.08,20.08,0,0,0,2.83,1.07,26.55,26.55,0,0,1,2.83,1.14c-1.87-.81-3.89-1.12-5.78-2a13.51,13.51,0,0,1-2.62-1.6,7.07,7.07,0,0,1-1.14-1,8.53,8.53,0,0,0-1-1.14,13.38,13.38,0,0,0-2.55-1.56c-.9-.46-1.83-.85-2.77-1.22C114.5,100.47,112.54,99.93,110.63,99.22Z"
              fill="#683009"
            />
            <path
              d="M154.26,116.37c1.22.55,2.43,1.11,3.63,1.7.6.29,1.21.58,1.79.91l.43.26c.14.12.3.15.4.39s-.12.13-.15.14h-.14l-.26,0-.5-.11a72.4,72.4,0,0,1-7.59-2.63c-1.24-.5-2.48-1-3.7-1.57-.61-.28-1.21-.57-1.8-.91a3.87,3.87,0,0,1-.43-.27,1.57,1.57,0,0,1-.21-.17c0-.07-.19-.11-.13-.34s.23-.1.32-.12h.27l.5.08a31.6,31.6,0,0,1,3.85,1.15C151.8,115.31,153.05,115.81,154.26,116.37Zm0,0a34.83,34.83,0,0,0-7.6-2.48,4.1,4.1,0,0,0-.49-.06,1.21,1.21,0,0,0-.38,0c0-.07,0,0,.09.07a1.33,1.33,0,0,0,.19.14c.13.09.28.17.42.25.58.31,1.2.58,1.81.85,1.22.53,2.46,1,3.7,1.51s2.48,1,3.73,1.46,2.5,1,3.78,1.33c.16,0,.32.09.48.12l.24,0c.07,0,.18,0,.14,0a3,3,0,0,0-.74-.55c-.58-.34-1.16-.66-1.76-1C156.68,117.51,155.47,116.93,154.26,116.37Z"
              fill="#683009"
            />
            <path
              d="M100.08,94.63c1.22.55,2.44,1.11,3.64,1.7.6.29,1.2.59,1.79.91l.43.26c.14.12.29.15.4.39s-.13.13-.16.14H106l-.25,0-.5-.11a71.61,71.61,0,0,1-7.59-2.63c-1.24-.5-2.48-1-3.7-1.57-.61-.28-1.22-.57-1.8-.91a3.87,3.87,0,0,1-.43-.27.87.87,0,0,1-.21-.17c0-.07-.19-.11-.13-.34s.23-.1.32-.12H92l.51.08a31.6,31.6,0,0,1,3.85,1.15C97.63,93.57,98.87,94.07,100.08,94.63Zm0,0a34.66,34.66,0,0,0-7.6-2.48,3.93,3.93,0,0,0-.48-.06,1.18,1.18,0,0,0-.38,0c0-.07,0,0,.09.07a1.24,1.24,0,0,0,.18.14l.43.25c.58.31,1.19.58,1.8.85,1.22.53,2.47,1,3.71,1.51s2.48,1,3.73,1.47,2.5.95,3.77,1.32c.16,0,.32.09.49.12l.23,0c.07,0,.19,0,.14,0a2.65,2.65,0,0,0-.74-.56c-.57-.34-1.16-.66-1.75-1C102.5,95.77,101.3,95.2,100.08,94.63Z"
              fill="#683009"
            />
            <path
              d="M156.4,114.5a3,3,0,0,0,1.87.81,11.1,11.1,0,0,1,2.11.42,5,5,0,0,0,2,.4,4.24,4.24,0,0,1,2.08.5,5.43,5.43,0,0,0-2.07-.22,4.71,4.71,0,0,1-2.14-.35,13.48,13.48,0,0,0-2-.48,4,4,0,0,1-1-.35A2.51,2.51,0,0,1,156.4,114.5Z"
              fill="#683009"
            />
            <path
              d="M145.5,109.14a3,3,0,0,0,1.88.82,11.23,11.23,0,0,1,2.11.41,4.73,4.73,0,0,0,2,.41,4.3,4.3,0,0,1,2.09.5,5.69,5.69,0,0,0-2.07-.23,4.54,4.54,0,0,1-2.14-.34,13.9,13.9,0,0,0-2-.48,3.8,3.8,0,0,1-1-.35A2.58,2.58,0,0,1,145.5,109.14Z"
              fill="#683009"
            />
            <path
              d="M105,99.4a2.94,2.94,0,0,0,1.87.82,11.23,11.23,0,0,1,2.11.41,4.73,4.73,0,0,0,2,.41,4.3,4.3,0,0,1,2.09.5,5.48,5.48,0,0,0-2.07-.23,4.69,4.69,0,0,1-2.14-.34,15.31,15.31,0,0,0-2-.49,3.78,3.78,0,0,1-1-.34A2.55,2.55,0,0,1,105,99.4Z"
              fill="#683009"
            />
            <path
              d="M79.51,87.75a2.88,2.88,0,0,0,1.87.81,11.94,11.94,0,0,1,2.11.42,4.6,4.6,0,0,0,2,.4,4.42,4.42,0,0,1,2.09.5,5.63,5.63,0,0,0-2.07-.22,4.82,4.82,0,0,1-2.14-.34,12.51,12.51,0,0,0-2-.49,3.8,3.8,0,0,1-1-.35A2.41,2.41,0,0,1,79.51,87.75Z"
              fill="#683009"
            />
            <path
              d="M87.74,88.85a3,3,0,0,0,1.88.82,11.23,11.23,0,0,1,2.11.41,4.73,4.73,0,0,0,2,.41,4.3,4.3,0,0,1,2.09.5,5.69,5.69,0,0,0-2.07-.23,4.54,4.54,0,0,1-2.14-.34,13.9,13.9,0,0,0-2.05-.48,3.8,3.8,0,0,1-1-.35A2.58,2.58,0,0,1,87.74,88.85Z"
              fill="#683009"
            />
            <path
              d="M78.29,86c6.61,2.58,85.2,32.54,85.2,32.54"
              fill="#96440c"
              stroke="#6d3007"
              strokeMiterlimit="10"
              strokeWidth="0.36"
            />
            <path
              d="M163.49,118.5s6.61-2.62,9.74-1.51,16.56,5.68,16.56,5.68-8-4.62-27.92,3.29c-16.43-6.32-92.54-36.83-92.54-36.83a12.18,12.18,0,0,1,9-3.17"
              fill="#96440c"
              stroke="#6d3007"
              strokeMiterlimit="10"
              strokeWidth="0.83"
            />
            <path
              d="M112.1,106.2a11.36,11.36,0,0,1,8.79-4c7.35,2.93,7.29,2.92,7.29,2.92"
              fill="#573828"
              stroke="#441f07"
              strokeMiterlimit="10"
              strokeWidth="0.03"
            />
            <path
              d="M128.18,105.15s-6.56-1.14-9.88,3.56c-6.14-2.45-6.2-2.51-6.2-2.51"
              fill="#573828"
              stroke="#441f07"
              strokeMiterlimit="10"
              strokeWidth="0.24"
            />
            <path
              d="M117.82,106.65s-2.86,2.6-2.39,5.23c-1.48,0-3.33,0-3.55-1.75s1.52-4.55,3.62-4.64"
              fill="none"
              stroke="#573828"
              strokeMiterlimit="10"
              strokeWidth="1.3"
            />
            <ellipse
              cx="172.16"
              cy="119.27"
              rx="0.8"
              ry="1.42"
              transform="translate(51.38 290.37) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="162.65"
              cy="122.26"
              rx="0.8"
              ry="1.42"
              transform="translate(38.96 283.82) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="155.17"
              cy="118.99"
              rx="0.8"
              ry="1.42"
              transform="translate(34.82 273.11) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="147.21"
              cy="115.6"
              rx="0.8"
              ry="1.42"
              transform="translate(30.31 261.79) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="139.73"
              cy="112.57"
              rx="0.8"
              ry="1.42"
              transform="translate(25.94 251.3) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="132.5"
              cy="110.22"
              rx="0.8"
              ry="1.42"
              transform="translate(21.12 241.73) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="125.88"
              cy="107.53"
              rx="0.8"
              ry="1.42"
              transform="translate(17.24 232.45) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="111.66"
              cy="101.92"
              rx="0.8"
              ry="1.42"
              transform="translate(8.76 212.67) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="104.68"
              cy="98.88"
              rx="0.8"
              ry="1.42"
              transform="translate(4.87 202.68) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="97.32"
              cy="96.53"
              rx="0.8"
              ry="1.42"
              transform="translate(-0.07 192.99) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="89.97"
              cy="93.27"
              rx="0.8"
              ry="1.42"
              transform="translate(-4.09 182.4) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="82.11"
              cy="90.68"
              rx="0.8"
              ry="1.42"
              transform="translate(-9.29 171.99) rotate(-89.49)"
              fill="#6d3007"
            />
            <ellipse
              cx="74.88"
              cy="87.76"
              rx="0.8"
              ry="1.42"
              transform="translate(-13.53 161.87) rotate(-89.49)"
              fill="#6d3007"
            />
            <g>
              <ellipse
                cx="55.56"
                cy="186.84"
                rx="0.91"
                ry="3.02"
                transform="matrix(0.01, -1, 1, 0.01, -131.79, 240.64)"
                fill="#d1a11e"
              />
              <polygon
                points="58.58 186.41 58.58 186.87 52.55 186.81 52.55 186.35 58.58 186.41"
                fill="#d1a11e"
              />
              <ellipse
                cx="55.57"
                cy="186.38"
                rx="0.91"
                ry="3.02"
                transform="translate(-131.33 240.2) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="60.29"
                cy="193.04"
                rx="0.91"
                ry="3.02"
                transform="translate(-133.31 251.52) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="63.31 192.62 63.31 193.07 57.28 193.01 57.28 192.56 63.31 192.62"
                fill="#d1a11e"
              />
              <ellipse
                cx="60.3"
                cy="192.59"
                rx="0.91"
                ry="3.02"
                transform="translate(-132.85 251.08) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="68.34"
                cy="198.93"
                rx="1.43"
                ry="4.73"
                transform="translate(-131.22 265.41) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="73.08 198.26 73.07 198.98 63.61 198.89 63.62 198.17 73.08 198.26"
                fill="#d1a11e"
              />
              <ellipse
                cx="68.35"
                cy="198.22"
                rx="1.43"
                ry="4.73"
                transform="translate(-130.5 264.71) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="88.97"
                cy="204"
                rx="1.47"
                ry="4.85"
                transform="translate(-115.85 291.05) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="93.83 203.31 93.82 204.04 84.12 203.95 84.13 203.22 93.83 203.31"
                fill="#d1a11e"
              />
              <ellipse
                cx="88.98"
                cy="203.26"
                rx="1.47"
                ry="4.85"
                transform="translate(-115.11 290.33) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="80.85"
                cy="198.4"
                rx="1.47"
                ry="4.85"
                transform="translate(-118.3 277.38) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="85.71 197.71 85.7 198.45 76 198.35 76 197.62 85.71 197.71"
                fill="#d1a11e"
              />
              <ellipse
                cx="80.86"
                cy="197.67"
                rx="1.47"
                ry="4.85"
                transform="translate(-117.56 276.66) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
            <g>
              <ellipse
                cx="61.56"
                cy="189.75"
                rx="0.91"
                ry="3.02"
                transform="translate(-128.76 249.52) rotate(-89.46)"
                fill="#d1a11e"
              />
              <polygon
                points="64.58 189.32 64.58 189.78 58.55 189.72 58.55 189.26 64.58 189.32"
                fill="#d1a11e"
              />
              <ellipse
                cx="61.57"
                cy="189.29"
                rx="0.91"
                ry="3.02"
                transform="translate(-128.29 249.08) rotate(-89.46)"
                fill="#eaa907"
              />
            </g>
          </g>
        </g>
        <g className="text" transform="translate(20 -35)">
          <path
            d="M62.67,276.6q-.3-1.85-.66-3.69c-.24-1.22-.52-2.45-.83-3.69-.22,1.14-.47,2.28-.77,3.41s-.64,2.25-1,3.38a2.13,2.13,0,0,1-.33.59,1.07,1.07,0,0,1-.61.31,6,6,0,0,1-1.29.14,1.58,1.58,0,0,1-.89-.21,1.34,1.34,0,0,1-.46-.67,31.66,31.66,0,0,1-1.07-3.43c-.3-1.15-.6-2.33-.91-3.52-.27,1.07-.49,2.19-.67,3.35s-.35,2.42-.52,3.76a1.61,1.61,0,0,1-.22.71c-.11.15-.36.23-.75.23a8.54,8.54,0,0,1-.92,0c-.28,0-.54-.07-.79-.12a.74.74,0,0,1-.7-.78v-.18s0-.12,0-.19a54,54,0,0,1,1.11-5.35q.69-2.64,1.61-5.45a1.39,1.39,0,0,1,.34-.6,1.32,1.32,0,0,1,.68-.25l.59-.05a5.15,5.15,0,0,1,.55,0h.27a1.06,1.06,0,0,1,.25,0,1.21,1.21,0,0,1,.65.23,1.63,1.63,0,0,1,.45.67,29,29,0,0,1,1.06,2.91c.3,1,.59,2,.88,3,.23-1,.47-2,.73-3a21,21,0,0,1,1-3,1.28,1.28,0,0,1,1.11-.81l.59-.06h1a1.29,1.29,0,0,1,.72.28,1.87,1.87,0,0,1,.42.71A49.79,49.79,0,0,1,65,270.54a54.81,54.81,0,0,1,1.09,5.54,1.65,1.65,0,0,1,0,.27.65.65,0,0,1-.5.72,4.2,4.2,0,0,1-.87.18,6.88,6.88,0,0,1-.92.06,2.64,2.64,0,0,1-.76-.1C62.86,277.14,62.73,276.94,62.67,276.6Z"
            fill="#fff"
          />
          <path
            d="M75.72,275.94a2.8,2.8,0,0,1-.09.68.65.65,0,0,1-.41.4,4.52,4.52,0,0,1-1,.29,6.24,6.24,0,0,1-1,.09c-.43,0-.65-.19-.65-.56,0-.07,0-.15,0-.22a1.85,1.85,0,0,0,0-.25,4.71,4.71,0,0,1-1.4.7,5.12,5.12,0,0,1-1.55.24,5.49,5.49,0,0,1-.85-.08,2.53,2.53,0,0,1-.91-.35,2.09,2.09,0,0,1-.73-.77,2.72,2.72,0,0,1-.3-1.38c0-.32,0-.7,0-1.13s0-.9.07-1.4.07-1,.13-1.55.11-1.08.19-1.61a.85.85,0,0,1,.36-.68,1.87,1.87,0,0,1,.88-.16,4.26,4.26,0,0,1,.61,0,3.06,3.06,0,0,1,.56.14.92.92,0,0,1,.44.29.8.8,0,0,1,.13.5c0,.13,0,.35,0,.66s-.07.66-.1,1.06-.07.84-.1,1.31,0,.95,0,1.42a1.2,1.2,0,0,0,.17.69.57.57,0,0,0,.51.26,3.14,3.14,0,0,0,1-.17,4.09,4.09,0,0,0,1-.53c0-.55,0-1.08,0-1.59s-.06-1-.09-1.37-.06-.77-.09-1.06,0-.5,0-.61a.78.78,0,0,1,.19-.56,1.82,1.82,0,0,1,.74-.34l.52-.1a3.53,3.53,0,0,1,.54,0,1.51,1.51,0,0,1,.77.15.81.81,0,0,1,.3.62c.09.9.17,1.83.23,2.78s.09,1.91.09,2.87v.67C75.74,275.51,75.73,275.72,75.72,275.94Z"
            fill="#fff"
          />
          <path
            d="M77.43,265.46a2.49,2.49,0,0,1,.16-.8.64.64,0,0,1,.38-.26,6,6,0,0,1,1-.16,8.42,8.42,0,0,1,.91-.06.49.49,0,0,1,.4.15.91.91,0,0,1,.13.56c0,.27,0,.55,0,.84v.9c0,.83,0,1.69,0,2.58s0,1.75-.07,2.6-.05,1.64-.09,2.37-.07,1.37-.12,1.9a2.63,2.63,0,0,1-.15.74c-.08.17-.31.27-.7.31h-1a1,1,0,0,1-.73-.26,1.18,1.18,0,0,1-.2-.64c0-.54-.09-1.21-.11-2s0-1.64,0-2.57,0-2.06.07-3.14S77.34,266.43,77.43,265.46Z"
            fill="#fff"
          />
          <path
            d="M81.37,269.87a2,2,0,0,1,0-.48.56.56,0,0,1,.17-.29.76.76,0,0,1,.34-.15l.58-.09v-.5c0-.23,0-.46,0-.68s0-.48,0-.74a2.77,2.77,0,0,1,.1-.58A.77.77,0,0,1,83,266a2.31,2.31,0,0,1,.72-.21A9.08,9.08,0,0,1,85,265.7a.72.72,0,0,1,.58.2,1,1,0,0,1,.16.61c0,.06,0,.17,0,.33s0,.36,0,.58l0,.72c0,.24,0,.47,0,.69l.62.06.64.08a.81.81,0,0,1,.51.23.84.84,0,0,1,.14.53q0,.18,0,.48c0,.19,0,.38-.06.54a.81.81,0,0,1-.25.5,1.11,1.11,0,0,1-.58.17l-.53.05a3.66,3.66,0,0,1-.42,0c0,.4,0,.86,0,1.37s.05,1,.08,1.49.06.92.08,1.3,0,.64,0,.76a.74.74,0,0,1-.13.48.81.81,0,0,1-.52.22,8.91,8.91,0,0,1-1.36.11.74.74,0,0,1-.52-.16.9.9,0,0,1-.22-.58q-.18-1.28-.3-2.52c-.08-.83-.15-1.69-.21-2.57l-.46-.06a1,1,0,0,1-.55-.17.73.73,0,0,1-.21-.55l0-.4C81.38,270.08,81.37,270,81.37,269.87Z"
            fill="#fff"
          />
          <path
            d="M90.1,264a4.2,4.2,0,0,1,.86.07,1.26,1.26,0,0,1,.58.28,1.22,1.22,0,0,1,.32.57,4,4,0,0,1,.1,1,2.61,2.61,0,0,1-.08.64,1.27,1.27,0,0,1-.28.51,1.22,1.22,0,0,1-.57.34,3,3,0,0,1-.93.11,3.42,3.42,0,0,1-.84-.08,1.15,1.15,0,0,1-.55-.28,1.19,1.19,0,0,1-.3-.54,3.43,3.43,0,0,1-.09-.86,1.82,1.82,0,0,1,.41-1.29A1.86,1.86,0,0,1,90.1,264Zm-1.47,5.44a2.63,2.63,0,0,1,.11-.7.51.51,0,0,1,.45-.33,4.22,4.22,0,0,1,.69-.1l.76,0H91l.29,0c.18,0,.29.07.33.16a1.63,1.63,0,0,1,.06.56c0,1.29,0,2.49,0,3.61s-.09,2.28-.17,3.48a4.31,4.31,0,0,1,0,.46.58.58,0,0,1-.12.31.6.6,0,0,1-.28.17,1.82,1.82,0,0,1-.52.05,8,8,0,0,1-1-.05c-.38,0-.61-.13-.71-.28a1.27,1.27,0,0,1-.19-.67c0-.44,0-.86-.06-1.29s0-.85,0-1.27c0-.68,0-1.36,0-2S88.58,270.18,88.63,269.48Z"
            fill="#fff"
          />
          <path
            d="M96.8,271a.77.77,0,0,1,.52.17.72.72,0,0,1,.24.5c0,.23,0,.46,0,.7v.54a1.46,1.46,0,0,1-.18.83.73.73,0,0,1-.54.29c-.65.07-1.25.12-1.81.15s-1.09.05-1.59.05a.59.59,0,0,1-.43-.19,1,1,0,0,1-.18-.66v-.67c0-.13,0-.25,0-.37s0-.22,0-.29a.86.86,0,0,1,.24-.65,1,1,0,0,1,.42-.2c.48-.06,1-.11,1.57-.14S96.24,271,96.8,271Z"
            fill="#fff"
          />
          <path
            d="M98.82,269.6a1.76,1.76,0,0,1,.19-.8,1,1,0,0,1,.63-.33,5.61,5.61,0,0,1,.9-.12l.89,0c.24,0,.39.06.46.17a.93.93,0,0,1,.11.54,3.29,3.29,0,0,1,1.24-.73,4.55,4.55,0,0,1,1.44-.25,4.23,4.23,0,0,1,1.52.28,3.55,3.55,0,0,1,1.23.84,3.94,3.94,0,0,1,.83,1.4,6.3,6.3,0,0,1,.29,2,4.62,4.62,0,0,1-.37,1.87,5.12,5.12,0,0,1-1,1.51,4.78,4.78,0,0,1-1.44,1,4,4,0,0,1-1.66.36,6,6,0,0,1-2.14-.35c0,.21,0,.43,0,.66l0,.7c0,.24,0,.46,0,.67s0,.39,0,.55a1.25,1.25,0,0,1-.14.66,1.67,1.67,0,0,1-.58.44l-.4.19-.46.18-.45.13a1.38,1.38,0,0,1-.36.05c-.35,0-.55-.2-.6-.61-.12-1-.2-2-.25-3.06s-.07-2.13-.07-3.26C98.71,272.76,98.74,271.21,98.82,269.6Zm3.09,2.11c0,.31,0,.62,0,.93v1.68a2.21,2.21,0,0,0,1.17.3,2.35,2.35,0,0,0,.87-.16,2.64,2.64,0,0,0,.74-.44,2.19,2.19,0,0,0,.52-.65,1.62,1.62,0,0,0,.2-.78,1.57,1.57,0,0,0-.46-1.25,1.72,1.72,0,0,0-1.15-.39,3,3,0,0,0-1,.17A2.46,2.46,0,0,0,101.91,271.71Z"
            fill="#fff"
          />
          <path
            d="M118.33,275.94a2.8,2.8,0,0,1-.09.68.67.67,0,0,1-.42.4,4.43,4.43,0,0,1-1,.29,6.46,6.46,0,0,1-1,.09c-.44,0-.65-.19-.65-.56a1.62,1.62,0,0,1,0-.22c0-.07,0-.15,0-.25a4.65,4.65,0,0,1-1.41.7,5.05,5.05,0,0,1-1.54.24,5.61,5.61,0,0,1-.86-.08,2.6,2.6,0,0,1-.91-.35,2.09,2.09,0,0,1-.73-.77,2.72,2.72,0,0,1-.29-1.38c0-.32,0-.7,0-1.13s0-.9.07-1.4.08-1,.13-1.55.12-1.08.19-1.61a.86.86,0,0,1,.37-.68,1.85,1.85,0,0,1,.87-.16,4.17,4.17,0,0,1,.61,0,2.86,2.86,0,0,1,.56.14.92.92,0,0,1,.44.29.8.8,0,0,1,.14.5c0,.13,0,.35,0,.66s-.06.66-.1,1.06-.07.84-.1,1.31,0,.95,0,1.42a1.28,1.28,0,0,0,.17.69.57.57,0,0,0,.51.26,3.25,3.25,0,0,0,1-.17,4,4,0,0,0,1-.53c0-.55,0-1.08,0-1.59s-.06-1-.09-1.37-.06-.77-.09-1.06-.05-.5-.05-.61a.78.78,0,0,1,.2-.56,1.76,1.76,0,0,1,.74-.34l.51-.1a3.65,3.65,0,0,1,.55,0,1.47,1.47,0,0,1,.76.15.76.76,0,0,1,.3.62c.1.9.18,1.83.23,2.78s.1,1.91.1,2.87v.67C118.35,275.51,118.34,275.72,118.33,275.94Z"
            fill="#fff"
          />
          <path
            d="M119.8,269.33a4.1,4.1,0,0,1,.08-.69.52.52,0,0,1,.43-.37,3,3,0,0,1,.5-.09l.6-.06.61-.05.52,0a.43.43,0,0,1,.36.13.57.57,0,0,1,.09.34,2.44,2.44,0,0,1,0,.26c0,.11,0,.2,0,.28a4.18,4.18,0,0,1,1.13-.72,3.31,3.31,0,0,1,1.34-.27.84.84,0,0,1,.75.4,2.25,2.25,0,0,1,.37.84,6.18,6.18,0,0,1,.1.91c0,.33,0,.62,0,.86a1.18,1.18,0,0,1-.19.66,1.9,1.9,0,0,1-.69.58,6.25,6.25,0,0,1-.6.26,1.78,1.78,0,0,1-.57.14.54.54,0,0,1-.47-.26,1.07,1.07,0,0,1-.16-.57c0-.13,0-.31,0-.52a3.87,3.87,0,0,0-.07-.56c-.17.08-.32.17-.46.25a3.67,3.67,0,0,0-.51.38c0,.65,0,1.26,0,1.83s.06,1.07.09,1.51.06.8.09,1.1,0,.48,0,.58a.62.62,0,0,1-.19.47,1.44,1.44,0,0,1-.77.2h-1.17a1,1,0,0,1-.73-.26,1.27,1.27,0,0,1-.22-.64c-.1-.92-.18-1.84-.24-2.78s-.08-1.89-.08-2.82V270C119.79,269.76,119.79,269.55,119.8,269.33Z"
            fill="#fff"
          />
          <path
            d="M127.72,269.6a1.74,1.74,0,0,1,.2-.8,1,1,0,0,1,.63-.33,5.48,5.48,0,0,1,.89-.12l.89,0a.53.53,0,0,1,.47.17,1,1,0,0,1,.11.54,3.29,3.29,0,0,1,1.24-.73,4.55,4.55,0,0,1,1.44-.25,4.18,4.18,0,0,1,1.51.28,3.59,3.59,0,0,1,1.24.84,3.79,3.79,0,0,1,.82,1.4,6,6,0,0,1,.3,2,4.63,4.63,0,0,1-.38,1.87,4.91,4.91,0,0,1-1,1.51,4.82,4.82,0,0,1-1.45,1,4,4,0,0,1-1.65.36,6,6,0,0,1-2.14-.35c0,.21,0,.43,0,.66l0,.7c0,.24,0,.46,0,.67s0,.39,0,.55a1.25,1.25,0,0,1-.14.66,1.67,1.67,0,0,1-.58.44l-.4.19-.47.18-.45.13a1.29,1.29,0,0,1-.36.05c-.35,0-.54-.2-.59-.61-.12-1-.2-2-.25-3.06s-.07-2.13-.07-3.26C127.62,272.76,127.65,271.21,127.72,269.6Zm3.1,2.11c0,.31,0,.62,0,.93v1.68a2.17,2.17,0,0,0,1.17.3,2.27,2.27,0,0,0,.86-.16,2.38,2.38,0,0,0,.74-.44,2,2,0,0,0,.52-.65,1.51,1.51,0,0,0,.2-.78,1.53,1.53,0,0,0-.46-1.25,1.68,1.68,0,0,0-1.14-.39,3,3,0,0,0-1,.17A2.38,2.38,0,0,0,130.82,271.71Z"
            fill="#fff"
          />
          <path
            d="M144.64,268.25a1.79,1.79,0,0,1,.37.19.47.47,0,0,1,.14.39s0,.08,0,.13,0,.15,0,.28a3.91,3.91,0,0,1,2.21,1.37,4.3,4.3,0,0,1,.38,4.35,4.4,4.4,0,0,1-1.11,1.34,5.07,5.07,0,0,1-1.54.82,5.68,5.68,0,0,1-1.72.28,7.34,7.34,0,0,1-2.12-.29,4.33,4.33,0,0,1-1.62-.86,3.63,3.63,0,0,1-1-1.4,4.83,4.83,0,0,1-.36-1.92,4.42,4.42,0,0,1,.45-2,4.87,4.87,0,0,1,1.17-1.54,5.29,5.29,0,0,1,1.63-1,5,5,0,0,1,1.84-.36,4.27,4.27,0,0,1,.68.06A4.42,4.42,0,0,1,144.64,268.25Zm-.56,3.46a2.53,2.53,0,0,1-.35-.14.6.6,0,0,1-.22-.16.59.59,0,0,1-.14-.26,1.69,1.69,0,0,1,0-.43,2.36,2.36,0,0,0-1.53.73,2.18,2.18,0,0,0-.61,1.59,1.64,1.64,0,0,0,.15.71,1.46,1.46,0,0,0,.42.53,1.94,1.94,0,0,0,.62.33,2.66,2.66,0,0,0,.75.1,2.76,2.76,0,0,0,.75-.1,2.15,2.15,0,0,0,.66-.33,1.62,1.62,0,0,0,.48-.53,1.41,1.41,0,0,0,.18-.71,1.17,1.17,0,0,0-.31-.85A1.57,1.57,0,0,0,144.08,271.71Z"
            fill="#fff"
          />
          <path
            d="M155.89,274.64a2,2,0,0,1-.3,1.1,3.05,3.05,0,0,1-.84.84,4.28,4.28,0,0,1-1.26.54,6.58,6.58,0,0,1-1.58.19,9.07,9.07,0,0,1-1.35-.1,5.27,5.27,0,0,1-1.15-.32.62.62,0,0,1-.48-.59,1.37,1.37,0,0,1,0-.38,4.32,4.32,0,0,1,.21-.55c.09-.2.16-.37.22-.53s.25-.38.38-.38a1.53,1.53,0,0,1,.47.15,3.47,3.47,0,0,0,.71.23,3.19,3.19,0,0,0,.64.07,2,2,0,0,0,.66-.09.34.34,0,0,0,.26-.34c0-.13-.1-.25-.28-.36a5.18,5.18,0,0,0-.7-.33l-.9-.4a4.22,4.22,0,0,1-.9-.56,3,3,0,0,1-.69-.81,2.19,2.19,0,0,1-.28-1.16,2.15,2.15,0,0,1,.35-1.18,3.29,3.29,0,0,1,.92-.9,5,5,0,0,1,1.3-.57,5.33,5.33,0,0,1,1.5-.21,8.6,8.6,0,0,1,1.32.11,7.26,7.26,0,0,1,1.24.3.93.93,0,0,1,.44.28.88.88,0,0,1,.15.55,6,6,0,0,1-.08.87,7.72,7.72,0,0,1-.17.82,1.24,1.24,0,0,1-.23.43.64.64,0,0,1-.49.15,5.65,5.65,0,0,1-1.08-.11.76.76,0,0,1-.46-.2,1,1,0,0,1-.1-.55v-.13a2.49,2.49,0,0,0-.58-.09,2,2,0,0,0-.78.13.43.43,0,0,0-.31.43q0,.19.3.36a5.54,5.54,0,0,0,.78.33l1,.4a4.74,4.74,0,0,1,1,.56,3,3,0,0,1,.78.81A2.24,2.24,0,0,1,155.89,274.64Z"
            fill="#fff"
          />
          <path
            d="M165.25,272.88a7.67,7.67,0,0,1-1.1.3c-.43.1-.89.18-1.37.26l-1.52.19c-.52.05-1,.09-1.5.11a2.45,2.45,0,0,0,.93.66,3.06,3.06,0,0,0,1.2.24,5.24,5.24,0,0,0,1.09-.13,5.1,5.1,0,0,0,1.16-.39,1.46,1.46,0,0,1,.37-.13.27.27,0,0,1,.22.1,1.05,1.05,0,0,1,.14.3,2.64,2.64,0,0,1,.12.4c0,.13.06.26.08.39a.5.5,0,0,1,0,.19v.17a.82.82,0,0,1-.29.61,3.85,3.85,0,0,1-1.52.84,7.23,7.23,0,0,1-2.21.32,4.55,4.55,0,0,1-1.7-.33,4.37,4.37,0,0,1-1.44-.92,4.72,4.72,0,0,1-1-1.42,4.43,4.43,0,0,1-.37-1.85,4.5,4.5,0,0,1,.38-1.89,4.81,4.81,0,0,1,1-1.49,4.75,4.75,0,0,1,3.27-1.3,4.47,4.47,0,0,1,2.1.45,4.11,4.11,0,0,1,1.37,1.1,4.28,4.28,0,0,1,.74,1.35,3.92,3.92,0,0,1,.22,1.18.87.87,0,0,1-.09.4A.64.64,0,0,1,165.25,272.88Zm-3.92-2.29a2,2,0,0,0-1.17.38,1.9,1.9,0,0,0-.74.95c.54,0,1.11-.06,1.71-.1a11.33,11.33,0,0,0,1.66-.26,1.37,1.37,0,0,0-.63-.74A1.77,1.77,0,0,0,161.33,270.59Z"
            fill="#fff"
          />
        </g>
      </g>
      <Checkmarks
        visited={visited}
        process={process}
        position={{ x: 140, y: 133 }}
        gradientIdChunk="multi-purpose"
      />
    </g>
  );
};

export default MultiPurpose;
